export const czech = {
    NAPOVEDA: 'Nápověda',
    UZIVATEL: 'Uživatel',
    PRIHLASIT_SE: 'Přihlásit se',
    ODHLASIT_SE: 'Odhlásit se',
    ODHLASIT: 'Odhlásit',
    NAZEV: 'Název',
    UPOZORNENI: 'Upozornění',
    ZAVRIT: 'Zavřít',
    VYDAL: 'Vydal',
    VYHLEDAT: 'Vyhledat',
    PREVEST: 'Převést',
    EMITENT: 'Emitent',
    ZDE: 'zde',
    EMITENTA: 'Emitenta',
    VZTAH: 'Vztah',
    VZTAH_TYP: 'Typ vztahu',
    STAV: 'Stav',
    ZOBRAZIT: 'Zobrazit',
    ZNEAKTIVNIT: 'Zneaktivnit',
    ZAPOMENUTE_HESLO: 'Zapomenuté heslo',
    PROFIL_UDAJE_CHYBA: 'Pro aktualizaci kontaktních ůdajů kontaktuje CDCP',
    ZAPOMENUTE_HESLO_INFO:
        'Odkaz pro obnovu hesla obdržíte pouze v případě, že jste uvedli e-mail, který je totožný s e-mailem uvedeným v registračním formuláři.',
    CHYBA: 'Chyba',
    CODE: 'Kód',
    ZADOST_O_AMLZ: 'Žádost o AMLZ',
    IDENTIFIKACE_TEXT: 'Pro ověření Vašeho telefonního čísla Vám bude zaslána SMS s kódem',
    ZASLAT_SMS_KOD: 'Zaslat SMS kód',
    IDENTIFIKACE_OSOBY_LEGALENTITY: 'Dotazník ke kontrole právnické osoby podle AMLZ',
    IDENTIFIKACE_OSOBY_ZADOST_LEGALENTITY_TEXT:
        'U Vaší osoby není vedeno právo pro přístup k právnické osově DLT. Identifikujte se a doložte své oprávnění.',
    IDENTIFIKACE_TYP: 'Typ identifikace',
    IDENTIFIKACE_OSOBY: 'Identifikace osoby',
    IDENTIFIKACE_OSOBY_ZADOST_TEXT:
        'U Vaší osoby není vedeno právo pro agendu AMLZ. Identifikujte se a doložte své oprávnění.',
    IDENTIFIKACE_OSOBY_TEXT: 'Pro přístup k žádosti Vám bude zaslána SMS s kódem.',
    IDENTIFIKACE_OSOBY_KOD: 'Zadejte kód, který jste obdrželi v SMS zprávě',
    ZADOST_O_KOMUNIKACI: 'Identifikace osoby pro komunikaci s CDCP',
    ZADOST_O_LEI: 'Žádost o LEI',
    ZADOST_O_LEI_UPDATE: 'Žádost o aktualizaci LEI',
    PREHLED_LEI: 'Přehled LEI',
    PREHLED_UCTU: 'Přehled účtů',
    ZADOST_O_ISIN_AMLZ: 'Pro odeslání požadavku ISIN je třeba podat žádost AMLZ a počkat na jeho schválení',
    ZADOST_O_ISIN_AMLZ_CDCP:
        'Pokud chcete změnit evidenci na CDCP, je třeba podat žádost AMLZ a počkat na jeho schválení',
    PREJIT_NA_AMLZ: 'Přejít na Amlz',
    POKRACOVAT: 'Pokračovat',
    POKRACOVAT_NA_ZHRNUTI: 'Pokračovat na shrnutí',
    ZPET: 'Zpět',
    PREJIT: 'Přejít',
    ZMENIT: 'Změnit',
    ZAPLATIT: 'Zaplatit',
    ZMENIT_HESLO: 'Změnit heslo',
    ZMENIT_LOGIN: 'Změnit uživatelské jméno (e-mail)',
    ZRUSIT_ZADOST: 'Zrušit žádost',
    ZRUSIT_DOKUMENT: 'Zrušit dokument',
    ZRUSIT_ZADOST_SUCCESS: 'Zrušení žádosti bylo úspěšné',
    ZMENA_EMAIL_SENT: 'Byl Vám odeslán e-mail pro potvrzení změny e-mailu.',
    ZMENA_EMAIL_FAILED: 'Emailová adresa nebyla změněna.',
    ZMENA_UDAJU_SUCESS: 'Údaje byly úspěšně změněny.',
    ZMENA_UDAJU_FAILED: 'Údaje nebyly změněny.',
    ICO: 'Identifikační číslo',
    ZADNE_EMISE: 'Nejsou vedeny žádné žádosti o ISIN.',
    ZADNE_LEI: 'Nejsou vedeny žádné LEI',
    ICO_ZKRATKA: 'IČO',
    DATUM_UVEREJNENI: 'Datum zveřejnění (CET/CEST)',
    DATUM_UVEREJNENI_SHORT: 'Datum zveřejnění',
    DATUM_ZALOZENI: 'Datum založení',
    NEPLATNY_DATUM: 'Neplatný datum',
    VYPLNTE_PLACEHOLDER: 'Vyplňte...',
    VYBERTE_PLACEHOLDER: 'Vyberte...',
    MUJ_DEPOZITAR: 'MŮJ DEPOZITÁŘ',
    MUJ_DEPOZITAR_LOWER: 'Můj depozitář',
    SOUBOR: 'Soubor',
    SOUBOR_NOT_LOADED: 'Soubor nebyl nahrán',
    POZADAVKY: 'Požadavky',
    SOUBOR_NOT_LOADED_OSOBA:
        'Uvedenou osobu nebylo možné automaticky ověřit v OR nebo v ARES. Vložte soubor, který potvrzuje oprávnění této osoby jednat za společnost (výpis z OR, plnou moc apod.)',
    SOUBOR_200: 'Soubor byl úspěšně odeslán',
    UDALOSTI: 'Události',
    UDALOST: 'Událost',
    NEVALIDNI_IDENTIFIKATOR: 'Nevalidní identifikátor',
    NEVALIDNI_XSD_SOUBOR: 'XSD soubor není validni',
    SEZNAM_EMISI_TEXT: 'Seznam zaknihovaných emisí vedených v CDCP',
    VYBRAT_SOUBOR: 'Vybrat soubor',
    PRIHLASENI: 'Přihlášení',
    VSTOUPIT: 'Vstoupit',
    REGISTROVAT_BUTTON_TEXT: 'Ještě nemáte účet?',
    REGISTROVAT_BUTTON: 'Zaregistrujte se',
    UPLOAD_MAX_SIZE: 'Soubor je příliš velký',
    UPLOAD_MAX_SIZE_TEXT: 'Maximální velikost souboru je 20 MB',
    IC_EMITENTA: 'IČ emitenta',
    VYBRANE_EMISE: 'Vybrané emise',
    NAZEV_EMITENTA: 'Název emitenta',
    EMISE_FILTER: 'Filtr emisí',
    EMISE_NAZEV_CELY: 'Celý název emise',
    NAZEV_EMISE: 'Název emise',
    PREJIT_NA_CDCP: 'Přejít na cdcp.cz',
    ZADNE_UDAJE: 'Žádné údaje',
    TABULKA_ZADNE_ZAZNAMY: 'Tabulka neobsahuje žádné záznamy',
    CHYBNY_NID: 'Nevalidní NID',
    CHYBNE_LEI: 'Neplatný LEI',
    CHYBNE_LEI2:
        'Neplatný LEI – pro tento typ žádosti je nutné uvést LEI mateřské společnosti, která je Subjektem Státní Správy (Entity Category = RESIDENT GOVERNMENT ENTITY).',
    PREHLED_UDALOSTI: 'Přehled událostí',
    DUVERNE_INFORMACE: 'Důvěrné informace',
    STAV_ZADOSTI: 'Stav žádosti',
    STAV_POZADAVKU: 'Stav požadavku',
    PREHLED_POZADAVKU: 'Přehled požadavků',
    OVERIT: 'Ověřit',
    SOUBOR_POVINNY: 'Není přiložen žádný soubor',
    AKTIVNI: 'Aktivní',
    SMAZANI_POZADAVKU: 'Smazání požadavků',
    SS_PREHLED_AKTIVNICH_POZADAVKU: 'Přehled aktivních požadavků',
    UCET: 'Účet',
    ID_OSOBY: 'ID osoby',
    ID_NABYVATELE: 'ID osoby',
    IDVCDCP: 'ID v CDCP',
    POCET_CP_PREPSANO: 'Počet CP - úspěšně připsáno',
    POCET_CP: 'Počet CP',
    POCET_CP_MAX: 'Maximální počet CP',
    POCET_CP_PRODEJ: 'Počet CP - úpis',
    POCET_CP_ODKUP: 'Počet CP - odkup',
    POCET_CP_ZAEVIDOVANO: 'Počet CP - úspěšně zaevidováno',
    POCET_CP_NEUHRAZENE: 'Počet neuhrazených CP / účtů',
    KOD_UCASTNIKA: 'Kód účastníka',
    CISLO_ZASTAVNI_SMLOUVY_ROW: 'Číslo zástavní smlouvy/PPN',
    CISLO_ZASTAVNI_SMLOUVY: 'Číslo zástavní smlouvy',
    POZNAMKA: 'Poznámka',
    NOVA_OSOBA: 'Nová osoba',
    ZPUSOB_PORIZENI: 'Způsob pořízení',
    ID_PREVODU_V_CDCP: 'Id převodu v CDCP',
    PODROBNOSTI: 'Podrobnosti',
    SS_MENU_TITLE: 'Emisní operace',
    PRIMARNI_UPIS: 'Primární úpis',
    SS_PREHLED_POZADAVEK_PREVODZPET: 'Zpětný převod zaměstnaneckých akcií',
    SS_PREHLED_POZADAVEK_UPIS: 'Primární úpis',
    SS_PREHLED_POZADAVEK_NAVYSENI: 'Navýšení emise',
    SS_PREHLED_POZADAVEK_SNIZENI: 'Snížení emise',
    SS_PREHLED_POZADAVEK_PREVOD: 'Převod z technického účtu',
    SS_PREHLED_POZADAVEK_SICAV: 'SICAV/OPF',
    SS_PREHLED_POZADAVEK_SICAVNAVYSENI: 'Navýšení SICAV/OPF',
    SS_PREHLED_POZADAVEK_SICAVSNIZENI: 'Snížení SICAV/OPF',
    SS_PREHLED_USPESNYCH_NEUSPESNYCH: 'Počet úspěšných / neúspěšných',
    SS_PREHLED_STAV_LZE_PRIDAVAT: 'Lze přidávat požadavky',
    SS_PREHLED_STAV_NELZE_PRIDAVAT: 'Zaevidováno v CDCP - nelze přidávat požadavky',
    SS_PREHLED_STAV_VYRIZENO: 'Vyřízeno',
    SS_DETAIL_POZADAVEK: 'Požadavek na',
    SS_DETAIL_FILTR_TYP: 'Typ transakce',
    SS_DETAIL_FILTR_NAKUP: 'Navýšení SICAV/OPF',
    SS_DETAIL_FILTR_PRODEJ: 'Snížení SICAV/OPF',
    SS_DETAIL_POCET_UCTU_ZAEVIDOVANO: 'Počet účtů - úspěšně zaevidováno',
    SS_DETAIL_USPESNE_POZADAVKY: 'Úspěšné požadavky',
    SS_DETAIL_NEUSPESNE_POZADAVKY: 'Neúspěšné požadavky',
    SS_DETAIL_VYBRANY: 'Detail vybraného požadavku na',
    SS_DETAIL_VYBRANY_MEZNI_DATUM_ZRUSENI: 'Mezní datum pro zrušení',
    SS_DETAIL_VYBRANY_LZE_ZAEVIDOVAT_OD: 'Lze zaevidovat od',
    SS_DETAIL_VYBRANY_SMAZAT: 'Smazat vybraný',
    SS_DETAIL_VYBRANY_ZMENIT: 'Změnit vybraný',
    SS_DETAIL_STAV_U001: 'Nový',
    SS_DETAIL_STAV_U002: 'Nový se závažnou chybou',
    SS_DETAIL_STAV_U003: 'Nový s informativní chybou',
    SS_DETAIL_STAV_U005: 'Odeslaný do zpracování',
    SS_DETAIL_STAV_U006: 'Probíhá kontrola',
    SS_DETAIL_STAV_U007: 'Ověřeno',
    SS_DETAIL_STAV_U008: 'Probíhá kontrola – účet zatím neověřen',
    SS_DETAIL_STAV_U700_ALT: 'Uhrazeno',
    SS_DETAIL_STAV_U700: 'Čekající na vypořádání',
    SS_DETAIL_STAV_U702: 'Čeká na vypořádání (spárováno)',
    SS_DETAIL_STAV_U701: 'Čekající na vypořádání - účet neověřen',
    SS_DETAIL_STAV_U710: 'Probíhá odeslání',
    SS_DETAIL_STAV_U730: 'Čeká na zaregistrování emise v CDCP',
    SS_DETAIL_STAV_U750: 'Zamítnutý',
    SS_DETAIL_STAV_U770: 'Čeka na uhrazení',
    SS_DETAIL_STAV_U800: 'Označený ke zrušení',
    SS_DETAIL_STAV_U801: 'Odeslaný ke zrušení',
    SS_DETAIL_STAV_U850: 'Zrušený',
    SS_DETAIL_STAV_U900: 'Převod vypořádán',
    SS_DETAIL_STAV_U950: 'Převod nevypořádán',
    SS_SANKCE_TOOLTIP: 'Osoba je evidována v sankčních seznamech nebo je stát osoby rizikový',
    // /UED/{id}/potvrzeni
    POTVRZENI_ERR001: 'ID požadavku v databázi neexistuje',
    POTVRZENI_ERR002: 'Volání služby PATCH /securities/dvps skončilo chybou',
    POTVRZENI_ERR003: 'Počet uhrazených CP v ISB neodpovídá počtu uhrazených CP v DLT',
    POTVRZENI_ERR004: 'Částka uhrazených CP v ISB neodpovídá částce uhrazených CP v DLT',
    POTVRZENI_ERR005: 'Volání služby ev010 / 85010 změna počtu CP v emisi skončilo chybou',
    POTVRZENI_ERR006: 'Zpracování sql příkazu skončilo chybou',
    // /UED/{id}/vymazani
    VYMAZANI_ERR001: 'ID požadavku v databázi neexistuje',
    VYMAZANI_ERR002: 'Volání služby DLT skončilo chybou',
    VYMAZANI_ERR003: 'Zpracování sql příkazu skončilo chybou',
    // /UED/{id}/zalozeni
    ZALOZENI_PREKROCENO: 'Počet zadaných CP k převodu je vyšší než počet, který je možné upsat.',
    ZALOZENI_ERR001: 'Překročen počet',
    ZALOZENI_ERR002: 'Duplicitní účet',
    ZALOZENI_ERR003: 'Úcet nenalezen',
    ZALOZENI_ERR004: 'Osoba nenalezena',
    ZALOZENI_ERR005: 'Nepodařilo se ověřit číslo zástavní smlouvy',
    ZALOZENI_ERR006: 'Číslo zástavní smlouvy neexistuje',
    ZALOZENI_ERR007: 'Položku požadavku DLT lze měnit pouze ve stavech U001, U002, U007',
    ZALOZENI_ERR008: 'Účet blokován',
    ZALOZENI_ERR009: 'Počet CP musí být > 0.',
    ZALOZENI_ERR010:
        'Pro položku požadavku nelze zadat technický účet. Zadání technického účtu je nutné nejprve pro daný ISIN povolit.',
    ZALOZENI_ERR011: 'Převod na technický účet lze zadat pouze pro cenné papíry typu akcie.',
    ZALOZENI_ERR012: 'Pro úpis z technického účtu nelze zadat položku požadavku s číslem zástavní smlouvy.',
    // /UED/{id}/zruseni
    ZRUSENI_ERR001: 'ID požadavku v databázi neexistuje',
    ZRUSENI_ERR002: 'Volání služby POST /securities/dvps/cancel skončilo chybou',
    ZRUSENI_ERR003: 'Počet úspěšně zrušených položek požadavků v ISB neodpovídá počtu položek zrušených v DLT',
    ZRUSENI_ERR004: 'Počet uhrazených CP v ISB neodpovídá počtu uhrazených CP v DLT',
    ZRUSENI_ERR005: 'Částka uhrazených CP v ISB neodpovídá částce uhrazených CP v DLT',
    ZRUSENI_ERR006: 'Zpracování sql příkazu skončilo chybou',
    SS_DETAIL_TAB_PORIZENI_R: 'Pořízeno ručně',
    SS_DETAIL_TAB_PORIZENI_D: 'Pořízeno souborem',
    SS_DETAIL_TAB_PORIZENI_CDCP: 'CDCP',
    SS_DATUM_UPIS: 'úpisu',
    SS_DATUM_NAVYSENI: 'navýšení/snížení emise',
    SS_DATUM_PREVODZPET: 'převodu',
    SS_DATUM_PREVOD: 'převodu',
    SS_DATUM_SICAV: 'navýšení/snížení SICAV/OPF',
    SS_DATUM_SNIZENI: 'snížení emise',
    SS_DATUM_SICAVNAVYSENI: 'navýšení SICAV/OPF',
    SS_DATUM_SICAVSNIZENI: 'snížení SICAV/OPF',
    SS_PREHLED_POCET_UCTU: 'Počet účtů',
    SS_PREHLED_OVERENE: 'ověřené',
    SS_NOVY_UPIS: 'Primární úpis emise',
    SS_NOVY_UPIS_SICAV: 'Primární úpis SICAV/OPF',
    SS_NOVY_PREVOD_Z_TECH_UCTU: 'Převod z technického účtu',
    SS_NOVE_NAVYSENI: 'Navýšení/snížení emise',
    SS_NOVE_SICAV: 'Navýšení/snížení SICAV/OPF',
    SS_HISTORICKE_POZADAVKY: 'Historie',
    SS_PRIDAT_POZADAVEK: 'Přidat požadavek',
    SS_PRIDAT_ZE_SOUBORU: 'Přidat ze souboru',
    SS_OVERENI_UCTU: 'Ověření účtu',
    SS_ZAEVIDOVAT_V_CDCP: 'Zaevidovat v CDCP',
    ZAEVIDOVAT: 'Zaevidovat',
    SS_POZADAVEK_NA: 'Požadavek na ',
    SS_NOVY_POZADAVEK_NA: 'Nový požadavek na ',
    SS_NOVY_POZADAVEK_NA_UPIS: 'Primární úpis emise',
    SS_NOVY_POZADAVEK_NA_UPIS_SICAV: 'Primární úpis emise',
    SS_NOVY_POZADAVEK_NA_PREVOD: 'Převod',
    SS_NOVY_POZADAVEK_NA_NAVYSENI: 'Navýšení emise',
    SS_NOVY_POZADAVEK_NA_PREVODZPET: 'Zpětný převod zaměstnaneckých akcií',
    SS_NOVY_POZADAVEK_NA_NAVYSENISNIZENI: 'Navýšení/snížení emise',
    SS_NOVY_POZADAVEK_NA_SICAVNAVYSENI: 'Navýšení SICAV/OPF',
    SS_NOVY_POZADAVEK_NA_SICAVSNIZENI: 'Snížení SICAV/OPF',
    SS_NOVY_POZADAVEK_NA_SICAV: 'Navýšení/snížení SICAV/OPF',
    SS_NOVY_POZADAVEK_NA_SNIZENI: 'Snížení',
    SS_NOVY_POZADAVEK_S_CHYBOU: 's chybou',
    SS_NOVY_RUCNI_UVEDTE: 'Vyplňte pouze, pokud se jedná o účet v navazující evidenci (typ účtu 31).',
    SS_NOVY_RUCNI_ID_C_VLASTNIKA: 'ID osoby v navazující evidenci',
    SS_NOVY_RUCNI_PRIJMENI: 'Příjmení/Obchodní firma',
    SS_NOVY_RUCNI_JMENO: 'Jméno',
    SS_NOVY_RUCNI_MODAL_ZAPIS: 'Zápis požadavku',
    SS_NOVY_RUCNI_MODAL_RESP_VLASTNIK: 'Vyplňte údaje o vlastníkovi',
    SS_NOVY_RUCNI_MODAL_RESP_UCET: 'Zadaný účet neexistuje',
    SS_NOVY_RUCNI_MODAL_RESP_SANKCE:
        'Osoba uvedená v požadavku pro úpis byla nalezena v sankčních seznamech nebo stát osoby je označen jako rizikový. Požadavek nebude možné odeslat k zaevidování v CDCP. Pro další postup nás kontaktujte na mujdepozitar@pse.cz.',
    SS_NOVY_RUCNI_MODAL_RESP_PREKROCENO: 'Počet zadaných CP k převodu je vyšší než počet, který je možné upsat.',
    SS_NOVY_RUCNI_MODAL_RESP_PREKROCENO_PPN:
        'Počet zadaných cenných papírů k zrušení PPN na zaměstnaneckých akciích převyšuje počet cenných papírů s PPN.',
    SS_NOVY_RUCNI_MODAL_RESP_CASTKA: 'Celková částka za všechny úpisy překročila cílovou částku',
    SS_NOVY_RUCNI_MODAL_RESP_DUPLICITA: 'Pro zadaný účet již existuje požadavek.',
    SS_NOVY_RUCNI_MODAL_RESP_CHYBNEICO: 'Pro zadaný účet a kód účastníka je chybně uvedeno ID nabyvatele.',
    SS_NOVY_RUCNI_MODAL_RESP_ODMITNUTO: 'Pro zadanou kombinaci údajů nebyl nalezen žádný účet.',
    SS_NOVY_RUCNI_MODAL_RESP_BEZPPN: 'Není vedeno PPN na účtu',
    SS_NOVY_RUCNI_VALIDACE_UCET: 'Položka vyžaduje 12 číslic a musí začínat 808, 909 nebo 100',
    SS_NOVY_RUCNI_VALIDACE_IDNABYVATELE_CISLA: 'Musí být v rozsahu 8 až 10 číslic',
    SS_NOVY_RUCNI_VALIDACE_CP: 'Počet CP musí být větší než 0',
    SS_NOVY_RUCNI_VALIDACE_ZASTAVNI: 'Položka vyžaduje 12 číslic a musí začínat 6',
    SS_NOVY_SOUBOR_OBSAH_DAVKY: 'Obsah vstupní dávky',
    SS_NOVY_SOUBOR_NAZEV_DAVKY: 'Název dávky',
    SS_NOVY_SOUBOR_NAZEV_SOUBORU: 'Název vstupního souboru',
    SS_NOVY_SOUBOR_POCET_CHYBNYCH: 'Počet chybných požadavků',
    SS_NOVY_SOUBOR_POCET_BEZCHYBNYCH: 'Počet bezchybných požadavků',
    SS_NOVY_SOUBOR_SEZNAM_NADPIS_OVERENI: 'Seznam požadavků pro ověření účtu',
    SS_NOVY_SOUBOR_SEZNAM_NADPIS_SMAZANI: 'Seznam požadavků ke smazání',
    SS_NOVY_SOUBOR_SEZNAM_NA: 'Seznam požadavků na',
    SS_NOVY_SOUBOR_SEZNAM_BEZ_CHYBY: 'Seznam bezchybných požadavků na',
    SS_NOVY_SOUBOR_ZAPSAT_BEZCHYBNE: 'Zapsat bezchybné požadavky',
    SS_NOVY_SOUBOR_CHYBNE: 'Chybné požadavky',
    SS_NOVY_SOUBOR_SMAZAT_DAVKU: 'Smazat celou dávku',
    SS_NOVY_SOUBOR_EXPORTOVAT_CHYBNE: 'Exportovat chybné',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_HEAD: 'Potvrzení – Zápis bezchybných požadavků',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_TEXT: 'Chybné požadavky budou zrušeny. Přejete si pokračovat?',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_TEXT_2: 'Přejete si zapsat vybrané bezchybné požadavky?',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_RESP: 'Bezchybné požadavky dávky byly úspěšně zapsány.',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_RESP2:
        'Pokyn k vytvoření převodu provedete prostřednictvím volby bold(Zaevidovat v CDCP).',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_HEAD: 'Smazání celé dávky',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_TEXT: 'Skutečně chcete smazat celou dávku?',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_RESP: 'Požadavky byly úspěšně smazány.',
    SS_VYBER_ISIN_FILTR_EMISI: 'Filtr emisí',
    SS_VYBER_ISIN_NAZEV_EMISE: 'Celý název emise',
    SS_SEZNAM_MODAL_USPESNE: 'Vybrané účty byly úspěšně',
    SS_SEZNAM_MODAL_USPESNE_POZADAVKY: 'Vybrané požadavky byly úspěšně',
    SS_SEZNAM_MODAL_USPESNE_OVERENY: 'odeslány k ověření',
    SS_SEZNAM_MODAL_USPESNE_SMAZANY: 'smazány',
    SS_SEZNAM_MODAL_USPESNE_ZAEVIDOVANY: 'odeslány ke zpracování',
    SS_SEZNAM_ZAEVIDOVAT_LZE: 'Seznam požadavků, které lze zaevidovat',
    SS_SEZNAM_ZAEVIDOVAT_NELZE: 'Seznam požadavků, které nelze zaevidovat',
    SS_SEZNAM_MODAL_ZAEVIDOVAT_TEXT:
        'Upozorňujeme, že tímto krokem nebyl požadavek proveden a je nutné zkontrolovat, zda byly Vámi zadané pokyny k převodu přijaty Centrálním depozitářem k vypořádání k Vámi stanoveném datu. Tento výsledek stavu požadavku zjistíte v detailu každého požadavku v sekci "Přehled aktivních požadavků".',
    SS_ERR_ISIN_PRAVO: 'Nemáte právo na tento ISIN',
    SS_SLUZBA_ERROR_NESKORO: 'Už je uzavřen obchodní den',
    SS_DVP_ZAEVIDOOVAT_ERR1:
        'Celková částka {{castka}} neodpovídá částce {{cielcastka}} {{mena}}, která byla předána CDCP.',
    SS_DVP_ZAEVIDOOVAT_ERR2: 'Počet cenných papírů {{pocetcp}} neodpovídá počtu cenných papírů v emisi {{pocetcp2}}.',
    SS_DVP_ZAEVIDOOVAT_ERR3: 'Je nutné podat Příkaz emitenta k vydání zaknihovaných cenných papírů na účty nabyvatelů',
    SS_PREVODZPET_404: 'Všechny zablokované papíry budou staženy k Vámi zvolenému datu. Poté zde budou zobrazeny.',
    POCET_UCTU_OVERENE_2: 'Počet účtů - ověřené',
    PREDPOKLADANE_DATUM: 'Předpokládané datum',
    VYBRAT_ISIN: 'Vybrat ISIN',
    VSECHNY: 'Všechny',
    POCET_USPESNYCH: 'Počet úspěšných',
    POCET_NEUSPESNYCH: 'Počet neúspěšných',
    ZMENA_HESLA: 'Změna hesla',
    ZMENA_EMAILU: 'Změna uživatelského jména',
    LOGIN_INVALID: 'Neplatné uživatelské jméno či heslo',
    LOGIN_LEI_INVALID:
        'Neplatné uživatelské jméno či heslo. Upozorňujeme, že od 1. 4. 2022 došlo ke změně způsobu v přihlašování uživatelů ke službám LEI. Online služby jsou bold(nově) dostupné pouze registrovaným uživatelům portálu Můj depozitář',
    PROFIL: 'Profil',
    DUVOD: 'Popis',
    STAHNOUT: 'Stáhnout',
    ZRUSIT: 'Zrušit',
    NACITANI_DAT: 'Probíhá načítání dat z rejstříku, prosíme o strpení',
    NACITANI: 'Načítání...',
    KOMERCNI_CERTIFIKAT: 'Komerční certifikát',
    CERTIFIKAT: 'Certifikát',
    UZIVATELSKE_JMENO: 'Uživatelské jméno',
    UZIVATELSKE_JMENO_NOVE: 'Nové uživatelské jméno (e-mail)',
    ODESLAT: 'Odeslat',
    HESLO: 'Heslo',
    HESLO_OVERENI: 'Heslo ověření',
    SUBJEKT: 'Subjekt',
    DATUM: 'Datum',
    DATUM_CET: 'Datum (CET/CEST)',
    EMISE: 'Emise',
    HLASOVANI: 'Hlasování',
    UPRAVIT_HLASOVANI: 'Upravit hlasování',
    UPRAVIT_UDAJE: 'Upravit údaje',
    PRACOVNI_POZICE: 'Pracovní pozice',
    JAKA_OSOBA: 'Žadatel je oprávněn žádat jménem právnické osoby na základě:',
    JMENO: 'Jméno',
    PRIJMENI: 'Příjmení',
    JMENO_PRIJMENI: 'Jméno a příjmení',
    KONTAKTNI_UDAJE: 'Kontaktní údaje',
    KONTAKTNI_UDAJE_INFO: 'Kontaktní email je primární kontakt, na který budou zasílány informace.',
    EMAIL: 'E-mail',
    EMAIL2: 'E-mail 2',
    EMAIL_FAKTURACANI: 'Fakturační e-mail',
    EMAIL_OVERENI: 'E-mail ověření',
    TELEFON: 'Telefon',
    PODANO: 'Podáno',
    ISB_ID: 'Id v ISB',
    SLUZBA: 'Služba',
    NAZEV_CELY: 'Celý název',
    PODAL: 'Podal',
    ZOBRAZENO: 'Zobrazeno',
    CEKAJICI: 'Čekající',
    NEDORUCEN: 'Nedoručen',
    DORUCEN: 'Doručen',
    ZODPSCHYBOU: 'Zodpovězen s chybou',
    ZODPOVEZEN: 'Zodpovězen',
    PRIPRAVEN: 'Opakovaně poslat',
    POZRUCNE: 'Požadavek řešen ručně',
    CEKANAZPRAC: 'Čeká na zpracování',
    ZRUSEN: 'Zrušen',
    HESLO_ZMENA_401: 'Vypršela platnost zaslaného odkazu. Zašlete novou žádost o změnu hesla.',
    HESLO_NOVE_NADPIS: 'Nové heslo pro Můj depozitář',
    HESLO_ZMENA_TEST_ALT: 'Prosíme, zadejte své nové heslo pro přístup do portálu Můj depozitář.',
    HESLO_ZMENA_TEXT: 'Prosíme, zadejte své púvodní a nové heslo pro přístup do portálu Můj depozitář.',
    LOGIN_ZMENA_TEXT:
        'Prosíme, zadejte své heslo pro přístup do portálu Můj depozitář. Změna začne platit až po potvrzení linku, který Vám byl zaslán na nový e-mail.',
    LOGIN_ZMENA_MAIL: 'Změna začne platit až po potvrzení linku, který Vám byl zaslán na nový e-mail.',
    LOGIN_ZMENA_MAIL_DUPL: 'Uživatel již existuje, nelze použit',
    HESLO_PUVODNI: 'Původní heslo',
    HESLO_NESPRAVNE: 'Zadané heslo není správné',
    HESLO_PUVODNI_CHYBA: 'Původní heslo nesouhlasí',
    ZADAT_HESLO_PUVODNI: 'Zadejte Původní heslo',
    LOGIN_WRONG: 'Rozdílné údaje u uživatele. Nelze se přihlásit ',
    ZADAT_HESLO: 'Zadejte heslo',
    HESLO_NOVE: 'Nové heslo',
    ZADAT_HESLO_NOVE: 'Zadejte nové heslo',
    HESLO_NOVE_OVERENI: 'Nové heslo ověření',
    LOGOUT_TITLE: 'Odhlášení z oblasti Můj depozitář proběhlo úspěšně',
    LOGOUT_TEXT:
        'Pro opětovné přihlášení do Můj depozitář klikněte na tlačítko "Přihlásit se" Pokud chcete přejít na stránky Centrálního depozitáře, klikněte na tlačítko "Přejít na cdcp.cz".',
    ODEBRAT: 'Odebrat',
    VYBRAT: 'Vybrat',
    DOPLNIT: 'Doplnit',
    ZAPSAT: 'Zapsat',
    VYBERTE: 'Vyberte',
    STAT_SIDLA: 'Stát sídla',
    STAT_SIDLA_REGION: 'Stát sídla - Region',
    REGION: 'Region',
    STAT: 'Stát',
    PRID: 'Přidělení',
    ZMEN: 'Změna',
    ZRUS: 'Zrušení',
    ZAKLADNI_UDAJE_O_EMITENTOVI: 'Základní údaje o emitentovi',
    ZAKLADNI_UDAJE_O_PRAVNICKE_OSOBE: 'Dotazník ke kontrole právnické osoby podle AMLZ',
    ZAKLADNI_UDAJE: 'Základní údaje',
    UDAJE_O_EMITENTOVI: 'Údaje o emitentovi',
    IDENTIFIKACNI_CISLO: 'Identifikační číslo (IČ)',
    IDNID_OSOBY: 'ID / NID osoby',
    ISIN: 'ISIN',
    ULICE_CP: 'Ulice a č. p.',
    ULICE: 'Ulice',
    MESTO: 'Město',
    PSC: 'PSČ',
    PSC_ERROR: 'Nevalidní PSČ',
    DOPLNUJICI_INFORMACE: 'Doplňující informace',
    ANO: 'Ano',
    NE: 'Ne',
    BUTTON_UPRAVIT: 'Upravit',
    BUTTON_DEAKTIVOVAT: 'Deaktivovat',
    BUTTON_AKTIVURAV: 'Aktivovat a upravit',
    LEI_CELE: 'Legal Entity Identifier (LEI)',
    LEI: 'Lei',
    LEI_VELKE: 'LEI',
    IBAN: 'Bankovní spojení (IBAN)',
    PODPIS: 'Podpis',
    ZEME: 'Země',
    VLASTNORUCNI_PODPIS: 'Vlastnoruční podpis',
    ELEKTRONICKY_PODPIS: 'Elektronický podpis',
    ELEKTRONICKE_SLUZBY: 'Elektronické služby',
    NOVA_ZADOST: 'Nová žádost',
    DVA_DOKLADY_TOTOZNOSTI: 'Kopie dvou dokladů totožnosti',
    ZEME_SIDLA_VLASTNIKA_EMITENTA: 'Země sídla hlavního vlastníka emitenta',
    SK_NACE: 'SK NACE',
    CZ_NACE: 'CZ NACE',
    PRIDAT_OSOBU: 'Přidat osobu',
    FYZICKA_OSOBA: 'Fyzická osoba',
    PRAVNICKA_OSOBA: 'Právnická osoba',
    NELZE_UVEST: 'Nelze uvést',
    TYP_ZADOSTI: 'Typ změny',
    OSOBA: 'Osoba',
    UDAJE_OSOBY: 'Údaje osoby',
    UDAJE_SPOLECNOSTI: 'Údaje společnosti',
    FUNKCE: 'Funkce',
    POPIS: 'Popis',
    ULOZIT: 'Uložit',
    POPIS_EN: 'Popis - en',
    ZADOST_ODESLANA: 'Žádost byla úspěšně odeslána',
    ZADOST_ODESLANA_LEI_AKTUALIZACE: 'Žádost o aktualizaci LEI byla odeslána',
    ZADOST_ODESLANA_LEI: 'Žádost o LEI byla odeslána',
    NACIST_DALSI_ZAZNAMY: 'Načíst další záznamy',
    AKTUALIZOVAT: 'Aktualizovat',
    HLASOVAT: 'Hlasovat',
    UCASTNIK: 'Účastník',
    VYJADRENI_CDCP: 'Vyjádření CDCP',
    POTVRDIT: 'Potvrdit',
    MUJ_CERTIFIKAT: 'Můj certifikát',
    VSE: 'Vše',
    PDF: 'PDF',
    URL: 'URL',
    BIC: 'BIC',
    MAJITEL: 'Majitel',
    UDAJE_PLATI: 'Údaje platí',
    CISLO_UCTU: 'Číslo účtu',
    KONTAKT_MAJITEL_UCTU: 'Kontaktní údaje majitele účtu:',
    SPRAVA_MEJTOK_UCTU: 'Kontaktní údaje majitele účtu:',
    MENA: 'Měna',
    VYSTUP_CSV: 'Výstup do CSV',
    ZOBRAZIT_DETAIL: 'Zobrazit',
    NEURCENO: 'Neurčeno',
    DORUCENO: 'Doručeno',
    ODESLANO: 'Odesláno',
    HOTOVO: 'Hotovo',
    TYP: 'Typ',
    TYP_ZADOSTI_TITLE: 'Typ žádosti',
    ZPRAVY: 'Zprávy',
    DETAIL: 'Detail',
    PRIDAT: 'Přidat',
    ODSTRANIT: 'Odstranit',
    PREHLED: 'Přehled',
    FORMULARE_OSOBY: 'Osoby ve vrcholném vedení',
    UCET_NOVY: 'Nový účet',
    UCET_NOVY_SELECT: 'Účelem založení účtu je zastupování:',
    UCET_NOVY_SELECT_LEI: 'Žadatele o LEI / Držitele LEI',
    PREHLED_ZPRAV: 'Přehled zpráv',
    PREHLED_ZMEN_UDALOSTI: 'Přehled změn a korporátních událostí',
    MAIN_PAGE_FILTER_PLACEHOLDER: 'Název firmy, IČO, …',
    UCET_NOVY_ERR: 'Zadané IČO je registrováno pod jiným účtem',
    NOVA_REGISTRACE_DEPOZITAR: 'Nová registrace v Můj depozitář',
    OPISTE_SMS: 'Opište SMS kód ze zprávy',
    SMS_KOD: 'SMS kód',
    MUJ_PROFIL: 'Můj profil',
    MUJ_PROFIL_MODAL_ZPET: 'Zpět',
    REGISTRACE_NADPIS: 'Informace o registrované osobě',
    KONTAKTNI_UDAJE_EMAIL_INFO:
        'Kontaktní email je primární kontakt, na který budou zasílány informace. E-mail bude sloužit k přihlášení do portálu Můj depozitář.',
    KONTAKTNI_UDAJE_HESLO_INFO: 'Heslo slouží pro přihlášení se do portálu Můj depozitář',
    OPISTE_TEXT_Z_OBRAZKU: 'Opište text z obrázku',
    REGISTROVAT: 'Registrovat',
    STAHNOUT_PDF: 'Stáhnout PDF',
    SLUZBA_NEDOSTUPNA: 'Služba je nedostupná. Opakuje akci prosím později.',
    SEZNAM_UDALOSTI: 'Seznam udalostí',
    ZADOSTI_ISIN: 'Podané žádosti ISIN',
    SPRAVCE_MAJETKOVEHO_UCTU: 'Správce majetkového účtu',
    SPRAVCE_UCTU: 'Správce účtu',
    PREHLED_ZAKAZNIK: 'Uživatelé',
    PREHLED_EMITENT: 'Emitent',
    SMAZAT: 'Smazat',
    ZADNA_DATA: 'Žádná data k zobrazení',
    EMISE_CP: 'Emise CP',
    ZAKNIHOVANE_CP: 'Zaknihované CP',
    LISTINE_CP: 'Listinné CP',
    SPRAVA_UCTU: 'Správa účtu',
    ID_UCTU: 'ID uživatele',
    EVIDENCNI_UDAJE: 'Evidenční údaje',
    UZIVATELE: 'Uživatelé',
    PRIDELENE_ISIN: 'Přidělené ISIN',
    AUTENTIZACE: 'Autentizace',
    STAV_ZPRACOVANI: 'Stav zpracování',

    RESPONSE_ERROR_400:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_401: 'Vypršela platnost stránky.',
    RESPONSE_ERROR_404: 'Zadaným výběrovým kritériím nevyhovují žádná data.',
    RESPONSE_ERROR_409: 'Vaše změna záznamu neproběhla. Záznam byl změněn jiným uživatelem.',
    RESPONSE_ERROR_410: 'Zákazník již na žádosti pracuje.',
    RESPONSE_ERROR_408:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_403:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_500:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_503: 'Server je nedostupný. Opakujte akci znova.',

    NEVALIDNI_UCET: 'Nevalidní číslo účtu',
    NEVALIDNI_ISIN: 'Nevalidní kód ISIN',
    NEVALIDNI_LEI: 'Nevalidní kód LEI',
    NEVALIDNI_DIC: 'Nevalidní DIČ',
    NEVALIDNI_IBAN: 'Nevalidní IBAN',
    NEVALIDNI_NACE: 'Neexistující kód NACE',
    NEVALIDNI_RC: 'Nevalidní rodné číslo',
    NEVALIDNI_ICO: 'Nevalidní IČO',
    NEVALIDNI_POVINNA_POLOZKA: 'Hodnota musí být vyplněna',
    NEVALIDNI_POVINNA_POLOZKA_UPLOAD: 'Vložte soubor',
    NEVALIDNI_EMAIL: 'Nevalidní e-mail',
    NEVALIDNI_EMAIL_TWO: 'Vyplňte pouze 1 e-mailovou adresu',
    NEVALIDNI_EMAIL_SHODA: 'Zadané e-mailové adresy se neshodují',
    NEVALIDNI_HESLO:
        'Hodnota nesmí být kratší než 8 a delší než 128 znaků (musí obsahovat velké a malé písmeno a číslici)',
    NEVALIDNI_HESLO_SHODA: 'Zadaná hesla se neshodují',
    NEVALIDNI_TELEFON: "Nesprávný telefon - zadejte 9-17 znaků bez mezer, na začátku buď '+' nebo '00'",
    NEVALIDNI_PROCENTA_100:
        'Položka smí obsahovat pouze čísla (s max. 2 desetinnými místy) větší nebo rovná 10 a menší nebo rovná 100',
    NEVALIDNI_PROCENTA_100_0: 'Položka smí obsahovat pouze čísla (s max. 2 desetinnými místy) menší nebo rovná 100',
    NEVALIDNI_PROCENTA_100_06: 'Položka smí obsahovat pouze čísla (s max. 6 desetinnými místy) menší nebo rovná 100',
    NEVALIDNI_PROCENTA_100_06_0: 'Hodnota musí být větší než 0',
    NEVALIDNI_PROCENTA_CELKEM: 'Maximální součet podílů nemůže být větší než 100%',
    NEVALIDNI_CISLO_DESETINNE_2: 'Položka smí obsahovat pouze čísla (s max. 2 desetinnými místy)',
    NEVALIDNI_NUM_LAT: 'Položka smí obsahovat pouze číslice a písmena',
    NEVALIDNI_NUM: 'Položka smí obsahovat pouze číslice',
    VALIDACE_GLOBAL_INPUT: 'Položka smí obsahovat pouze číslice, písmena, speciální znaky a mezeru',
    NEVALIDNI_POCET_ZNAKU: 'Překročen maximální počet znaků',
    NEVALIDNI_NENI_FO: 'Subjekt není fyzickou osobou',
    NEVALIDNI_DATUM_MENSI: 'Zadané datum je menší než povolená hodnota',
    NEVALIDNI_DATUM_MIMO_INTERVAL: 'Zadané datum je mimo povolený interval',
    NEVALIDNI_URL: 'Nevalidní URL',
    NEVALIDNI_HODNOTA: 'Nevalidní hodnota',
    NEVALIDNI_RC_ICO: 'Nevalidní rodné číslo či ičo',
    NEVALIDNI_LEI_VS: 'Nevalidní LEI či variabilní symbol',

    CHYBA_ULOZENI_DAT: 'Nepodařilo se uložit data',
    ULOZENI_DAT_200: 'Uložení dat probehlo úspěšně',
    ULOZENI_DAT: 'Uložení dat formuláře',
    CHYBA_NEPLATNY_ODKAZ: 'Neplatný odkaz',
    CHYBA_UCET_JIZ_AKTIVOVAN: 'Účet byl již aktivován',
    CHYBA_SMS: 'Chybný SMS kód',
    CHYBA_REGISTRACE_401: 'Chybně opsaný text z obrázku. Prosím, opište text znovu.',
    CHYBA_REGISTRACE_404: 'Zadaný e-mail je již použit.',

    CHYBA_AMLZ_NEVEDENO: 'Není vedeno žádné AMLZ',
    CHYBA_SOUBOR_NEVALIDNI: 'Nevalidní vstupní soubor',
    CHYBA_SOUBOR_DUPLICITNI: 'Duplicitní vstupní soubor',

    LOGIN_ROLE_ADMINISTRATOR_EMISE: 'Administrátor emise',
    ROZPRACOVANE_ZADOSTI: 'Rozpracované žádosti',
    ZPRACOVANE_ZADOSTI: 'Zpracované žádosti',
    RODNE_CISLO_DATUM_NAR: 'Rodné číslo / Datum narození',
    LOGIN_OBNOVENI_HESLA_TEXT: 'Prosíme, zadejte Váš e-mail pro komunikaci s CDCP.',
    TIMER_LOGOUT: 'Budete odhlášeni za {{x}} sekund.',
    CHYBA_RESTORE_TOKEN: 'Chyba obnovy tokenu',
    FORMULARE_JMENA: 'Všechna jména',
    FORMULARE_PRIJMENI: 'Všechna příjmení',
    FORMULARE_RODNE_CISLO: 'Rodné číslo',
    FORMULARE_RODNE_CISLO_MALE: 'rodné číslo',
    FORMULARE_DATUM_NAROZENI: 'Datum narození',
    FORMULARE_DATUM_NAROZENI_MALE: 'datum narození',
    FORMULARE_STAT_NAROZENI: 'Stát narození',
    FORMULARE_MISTO_NAROZENI: 'Místo narození',
    FORMULARE_ZEME_PUVODU: 'Země původu',
    FORMULARE_ZEME_PUVODU_MALE: 'země původu',
    FORMULARE_SKUTECNI_MAJITELE: 'Skuteční majitelé',
    FORMULARE_IC: 'IČO',
    FORMULARE_PLNAMOC: 'Plná moc',
    FORMULARE_ZEME_SIDLA: 'Země sídla',
    FORMULARE_PODIL: 'Podíl',
    FORMULARE_RODNE_CISLO_CR: 'Rodné číslo přidělené v ČR',
    FORMULARE_ADRESA: 'Adresa',
    FORMULARE_ADRESA_POBYTU: 'Adresa trvalého pobytu',
    FORMULARE_STATNI_OBCANSTVI: 'Státní občanství',
    FORMULARE_DRUH_DOKLADU: 'Druh dokladu',
    FORMULARE_DRUH_DOKLADU_JINY: 'Jiný druh dokladu',
    FORMULARE_CISLO_DOKLADU: 'Číslo dokladu',
    FORMULARE_DATUM_PLATNOSTI: 'Datum platnosti do',
    FORMULARE_ZASTUPUJICI_OSOBA_LEGALENTITY: 'Osoba zastupující právnickou osobu je',
    FORMULARE_ZASTUPUJICI_OSOBA: 'Osoba zastupující emitenta je',
    FORMULARE_IDENTIFIKACE_OSOBA: 'Způsob identifikace osoby',
    FORMULARE_STAHNOUT_KPODPISU: 'Stáhnout formulář k podpisu',
    FORMULARE_BISIGN_PODPIS: 'Podepsat pomocí BankSign',
    FORMULARE_PLNA_MOC: 'Vložte úředně ověřenou plnou moc s elektronickou konverzí',
    FORMULARE_PLNA_MOC_DISABLED: 'úředně ověřená plná moc s elektronickou konverzí',
    FORMULARE_JINE_OPRAVNENI: 'Vložte jiné oprávnění',
    FORMULARE_JINE_OPRAVNENI_DISABLED: 'Jiné oprávnění',
    FORMULARE_PODEPSANY_SOUBOR: 'Vložte podepsaný soubor',
    FORMULARE_PODEPSANY_SOUBOR_DISABLED: 'Podepsaný soubor',
    FORMULARE_DOKLADY_TOTOZNOSTI: 'Vložte dva doklady totožnosti',
    FORMULARE_DOKLADY_TOTOZNOSTI_DISABLED: 'Dva doklady totožnosti',
    FORMULARE_ZASTUPUJUCE_OSOBY_PRIDAT_TEXT: 'Uživatelé, co nemají právo jednat za emitenta',
    FORMULARE_ZASTUPUJUCE_OSOBY_TEXT_LEGALENTITY:
        'Vyplňte údaje o všech fyzických osobách, které jsou oprávněny zastupovat právnickou osobu samostatně při jednáních s CDCP ve vztahu k majetkovému účtu DLT (na základě zastoupení ze zákona nebo na základě plné moci)',
    FORMULARE_ZASTUPUJUCE_OSOBY_TEXT:
        'Vyplňte údaje o všech fyzických osobách, o kterých předpokládate, že budou za emitenta jednat s CDCP (ať již společně nebo samostatně, na základě zastoupení ze zákona nebo ze smlouvy)',
    FORMULARE_AMLZ_C1_TITLE_LEGALENTITY: 'C1 - Základní údaje o právnické osobě',
    FORMULARE_AMLZ_C1_TITLE: 'C1 - Základní údaje o emitentovi',
    FORMULARE_AMLZ_C2_TITLE_LEGALENTITY: 'C2 – Údaje o všech fyzických osobách zastupujících právnickou osobu',
    FORMULARE_AMLZ_C2_TITLE: 'C2 - Údaje o všech fyzických osobách zastupujících emitenta',
    FORMULARE_AMLZ_C2_VALIDATION1: 'Je potřeba nahrát způsob identifikace těmto osobám',
    FORMULARE_AMLZ_C2_VALIDATION2: 'Je potřeba opravit datum platnosti těmto osobám',
    FORMULARE_AMLZ_C3A_TITLE_LEGALENTITY:
        'C3A – Údaje o vlastnické a řídící struktuře právnické osoby – PŘÍMÉ vlastnictví',
    FORMULARE_AMLZ_C3A_TITLE: 'C3A - Údaje o vlastnické a řídící struktuře emitenta - PŘÍMÉ vlastnictví',
    MATERSKA_SPOLECNOST: 'Mateřská společnost',
    MATERSKA_SPOLECNOST_FINAL: 'Finální mateřská společnost',
    FORMULARE_AMLZ_C3A_TOOLTIP_LEGALENTITY:
        'Podílníky se rozumí fyzické a právnické osoby, které drží podíl na společnosti. Primárně vyplní právnická osoba všechny podílníky, kteří vlastní více než 10% právnické osoby, tj. zejména společníky u s.r.o. a akcionáře u a.s. Pokud podílník, právnická osoba dosáhne 10% společně s jinou (sesterskou) právnickou osobou, která je ovládána stejnou osobou (mateřskou společností nebo fyzickou osobou), uvede se tato mateřská společnost nebo fyzická osoba jako nepřímý podílník v části C3B.',
    FORMULARE_AMLZ_C3A_TOOLTIP:
        'Podílníky se rozumí fyzické a právnické osoby, které drží podíl na společnosti. Primárně vyplní emitent všechny podílníky, kteří vlastní více než 10% emitenta, tj. zejména společníky u s.r.o. a akcionáře u a.s. Pokud podílník, právnická osoba dosáhne 10% společně s jinou (sesterskou) právnickou osobou, která je ovládána stejnou osobou (mateřskou společností nebo fyzickou osobou), uvede se tato mateřská společnost nebo fyzická osoba jako nepřímý podílník v části C3B.',
    FORMULARE_AMLZ_C3A_SELECT_LEGALENTITY: 'Existuje podílník, který přímo vlastní více než 10%  právnické osoby',
    FORMULARE_AMLZ_C3A_SELECT: 'Existuje podílník, který přímo vlastní více než 10% emitenta',
    FORMULARE_AMLZ_C3A_PODILNIK: 'Přímý podílník',
    FORMULARE_AMLZ_C3B_PODILNIK: 'Nepřímý podílník',
    FORMULARE_AMLZ_C3_PODILNIK_JE: 'Podílník je',
    FORMULARE_AMLZ_C3A_PODILNIKTEXT_LEGALENTITY:
        'C3A – Údaje o vlastnické a řídící struktuře právnické osoby – PŘÍMÉ vlastnictví',
    FORMULARE_AMLZ_C3A_PODILNIKTEXT: 'Uveďte údaje o podílnících, kteří přímo vlastní více než 10% emitenta',
    FORMULARE_AMLZ_C3A_PODIL: 'Podíl na vlastnické struktuře v %',
    FORMULARE_AMLZ_C3B_TITLE: 'C3B - Údaje o vlastnické a řídící struktuře emitenta - NEPŘÍMÉ vlastnictví',
    FORMULARE_AMLZ_C3B_TITLE_LEGALENTITY:
        'C3B – Údaje o vlastnické a řídící struktuře právnické osoby – NEPŘÍMÉ vlastnictví',
    FORMULARE_AMLZ_C3B_TEXT_LEGALETITY:
        'Uveďte údaje o podílnících, kteří nepřímo vlastní více než 10% právnické osoby',
    FORMULARE_AMLZ_C3B_TEXT: 'Uveďte údaje o podílnících, kteří nepřímo vlastní více než 10% emitenta',
    FORMULARE_AMLZ_C3B_TOOLTIP_LEGALENTITY:
        'Uveďte údaje o fyzické nebo právnické osobě, která ovládá přímé podílníky, kteří nejsou uvedeni jako přímý podílník v části C3A, ale součet jejichž podílů převyšuje 10% základního kapitálu právnické osoby.',
    FORMULARE_AMLZ_C3B_TOOLTIP:
        'Uveďte údaje o fyzické nebo právnické osobě, která ovládá přímé podílníky, kteří nejsou uvedeni jako přímý podílník v části C3A, ale součet jejichž podílů převyšuje 10% základního kapitálu emitenta.',
    FORMULARE_AMLZ_C3B_SELECT: 'Existuje podílník, který nepřímo vlastní více než 10% emitenta',
    FORMULARE_AMLZ_C3B_SELECT_LEAGLENTITY: 'Existuje podílník, který nepřímo vlastní více než 10% právnické osoby',
    FORMULARE_AMLZ_C4_TITLE: 'C4 - Údaje o skutečném majiteli emitenta',
    FORMULARE_AMLZ_C4_TITLE_LEGALENTITTY: 'C4 – Údaje o skutečném majiteli právnické osoby',
    FORMULARE_AMLZ_C4A_TITLE: 'C4A - Údaje o skutečném majiteli emitenta',
    FORMULARE_AMLZ_C4B_TITLE: 'C4B - Údaje o osobě ve vrcholném vedení',
    FORMULARE_AMLZ_C4_TEXT:
        'bold(Skutečným majitelem) se rozumí osoba podle zákona č. 37/2021 Sb., o evidenci skutečných majitelů („ESM“). Zjednodušeně je jím podle tohoto zákona bold(každá fyzická osoba, která je koncovým příjemcem nebo osobou s koncovým vlivem. Koncovým příjemcem) osoba, která může mít přímo nebo nepřímo prostřednictvím jiné osoby nebo právního uspořádání podstatnou část z celkového majetkového prospěchu tvořeného při činnosti nebo likvidaci právnické osoby nebo tvořeného při správě nebo zániku právního uspořádání (dále jen "prospěch"), a tento prospěch dále nepředává. bold(Osobou s koncovým vlivem) osoba, která může bez pokynů jiného přímo nebo nepřímo uplatňovat rozhodující vliv v právnické osobě nebo na správu právního uspořádání.',
    FORMULARE_AMLZ_C4_TEXT_A:
        'bold(Koncovým příjemcem) právnické osoby je každá osoba, která může přímo nebo nepřímo získávat více než bold(25 % z celkového majetkového prospěchu) tvořeného při činnosti nebo likvidaci právnické osoby, a tento prospěch dále nepředává; má se za to, že prospěch předáván není. Koncovým příjemcem obchodní korporace je každá osoba, která má přímo nebo nepřímo právo na podíl na zisku, jiných vlastních zdrojích nebo likvidačním zůstatku obchodní korporace (dále jen bold("podíl na prospěchu"))bold( větší než 25 %,) a tento podíl na prospěchu dále nepředává; má se za to, že podíl na prospěchu předáván není.Pro účely výpočtu výše nepřímého podílu na prospěchu se v případě',
    FORMULARE_AMLZ_C4_TEXT_A1:
        'a) řetězení podíly na prospěchu, na které mají právo navázané osoby nebo právní uspořádání, násobí a',
    FORMULARE_AMLZ_C4_TEXT_A2: 'b) větvení součiny podílů na prospěchu z jednotlivých řetězení sčítají.',
    FORMULARE_AMLZ_C4_TEXT_B:
        'bold(Osoba s koncovým vlivem) v obchodní korporaci je každá fyzická osoba, která je ovládající osobou podle zákona upravujícího právní poměry obchodních korporací. Má se za to, že osobou s koncovým vlivem v jiné než obchodní korporaci a v bytovém nebo sociálním družstvu je každá fyzická osoba, která je členem jejich statutárního orgánu. Na to, že fyzická osoba je osobou s koncovým vlivem v korporaci, ukazuje její přímý nebo nepřímý podíl na hlasovacích právech, který významně převyšuje podíly na hlasovacích právech ostatních osob, zejména je-li větší než 25 %. Pro účely výpočtu výše nepřímého podílu na hlasovacích právech se v případě',
    FORMULARE_AMLZ_C4_TEXT_B1:
        'a) řetězení podíly na hlasovacích právech, které mají navázané osoby nebo právní uspořádání, násobí, přičemž, s výjimkou podílu na hlasovacích právech v korporaci, která je předmětem výpočtu, se jako',
    FORMULARE_AMLZ_C4_TEXT_B2:
        '1. 100 % počítají podíly na hlasovacích právech zakládající domněnku ovládání podle zákona upravujícího právní poměry obchodních korporací a',
    FORMULARE_AMLZ_C4_TEXT_B3: '2. 0 % počítají podíly neuvedené v bodě 1,',
    FORMULARE_AMLZ_C4_TEXT_C: 'b) větvení součiny podílů na hlasovacích právech z jednotlivých řetězení sčítají.',
    FORMULARE_AMLZ_C4_TEXT_C1:
        'Platí, že bold(každá osoba ve vrcholném vedení korporace) je jejím skutečným majitelem,',
    FORMULARE_AMLZ_C4_TEXT_C2:
        'a) nelze-li žádného skutečného majitele určit ani při vynaložení veškerého úsilí, které lze po evidující osobě rozumně požadovat, nebo',
    FORMULARE_AMLZ_C4_TEXT_C3:
        'b) je-li osobou s koncovým vlivem v korporaci právnická osoba, která nemá skutečného majitele podle § 7.',
    FORMULARE_AMLZ_C4_TEXT_C4:
        'Je-li osobou s koncovým vlivem v korporaci právnická osoba, která nemá skutečného majitele podle § 7, a zároveň je koncovým příjemcem korporace jiná osoba, platí, že skutečnými majiteli korporace jsou každá osoba ve vrcholném vedení této korporace a každá fyzická osoba, která je jejím koncovým příjemcem.',
    FORMULARE_AMLZ_C4_TEXT_C5:
        'Je-li osobou s koncovým vlivem právnická osoba, jejíž skutečný majitel je určen podle předchozích dvou odstavců, platí, že každá osoba v jejím vrcholném vedení je také skutečným majitelem všech korporací v jí podřízené struktuře vztahů.',
    FORMULARE_AMLZ_C4_TEXT_C6: 'V § 7 ESM jsou uvedeny subjekty, které skutečného majitele nemají.',
    FORMULARE_AMLZ_C4_RADIO_UV:
        'bold(A.) Níže uvádí údaje o fyzické osobě či fyzických osobách, které jsou skutečným majitelem podle zákona o evidenci skutečných majitelů',
    FORMULARE_AMLZ_C4_RADIO_NEUV:
        'bold(B.) Níže uvádí každou osobu ve vrcholném vedení korporace (případně ve vrcholném vedení osoby s koncovým vlivem), protože nelze žádného skutečného majitele určit nebo je osobou s koncovým vlivem právnická osoba bez skutečného majitele podle § 7 ESM. ',
    FORMULARE_AMLZ_C4_RADIO_NENI:
        'bold(C.) Prohlašuje, že není schopen určit fyzickou osobu, která je skutečným majitelem podle zákona o evidenci skutečných majitelů, z následujících důvodů (např. že skutečného majitele nemá ve smyslu § 7 ESM):',
    FORMULARE_AMLZ_C4_OSOBA_TRUE: 'JE statutární orgán nebo člen statutárního orgánu',
    FORMULARE_AMLZ_C4_OSOBA_FALSE: 'NENÍ statutární orgán nebo člen statutárního orgánu',
    FORMULARE_AMLZ_C4_OSOBA_MAJITEL: 'Skutečný majitel',
    FORMULARE_AMLZ_C4_OSOBA_TEXT:
        'Pokud je skutečným majitelem člen vrcholného vedení, je nutné vyplnit veškeré níže uvedené identifikační údaje, pokud již nejsou uvedeny výše v údajích o fyzických osobách oprávněných zastupovat emitenta.',
    FORMULARE_AMLZ_C4_OSOBA_PUVOD: 'Země původu skutečného majitele',
    FORMULARE_AMLZ_C5_TITLE: 'C5 - Prohlášení emitenta k identifikaci politicky exponované osoby (PEP)',
    FORMULARE_AMLZ_C5_TITLE_LEGALENTITY:
        'C5 – Prohlášení právnické osoby k identifikaci politicky exponované osoby (PEP)',
    FORMULARE_AMLZ_C5_SUBTITLE: 'PEP se rozumí',
    FORMULARE_AMLZ_C5_TEXTA:
        'a) fyzická osoba, která je nebo byla ve významné veřejné funkci s celostátním nebo regionálním významem, jako je zejména hlava státu, předseda vlády, vedoucí ústředního orgánu státní správy a jeho zástupce (náměstek, státní tajemník), člen parlamentu, člen řídícího orgánu politické strany, vedoucí představitel územní samosprávy, soudce nejvyššího soudu, ústavního soudu nebo jiného nejvyššího justičního orgánu, proti jehož rozhodnutí obecně až na výjimky nelze použít opravné prostředky, člen bankovní rady centrální banky, vysoký důstojník ozbrojených sil nebo sboru, člen nebo zástupce člena, je-li jím právnická osoba, statutárního orgánu obchodní korporace ovládané státem, velvyslanec nebo vedoucí diplomatické mise, anebo fyzická osoba, která obdobnou funkci vykonává nebo vykonávala v jiném státě, v orgánu Evropské unie anebo v mezinárodní organizaci,',
    FORMULARE_AMLZ_C5_TEXTB: 'b) fyzická osoba, která je',
    FORMULARE_AMLZ_C5_TEXTB1: '1. osobou blízkou k osobě uvedené v písmenu a)',
    FORMULARE_AMLZ_C5_TEXTB2:
        '2. společníkem nebo skutečným majitelem stejné právnické osoby, popřípadě svěřenského fondu, jako osoba uvedená v písmenu a), nebo je o ní povinné osobě známo, že je v jakémkoli jiném blízkém podnikatelském vztahu s osobou uvedenou v písmenu a), nebo',
    FORMULARE_AMLZ_C5_TEXTB3:
        '3. skutečným majitelem právnické osoby, popřípadě svěřenského fondu, o kterých je povinné osobě známo, že byly vytvořeny ve prospěch osoby uvedené v písmenu a).',
    FORMULARE_AMLZ_C5_TEXT_PROHLASENI_LEGALENTIY:
        'Právnická osoba prohlašuje, že fyzická osoba jednající za klienta a jeho skutečný majitel',
    FORMULARE_AMLZ_C5_TEXT_PROHLASENI:
        'Emitent prohlašuje, že fyzická osoba jednající za klienta a jeho skutečný majitel',
    FORMULARE_AMLZ_C5_SELECT_ANO: 'následující  osoby jsou PEP',
    FORMULARE_AMLZ_C5_SELECT_NE: 'nejsou PEP',
    FORMULARE_AMLZ_C5_SELECT_DOPLN_INFO1:
        'Je osobou, vůči níž Česká republika uplatňuje mezinárodní sankce podle zákona o provádění mezinárodních sankcí',
    FORMULARE_AMLZ_C5_SELECT_DOPLN_INFO2:
        'Je ze státu, který nedostatečně nebo vůbec neuplatňuje opatření proti legalizaci výnosů z trestné činnosti a financování terorismu',
    FORMULARE_AMLZ_C6_ZHRNUTI: 'Shrnutí údajů k AMLZ',
    FORMULARE_AMLZ_C6_TITLE_LEGALENTITY: 'C6 – Právnická osoba se zavazuje',
    FORMULARE_AMLZ_C6_TITLE: 'C6 - Emitent se zavazuje',
    FORMULARE_AMLZ_C6_TEXTA: 'a) poskytnout CDCP součinnost při provádění kontroly,',
    FORMULARE_AMLZ_C6_TEXTB: 'b) oznámit změny v údajích uvedených v tomto dokumentu,',
    FORMULARE_AMLZ_C6_TEXTC: 'c) poskytovat na vyžádání vysvětlení ke smyslu a účelu konkrétní operace u CDCP,',
    FORMULARE_AMLZ_C6_TEXTD:
        'd) pro případ identifikace PEP u emitenta se emitent zavazuje poskytovat údaje k přezkoumávání zdrojů peněžních prostředků užitých v obchodu',
    FORMULARE_AMLZ_C6_SUBTITLE_LEGALENTITY: 'Dotazník za právnickou osobu podává',
    FORMULARE_AMLZ_C6_SUBTITLE: 'Dotazník za emitenta podává',
    FORMULARE_AMLZ_C6_SUBTEXT:
        'Vyberte ze seznamu osobu, která za emitenta odesílá dotazník ke kontrole emitenta podle AMLZ.',

    DOTAZNIK_AMLZ: 'Dotazník AMLZ',
    FORMULARE_AMLZ_ROZCESTNIK_ZAKON:
        'V souladu se bold(zákonem č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu) (bold(dále jen „AMLZ“))bold(, vyhlášky České národní banky č. 67/2018 Sb.), o některých požadavcích na systém vnitřních zásad, postupů a kontrolních opatření proti legalizaci výnosů z trestné činnosti a financování terorismu (dále jen „vyhláška“), a na jejich základě zavedenému Systému vnitřních zásad, postupů a kontrolních opatření k naplnění povinností vyplývajících z AMLZ a vyhlášky, je Centrální depozitář cenných papírů, a.s. (dále jen „CDCP“), povinen provádět identifikaci a kontrolu svých klientů. Vyplnění tohoto formuláře je podmínkou uzavření smlouvy nebo poskytnutí služby.',
    FORMULARE_AMLZ_ROZCESTNIK_ZAKL_UDAJE1:
        'Pro vyplnění dotazníku budete potřebovat znát údaje o fyzických osobách zastupujících emitenta, údaje o vlastnické a řídící struktuře emitenta, údaje o skutečném majiteli emitenta, údaje k identifikaci politicky exponované osoby. Po vyplnění je třeba podepsat dotazník elektronickým podpisem neboli kvalifikovaným certifikátem (podepisují osoby oprávněné jednat za emitenta na základě zápisu v rejstříku nebo plné moci). Návod, jak podepsat dotazník elektronickým podpisem, najdete v nápovědě u pole Způsob identifikace osoby – výběr „elektronický podpis“. V případě, že nebudete podepisovat elektronickým podpisem, připravte si před zahájením vyplňování dotazníku oboustranné kopie (v elektronické podobě) minimálně dvou dokladů totožnosti za každou osobu zastupující emitenta a potvrzení o existenci bankovního účtu emitenta.',
    FORMULARE_AMLZ_ROZCESTNIK_INVALID_LEI:
        'Pro zadané IČO nebylo LEI nalezeno. Pokud nemáte LEI kód přidělen, další informace naleznete na www.cdcp.cz v sekci Ostatní služby. Zda Vám byl LEI kód přidělen lze zkontrolovat na stránkách www.gleif.org.',
    FORMULARE_CHYBNE_OPSANY_KOD: 'Chybně opsaný text z obrázku. Prosím, opište text znovu.',
    FORMULARE_ZADOST_REGI: 'Žádost o registraci ISIN jiné jurisdikce',
    FORMULARE_ZADOST_PRID: 'Žádost emitenta o přidělení ISIN',
    FORMULARE_ZADOST_ZMEN: 'Žádost emitenta o změnu ISIN',
    FORMULARE_ZADOST_ZRUS: 'Žádost emitenta o zrušení ISIN',
    FORMULARE_CEKANI_NA_ZPRACOVANI_AMLZ:
        'Čeká se na zpracování žádosti o AMLZ. O možnosti pokračovat bude informováni e-mailem.',
    FORMULARE_NACE_TOOLTIP:
        'Uveďte dvoumístný číselný kód hlavní činnosti emitenta dle ARES (první dvě čísla ze záložky RES). Podrobnější informace též naleznete na www.nace.cz',
    FORMULARE_LEI_LAPSED_FO:
        "Zadané IČO nemá uhrazený poplatek za prodloužení platnosti LEI. Platnost prodloužíte provedením aktualizace údajů o LEI (dostupné na stránkách https://www.cdcp.cz' v sekci Další služby-Aktualizace LEI) a následným uhrazením poplatku dle zaslané platební instrukce. Bez prodloužení platnosti nelze v žádosti pokračovat.",
    FORMULARE_LEI_ZRUSENE: 'Vámi zadané LEI je zrušené.',
    FORMULARE_LEI_VEDENO_PRO_JINOU_SPOL: 'Vámi zadané LEI je registrováno pro jinou společnost. Opravte zadané LEI.',
    FORMULARE_PROVOZOVNA_STATY: 'Doplňte všechny státy v nichž má emitent pobočku, organizační složku nebo provozovnu',
    FORMULARE_PROVOZOVNA_STATY_LEGALENTITY:
        'Doplňte všechny státy, v nichž má právnická osoba pobočku, organizační složku nebo provozovnu',
    FORMULARE_C2_VLOZTE_DOKLAD: 'Vložte doklad o existenci bankovního účtu na jméno emitenta',
    FORMULARE_C2_VLOZTE_DOKLAD_TOOLTIP:
        'V případě více účtů uveďte bankovní účet, který je veden na jméno emitenta a ze kterého budou hrazeny poplatky CDCP.',
    CHECK_LEI_MATKASLEI_NEPLATNE_LEI: 'Neplatné LEI',
    NATURAL_PERSONS: 'Fyzické osoby',
    NON_CONSOLIDATING: 'Neexistuje konsolidace',
    NON_PUBLIC: 'Nezveřejněno',
    NO_KNOWN_PERSON: 'Osoby nejsou známy',
    LEGAL_OBSTACLES: 'Zákonné překážky',
    CONSENT_NOT_OBTAINED: 'Nebyl poskytnut souhlas',
    BINDING_LEGAL_COMMITMENTS: 'Jiné právní závazky',
    DETRIMENT_NOT_EXCLUDED: 'Nelze vyloučit škodu',
    DISCLOSURE_DETRIMENTAL: 'Zveřejnění by způsobilo škodu',
    EMITENTSKA_AUTOMATICKE_ODHLASENI:
        "Blíží se automatické odhlášení z bezpečnostních důvodů. Stisknutím tlačítka 'OK' interval prodloužíte.",
    EMP_POTVRZENI_EMAIL_NADPIS: 'Potvrzení změny e-mailové adresy',
    EMP_POTVRZENI_EMAIL_200: 'Heslo bylo úspěšně změněno. Nyní se můžete přihlásit pomocí svého nového hesla.',
    EMP_POTVRZENI_EMAIL_200_OK: 'Požadavek na změnu e-mailu byl úspěšně odeslán.',
    EMP_POTVRZENI_EMAIL_200_AUTENTIZACE: 'Neplatné uživatelské jméno nebo heslo.',
    EMP_POTVRZENI_EMAIL_200_DUPLICITA: 'Změnu nelze provést, uživatel již existuje.',
    EMP_POTVRZENI_EMAIL_SENT: 'Požadavek na změnu e-mailu byl úspěšně odeslán.',
    EMP_POTVRZENI_EMAIL_401: 'Vypršela platnost zaslaného odkazu. Zašlete novou žádost o změnu e-mailu.',
    EMP_POTVRZENI_EMAIL_404: 'Neplatný e-mail či heslo.',
    EMP_AKTIVACE_OK: 'Učet byl úspěšně aktivován. Můžete se přihlásit.',
    EMP_AKTIVACE_401: 'Vypršela platnost stránky. Pro založení účtu se prosím znovu zaregistrujte.',
    EMP_INFO_ZMENA_LOGIN_ZADEJTE: 'Zadejte své uživatelské jméno a heslo.',
    EMP_INFO_ZMENA_OBNOVENI_HESLO: 'Heslo bylo změněno',
    EMP_REGISTRACE_OK:
        'Pro úspěšné dokončení registrace je potřeba aktivovat učet pomoci odkazu, který Vám byl odeslán na e-mail uvedený při registraci.',
    EMP_AMLZ_DLAZDICE_NADPIS_DOTAZNIK: 'Dotazník ke kontrole emitenta podle AMLZ',
    EMP_ISIN_DLAZDICE_NADPIS_SEZNAM: 'Seznam ISIN',
    EMP_PODANE_ZADOSTI_SEZNAM_ZADOSTI: 'Seznam vybraných žádostí',
    EMP_PODANE_ZADOSTI_ICO: 'Identifikační číslo (IČ/NID)',
    EMP_PODANE_ZADOSTI_NID: 'Náhradní identifikační číslo (NID)',
    EMP_PODANE_ZADOSTI_NAZEV_PO: 'Název právnické osoby',
    EMP_PODANE_ZADOSTI_NAZEV_SPOLECNOSTI: 'Název společnosti',
    EMP_PODANE_ZADOSTI_FORMULAR: 'Formulář',
    EMP_PODANE_ZADOSTI_DATUM_PODANI: 'Datum podání',
    EMP_PODANE_ZADOSTI_DATUM_AKTUALIZACE: 'Datum poslední aktualizace',
    EMP_PODANE_ZADOSTI_DATUM_AKTUALIZACE_DALSI: 'Datum příští aktualizace',
    EMP_PODANE_ZADOSTI_DATUM_CERTIFIKACE: 'Datum příští certifikace',
    EMP_PODANE_ZADOSTI_STAV: 'Stav',
    EMP_PODANE_ZADOSTI_CHYBA_SMAZANI: 'Nepodařilo se zrušit vybranou žádost',
    EMP_PODANE_ZADOSTI_POTVRDIT_SMAZANI: 'Opravdu si přejete zrušit vybranou žádost?',
    EMP_PODANE_ZADOSTI_ZADOST_BYLA_ZRUSENA: 'Vybraná žádost byla zrušena.',
    EMP_PODANE_ZADOSTI_ZADOST_BYLA_ZAMITNUTA: 'Vybraná žádost byla zamítnuta.',
    EMP_PODANE_ZADOSTI_ODESLANO: 'Přijato do CDCP',
    EMP_PODANE_ZADOSTI_KEKONTROLE: 'Ke kontrole',
    EMP_PODANE_ZADOSTI_ZNEPLATNENO: 'Zneplatněno',
    EMP_PODANE_ZADOSTI_ZRUSENO: 'Zrušeno',
    EMP_PODANE_ZADOSTI_AKCEPTOVANO: 'Akceptováno',
    EMP_PODANE_ZADOSTI_ZAMITNUTO: 'Zamítnuto',
    EMP_PODANE_ZADOSTI_KDOPLNENI: 'K doplnění',
    EMP_PODANE_ZADOSTI_KDOPL: 'K doplnění',
    EMP_PODANE_ZADOSTI_ROZPRACOVANO: 'Rozpracováno',
    EMP_PODANE_ZADOSTI_ROZP: 'Rozpracováno',
    EMP_PODANE_ZADOSTI_KODESLANI: 'Rozpracováno',
    EMP_PODANE_ZADOSTI_CEKA: 'Čeká se na zpracování žádosti',
    EMP_PODANE_ZADOSTI_AKTUALIZOVAT: 'K aktualizaci',
    EMP_PODANE_ZADOSTI_DOPLENO: 'Doplněno',
    EMP_PODANE_ZADOSTI_BYLA_ZNEPLATNENA: 'Vybraná žádost byla zneplatněna.',
    EMP_PODANE_ZADOSTI_409_ZRUSENA: 'Vybraná žádost byla zrušena.',
    EMP_PODANE_ZADOSTI_409_ZNEPLANTNENA: 'Vybraná žádost byla zneplatněna.',
    LEI_KOD: 'LEI kód',
    DATUM_PRIDELENI: 'Datum přidělení',
    EMP_LOGIN_PODNADPIS_MOZNOSTI: 'Vyberte jednu z následujících možností pro přihlášení:',

    EMP_LOGIN_CERTIFIKAT_VYSTAVITEL: 'Vystavitel certifikátu',

    EMP_VYBER_PROFIL_CERTIFIKAT2: 'Zvolte, vyhledejte anebo vytvořte účet subjektu, kterého zastupujete.',
    EMP_VYBER_PROFIL_VYBERTE_SUBJEKT_NONE: 'Založit nový účet',
    EMP_VYBER_PROFIL_VYBERTE_SUBJEKT: 'Existujicí účty',
    EMP_VYBER_PROFIL_RESP_401_CHYBI: 'Váš systém neobsahuje certifikát pro komunikaci s Můj depozitář.',
    EMP_VYBER_PROFIL_RESP_401_NENALEZEN:
        'Při pokusu o přihlášení jste se prokázali certifikátem, který není registrován v Můj depozitář.',

    LEI_AKTUALIZACE_SIDLO_CENTRAL_SAME: 'Tuto změnu (se stejnými údaji) provést i u adresy centrály',
    LEI_U_OPRAVNENE_POVERENE: 'Oprávněné / pověřené osoby',
    LEI_AKTUALIZACE_INFORMACE_OPR: 'Informace o oprávněné osobě',
    LEI_AKTUALIZACE_INFORMACE_POV: 'Informace o pověřené osobě',
    PLNA_MOC_VZOR: 'Plná moc vzor',
    LEI_AKTUALIZACE_OPRAVNENI2:
        'Pověření jednající fyzické osoby k zastupování právnické osoby musí být doloženo plnou mocí, která musí být podepsána oprávněnou osobou nebo osobami uvedenými ve veřejných rejstřících.',
    LEI_AKTUALIZACE_OPRAVNENI_SUB:
        'Pokud není možné uvedenou osobu automaticky ověřit, je nutné vložit přílohu s oprávněním (výpis z OR, plná moc, apod.).',
    LEI_AKTUALIZACE_OPRAVNENI:
        'Oprávnění jednající fyzické osoby k zastupování právnické osoby by zásadně mělo vyplývat z veřejných rejstříků (OR, ARES). Oprávněné osoby jsou ověřovány automaticky dle OR nebo ARES.',
    LEI_AKTUALIZACE_PRIHLASOVACI_HESLO: 'Přihlašovací heslo',
    LEI_AKTUALIZACE_PRIHLASOVACI_UDAJE: 'Přihlašovací údaje',
    LEI_TYP_OSOBY_OPRAVNENA: 'Oprávněná osoba',
    LEI_TYP_OSOBY_POVERENA: 'Pověřená osoba',
    LEI_TYP_OSOBY_OPR: 'Oprávněná osoba',
    LEI_TYP_OSOBY_POV: 'Pověřená osoba',
    LEI_TYP_OSOBY_OPRAVNENA_SELECT: 'Jsem oprávněná osoba uvedená ve veřejném rejstříku.',
    LEI_TYP_OSOBY_POVERENA_SELECT: 'Jsem pověřená osoba, na základě plné moci.',

    AMLZ_HISTORIE: 'Historie',
    AMLZ_NOVE: 'Nové AML',
    AMLZ_AKTUALIZACE: 'Aktualizace AML',
    AMLZ_PREHLED_NADPIS: 'Aktuální údaje o AMLZ',
    AMLZ_PREHLED_DATUM: 'Naposledy aktualizováno',
    AMLZ_PREHLED_OSOBY: 'Osoby oprávněné zastupovat emitenta',
    AMLZ_NEUSPECH: 'AMLZ nebylo možné odeslat.',
    AMLZ_USPECH: 'AMLZ bylo úspěsně odesláno.',
    AMLZ_USPECH_TEXT: 'Odeslanou žádost lze najít v seznamu podaných žádostí.',
    AMLZ_NEUSPECH_CPRIMANEPRIMA: 'Zkontrolujte si údaje v části C3',
    AMLZ_NEUSPECH_ESM: 'Zkontrolujte si údaje v C4',
    AMLZ_NEUSPECH_LEI: 'Zkontrolujte si LEI',
    EMISE_REGI_ISIN: 'Zahraniční ISIN',
    EMISE_NOVY_ISIN: 'Nový ISIN',
    EMISE_ZMENY_ISIN: 'Změna ISIN',
    EMISE_ZRUSENI_ISIN: 'Zrušení ISIN',

    EMISE_PODANE_ZADOSTI: 'Historie',
    EMISE_PODZAD_STAV_AKCEPTOVANO: 'Akceptováno',
    EMISE_PODZAD_STAV_ZAMITNUTO: 'Zamítnuto',
    EMISE_PODZAD_STAV_KDOPLNENI: 'K doplnění',
    EMISE_PODZAD_STAV_KODESLANI: 'K odeslání',
    EMISE_PODZAD_STAV_DOPLENO: 'Doplněno',
    EMISE_PODZAD_STAV_ODESLANO: 'Přijato do CDCP',
    EMISE_PODZAD_STAV_AKTUALIZOVAT: 'K aktualizaci',
    EMISE_PODZAD_STAV_ROZPRACOVANO: 'Rozpracováno',
    EMISE_PODZAD_STAV_ZRUSENO: 'Zrušeno',
    EMISE_PODZAD_STAV_ZNEPLATNENO: 'Zneplatněno',
    LEI_CANCELLED_CARD_TEXT: 'Žádost o lei byla zrušena, vytvořte novou žádost',
    EMISE_PODZAD_PRID: 'Žádost o ISIN - Přidělení',
    EMISE_PODZAD_ZMEN: 'Žádost o ISIN - Změna',
    EMISE_PODZAD_ZRUS: 'Žádost o ISIN - Zrušení',
    EMISE_PODZAD_REGI: 'Zahraniční ISIN',

    ISIN_ROZCESTNIK_HELP_ZMENA:
        'Pokud při změně z listinné na zaknihovanou podobu je Osobou vedoucí evidenci CDCP, musíte požádat o zrušení původního ISIN a požádat o přidělení nového ISIN.',
    ISIN_ROZCESTNIK_HELP:
        'V případě změny podoby uveďte novou podobu, např. při přeměně z listinné podoby na zaknihovanou zaškrtněte „zaknihovaný“',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT: 'Emitent žádající o ISIN',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_UI:
        'Je úvěrovou nebo finanční institucí se sídlem v zemích EU nebo v zemi uplatňující požadavky rovnocenné AMLZ',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_UO:
        'Je ústředním orgánem státní správy, ČNB nebo vyšším územním samosprávným celkem',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_EM:
        'Je emitentem, jehož cenné papíry jsou přijaty k obchodování na regulovaném trhu se sídlem v zemích EU nebo v zemi uplatňující požadavky rovnocené AMLZ',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_FO: 'Je fyzickou osobou',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_NA: 'Nepatří ani do jedné z výše uvedených skupin',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN: 'Emitent žádá o přidělení ISIN',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_LIST: 'Listinný',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_ZAKN: 'Zaknihovaný',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_IMOB: 'Imobilizovaný',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_SBER: 'Listinný - sběrná podoba',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA:
        'Osoba vedoucí evidenci zaknihovaného CP, imobilizovaného CP nebo CP ve sběrné podobě je',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCP: 'CDCP',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB: 'ČNB',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF: 'MF',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCPDLT: 'CDCP DLT',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT: 'Jiná osoba',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY: 'Osoba vedoucí evidenci',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ICOLEI: 'Identifikátor osoby vedoucí evidenci (IČO/LEI)',
    PRIKAZ_ZRUSENI_PRIDELENI_OSOBA_PUV_JINY_ICOLEI: 'Identifikátor původní osoby vedoucí evidenci (IČO/LEI)',
    PRIKAZ_ZRUSENI_PRIDELENI_OSOBA_NOVY_JINY_ICOLEI: 'Identifikátor nové osoby vedoucí evidenci (IČO/LEI)',
    ISIN_IDENTIFIKACE_IDENTIFIKACE_EMITENTA: 'Identifikace emitenta',
    ISIN_IDENTIFIKACE_FIRMA: 'Obchodní firma nebo jiný název emitenta',
    ISIN_IDENTIFIKACE_FIRMA_LEGALENTITY: 'Obchodní firma nebo jiný název právnické osoby',
    ISIN_IDENTIFIKACE_PRAVNI_FORMA: 'Právní forma',
    ISIN_IDENTIFIKACE_ADRESA_SIDLA: 'Adresa sídla emitenta',
    ISIN_IDENTIFIKACE_ADRESA_LEGALENTITY: 'Adresa sídla právnické osoby',
    ISIN_IDENTIFIKACE_ADRESA_LEGALENTITY_ALT: 'Doručovací adresa je různá od sídla právnické osoby',
    ISIN_IDENTIFIKACE_KAPITAL: 'Základní kapitál',
    ISIN_IDENTIFIKACE_MENA: 'Měna kapitálu',
    ISIN_IDENTIFIKACE_SPLACENO: 'Splaceno v %',
    ISIN_IDENTIFIKACE_PLATCE: 'Plátce DPH',
    DIC: 'DIČ',
    ISIN_IDENTIFIKACE_DIC: 'DIČ pro DPH',
    ISIN_IDENTIFIKACE_EMAIL_FAKTURY: 'E-mail pro zasílání faktur',
    ISIN_IDENTIFIKACE_EMAIL_FAKTURY_HELP:
        'uveďte obecný email vašeho finančního oddělení nebo osoby na jejíž email bude CDCP zasílat daňové doklady za všechny služby poskytované emitentům.',
    ISIN_IDENTIFIKACE_EMAIL_OSOBY: 'E-mail osoby, která vyplňuje tuto žádost o ISIN',
    ISIN_IDENTIFIKACE_TELEFON: 'Telefon osoby, která vyplňuje tuto žádost o ISIN',
    ISIN_IDENTIFIKACE_VLASTNIK_HELP:
        'Uveďte bankovní účet, který je veden na jméno emitenta a ze kterého budou hrazeny poplatky CDCP (ve formátu IBAN). Účet vyplňte bez mezer. Pro ověření správnosti IBAN můžete použít Kalkulátor IBAN – Česká republika, který naleznete na stránkách www.cnb.cz',
    ISIN_ZMENA_NADPIS_DOPLNENI:
        'Zde zadáte ISIN, u kterého požadujete změnu údajů (např. změna formy, změna podoby cenného papíru, fúze).',
    ISIN_DUVOD_ZMENA_PODNADPIS:
        'Při změně ISIN vyplňte číslo ISINU u kterého žádáte změnu a uveďte vždy u hodnoty, které požadujete změnit. Vždy uvádějte původní hodnotu a novou hodnotu. Do odůvodnění vyplňte důvod změny nebo (např. změna formy, změna podoby cenného papíru, fúze). V případě neúplných informací nebude Váš požadavek přijat do zpracování. O této skutečnosti budou pracovníci CDCP informovat osobu, kterou máte v CDCP vedenou jako kontaktní osobu za Vaši společnost.',
    ISIN_DUVOD_ZRUSENI_PODNADPIS: 'V žádosti o zrušení ISIN uveďte důvod zrušení ISIN.',
    ISIN_DUVOD_ISIN: 'Dosavadní ISIN',
    ISIN_DUVOD_ISIN_NESHODA_AREM: 'Společnost není vedena jako emitent nebo administrátor emise',
    ISIN_DUVOD_ZMENA_DUVODY: 'Zde napište původní a nové hodnoty, kterých se změna týká a důvod změny',
    ISIN_DUVOD_ZRUSENI_DUVODY: 'Důvod zrušení',
    DUVOD_ODSTRANENI_OSOBY: 'Důvod odebrání osoby',
    ISIN_ZASTUPUJE_NADPIS: 'Emitenta zastupuje',
    ISIN_ZASTUPUJE_NADPIS_F: 'Emitenta zastupuje fyzická osoba',
    ISIN_ZASTUPUJE_NADPIS_P: 'Emitenta zastupuje právnická osoba',
    ISIN_ZASTUPUJE_OSOBA_FODVR: 'Fyzická osoba dle výpisu z veřejného rejstříku',
    ISIN_ZASTUPUJE_OSOBA_FOZPM: 'Fyzická osoba na základě plné moci',
    ISIN_ZASTUPUJE_OSOBA_FOZJO: 'Fyzická osoba na základě jiného oprávnění',
    ISIN_ZASTUPUJE_OSOBA_PODVR: 'Právnická osoba dle výpisu z veřejného rejstříku',
    ISIN_ZASTUPUJE_OSOBA_POZPM: 'Právnická osoba na základě plné moci',
    ISIN_ZASTUPUJE_OSOBA_PRIDAT_FO: 'Přidat fyzickou osobu',
    ISIN_ZASTUPUJE_OSOBA_PRIDAT_PO: 'Přidat právnickou osobu',
    ISIN_ZASTUPUJE_OSOBA_VYPLNTE:
        'Vyplňte v souladu se zápisem způsobu zastupování v obchodním rejstříku nebo v souladu s přiloženou plnou mocí.',
    ISIN_ZASTUPUJE_FO_CHYBA_RC_DATUM: 'Musí být vyplněno rodné číslo, datum narození nebo obojí.',
    ISIN_EMISE_UDAJ: 'Údaj o plánovaném přijetí emise k obchodování na regulovaném trhu',
    ISIN_EMISE_UDAJ_NADPIS: 'Údaje o emisi',
    ISIN_EMISE_UDAJ_HELP:
        "Pokud emise nebude obchodována na některém z trhů a žádáte pouze o její registraci (zaknihování) v CDCP, vyberte 'Nekótovaná'.",
    ISIN_EMISE_UDAJ_BCPP: 'Burza cenných papírů Praha, a.s.',
    ISIN_EMISE_UDAJ_RMS: 'RM-SYSTÉM',
    ISIN_EMISE_UDAJ_NEKOT: 'Nekótovaná',
    ISIN_EMISE_UDAJ_JINY: 'Jiný organizátor',
    ISIN_EMISE_DRUH_NASTROJKOLINV_TYP: 'Druh nástroje kolektivního investování',
    ISIN_EMISE_DRUH_NASTROJKOLINV_TYP_AKCIESICAV: 'Akcie fondů SICAV',
    ISIN_EMISE_DRUH_NASTROJKOLINV_TYP_AKCIEUIF: 'Akcie uzavřených investičních fondů',
    ISIN_EMISE_DRUH: 'Druh cenného papíru',
    ISIN_EMISE_DRUH_TYP: 'Typ CP',
    ISIN_EMISE_DRUH_AKCIE: 'Akcie',
    ISIN_EMISE_DRUH_DLUHOPIS: 'Dluhový cenný papír',
    ISIN_EMISE_DRUH_PODILLIST: 'Podílový list (OPF, UPF)',
    ISIN_EMISE_DRUH_INVCERT: 'Investiční certifikát',
    ISIN_EMISE_DRUH_WARRANT: 'Warrant',
    ISIN_EMISE_DRUH_NASTROJKOLINV: 'Nástroje kolektivního investování',
    ISIN_EMISE_DRUH_JINYINVNASTROJ: 'Jiný investiční nástroj',
    ISIN_EMISE_DRUH_PREDNOSTNIPRAVO: 'Přednostní právo',
    ISIN_EMISE_DRUH_PRAVOUPSANI: 'Právo upsání',
    ISIN_EMISE_DRUH_ZATIMNILISTY: 'Zatímní listy',
    ISIN_EMISE_DRUH_OSTATNI: 'Ostatní',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ: 'Druh akcie',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ_KMEN: 'kmenové',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ_KMENK: 'kmenové kusové',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ_PRIOR: 'prioritní',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ_PRIORK: 'prioritní kusové',
    ISIN_EMISE_AKCIE_DRUH_PRIKAZ_JINA: 'jiná',
    ISIN_EMISE_AKCIE_DRUH: 'Druh akcie',
    ISIN_EMISE_AKCIE_DRUH_KMENK: 'Kmenová kusová',
    ISIN_EMISE_AKCIE_DRUH_KMEN:
        'Kmenová (základní druh akcie, obvykle spojené s hlasovacím právem a/nebo právem na dividendu)',
    ISIN_EMISE_AKCIE_DRUH_PRIORK: 'Prioritní kusová',
    ISIN_EMISE_AKCIE_DRUH_PRIOR:
        'Prioritní (druh akcie obvykle spojené s přednostním právem na podíl na zisku nebo na likvidačním zůstatku)',
    ISIN_EMISE_AKCIE_DRUH_JINA:
        'Jiná (méně běžné druhy akcií, např. akcie se zvláštními právy, směnitelné akcie, apod.)',
    ISIN_EMISE_AKCIE_DRUH_HELP: 'Pokud jsou akcie též kusové, pak doplňte do jmenovité hodnoty 0.',
    ISIN_EMISE_AKCIE_ODKUP: 'Pravidla pro odkup akcií',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP: 'S možností odkupu',
    ISIN_EMISE_AKCIE_ODKUP_PRODLOUZENI: 'S možností prodloužení',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_PRODLOUZENI: 'S možností odkupu/s možností prodloužení',
    ISIN_EMISE_AKCIE_ODKUP_VYMENITELNE: 'Vyměnitelné',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE: 'S možností odkupu/vyměnitelné',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE_PRODLOUZENI: 'S možností odkupu/vyměnitelné/s možností prodloužení',
    ISIN_EMISE_AKCIE_ODKUP_VECNE: 'Věčné',
    ISIN_EMISE_AKCIE_VYNOS: 'Druh výnosu',
    ISIN_EMISE_AKCIE_VYNOS_P: 'Pevný',
    ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_P: 'Kumulativní pevný',
    ISIN_EMISE_AKCIE_VYNOS_PC: 'Participativní',
    ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_PC: 'Kumulativní participativní',
    ISIN_EMISE_AKCIE_VYNOS_PR: 'Proměnlivý',
    ISIN_EMISE_AKCIE_VYNOS_N: 'Normální',
    ISIN_EMISE_AKCIE_VYNOS_A: 'Aukční',
    ISIN_EMISE_AKCIE_HODNOTA_ZA_CP: 'Jmenovitá hodnota za jeden kus CP',
    ISIN_EMISE_AKCIE_KUSU: 'Počet kusů',
    ISIN_EMISE_AKCIE_KUSU_HELP: 'Uveďte shodný počet kusů, který jste uvedli u mateřského ISIN.',
    ISIN_EMISE_AKCIE_CELKOVA_HODNOTA: 'Celková jmenovitá hodnota emise',
    ISIN_EMISE_AKCIE_PODOBA: 'Podoba cenného papíru',
    ISIN_EMISE_AKCIE_FORMA: 'Forma cenného papíru',
    ISIN_EMISE_NON_AKCIE_FORMA_HELP: 'Má-li cenný papír formu na řad, uveďte pro účely tohoto rozdělení formu na jméno',
    ISIN_EMISE_AKCIE_FORMA_NAMAJITELE: 'Na majitele',
    ISIN_EMISE_AKCIE_FORMA_NADORUCITELE: 'Na doručitele',
    ISIN_EMISE_AKCIE_FORMA_NAJMENO: 'Na jméno',
    ISIN_EMISE_AKCIE_FORMA_NARAD: 'Na řad',
    ISIN_EMISE_AKCIE_FORMA_NEURCENO: 'Neurčeno',
    ISIN_EMISE_AKCIE_SEZNAM: 'Seznam akcionářů vede dle stanov společnosti CDCP',
    ISIN_EMISE_AKCIE_PREVODITELNOST_POPIS: 'Popis omezujících podmínek',
    ISIN_EMISE_AKCIE_PREVODITELNOST: 'Omezená převoditelnost cenného papíru',
    ISIN_EMISE_AKCIE_PREVODITELNOST_TOOLTIP:
        'Omezená převoditelnost musí být zapsaná ve veřejném rejstříku, nemůže být uvedena pouze ve stanovách společnosti',
    ISIN_EMISE_AKCIE_HLASOVACI: 'Hlasovací práva spojená s akcií',
    ISIN_EMISE_AKCIE_HLASOVACI_S: 'S hlasovacím právem',
    ISIN_EMISE_AKCIE_HLASOVACI_B: 'Bez hlasovacího práva',
    ISIN_EMISE_AKCIE_HLASOVACI_O: 'Omezený podíl hlasů',
    ISIN_EMISE_AKCIE_HLASOVACI_Z: 'Zvýšený podíl hlasů',
    ISIN_EMISE_DLUHOPIS_SAZBA: 'Typ úrokové sazby',
    ISIN_EMISE_DLUHOPIS_SAZBA_F: 'Fixní',
    ISIN_EMISE_DLUHOPIS_SAZBA_V: 'Variabilní',
    ISIN_EMISE_DLUHOPIS_SAZBA_Z: 'Zero',
    ISIN_EMISE_DLUHOPIS_SAZBA_K: 'Platby v naturáliích',
    ISIN_EMISE_DLUHOPIS_SAZBA_N: 'Nelze použít',
    ISIN_EMISE_DLUHOPIS_SAZBA_JINA: 'Jiná',
    ISIN_EMISE_DLUHOPIS_SAZBA_VYSE: 'Výše úrokové sazby',
    ISIN_MENU_TOOLTIP:
        'ISIN přidělený emisi zůstává stejný, mění se pouze některý z parametrů ISIN, např. jmenovitá hodnota, počet kusů, datum splatnosti atd.',
    ISIN_EMISE_DLUHOPIS_SAZBA_HELP: 'Pokud má mateřský ISIN fixní úrokovou sazbu, zde vyplňte 0,00.',
    ISIN_EMISE_DLUHOPIS_EMISNI_PODMINKY_DATUM: 'Emisní podmínky obsahují datum splatnosti',
    ISIN_EMISE_DLUHOPIS_SPLATNOST: 'Datum splatnosti',
    ISIN_EMISE_DLUHOPIS_SPLATNOST_HELP2: 'Uveďte datum splatnosti kupónu.',
    ISIN_EMISE_DLUHOPIS_DRUH: 'Druh dluhového CP',
    ISIN_EMISE_DLUHOPIS_DRUH_SD: 'Státní',
    ISIN_EMISE_DLUHOPIS_DRUH_BO: 'Bankovní',
    ISIN_EMISE_DLUHOPIS_DRUH_HZL: 'Hypoteční zástavní list',
    ISIN_EMISE_DLUHOPIS_DRUH_KO: 'Komunální',
    ISIN_EMISE_DLUHOPIS_DRUH_PO: 'Podnikový',
    ISIN_EMISE_DLUHOPIS_DRUH_OK: 'Odtržený kupón',
    ISIN_EMISE_DLUHOPIS_DRUH_OJ: 'Oddělená jistina',
    ISIN_EMISE_DLUHOPIS_DRUH_HELP: 'Pokud žádáte jako fyzická osoba, vyberte podnikový dluhopis.',
    ISIN_EMISE_DLUHOPIS_TYP: 'Typ dluhového CP pro CFI',
    ISIN_EMISE_DLUHOPIS_TYP_DL: 'Dluhopisy',
    ISIN_EMISE_DLUHOPIS_TYP_VD: 'Vyměnitelné dluhopisy',
    ISIN_EMISE_DLUHOPIS_TYP_DS: 'Dluhopisy spojené s warranty',
    ISIN_EMISE_DLUHOPIS_TYP_NP: 'Nástroje peněžního trhu',
    ISIN_EMISE_DLUHOPIS_TYP_HZL: 'Hypoteční zástavní listy',
    ISIN_EMISE_DLUHOPIS_TYP_CP: 'Cenné papíry zajištěné aktivy',
    ISIN_EMISE_DLUHOPIS_TYP_KD: 'Komunální dluhopisy',
    ISIN_EMISE_DLUHOPIS_TYP_OD: 'Ostatní dluhové CP',
    ISIN_EMISE_DLUHOPIS_TYP_NEVHODNE_ZVOLENY: 'Nevhodně zvolený typ dluhového CP pro CFI',
    ISIN_EMISE_DLUHOPIS_ZAHRANICNI_EMITENT: 'Zahraničního emitenta',
    ISIN_EMISE_DLUHOPIS_PRIORITNI: 'Prioritní',
    ISIN_EMISE_DLUHOPIS_PODRIZENY: 'Podřízený',
    ISIN_EMISE_DLUHOPIS_VYMENITELNY: 'Vyměnitelný',
    ISIN_EMISE_DLUHOPIS_PERPETUITNI: 'Perpetuitní',
    ISIN_EMISE_DLUHOPIS_ODDELENI_KUPONU: 'Právo na oddělení kupónů od jistiny',
    ISIN_EMISE_DLUHOPIS_ODDELENI_KUPONU_HELP: 'Uveďte shodně s údajem uvedeným v žádosti o ISIN mateřského dluhopisu.',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN:
        'Emitent požaduje přidělit ISIN i na všechny kupóny do splatnosti a na oddělenou jistinu',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN_KUPONY: 'Počet kupónů do splatnosti',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN_KUPONY_HELP: 'Uveďte počet kupónů, pro které bude přidělen ISIN.',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_TEST:
        'Vlastníka vybíráte pouze v případě, že má vlastník možnost žádat o předčasné splacení nad rámec zákona, t.j. i když se nejedená o nesplácení výnosů, změnu emitenta apod.',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM: 'Emisní podmínky',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_F: 'Pevná splatnost bez možnosti předčasného splacení ',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_G: 'Pevná splatnost s možností svolání emitenta k předčasnému splacení',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_C: 'Pevná splatnost s možností výzvy k  předčasnému splacení ze strany držitele',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_D:
        'Pevná splatnost s možností předčasného splacení na základě svolání emitenta nebo výzvy ze strany držitele',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_A: 'Postupné splácení - umořování ',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_B: 'Postupné splácení - umořování s možností svolání emitenta k předčasnému splacení',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_T:
        'Postupné splácení - umořování s možností výzvy k předčasnému splacení ze strany držitele',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_L:
        'Postupné splácení - umořování s možností předčasného splacení na základě svolání emitenta nebo výzvy ze strany držitele',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_P: 'Věčné - perpetuitní  (splácí se jen v případě likvidace emitenta)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_Q: 'Věčné - perpetuitní (s možností svolání emitenta k předčasnému splacení)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_R: 'Věčné - perpetuitní (s možností výzvy k předčasnému splacení ze strany držitele)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_E: 'S možností prodloužení',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NPS: 'Neumožňují předčasné splacení',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS: 'Umožňují předčasné splacení',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_EM: 'Předčasné splacení – emitent může požadovat (jistina v plné výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_DRZ: 'Předčasné splacení – držitel může požadovat (jistina v plné výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_PEVNA:
        'Předčasné splacení – emitent i držitel mohou požadovat (jistina v plné výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE: 'Umožňují postupné splacení emise',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_UMOR: 'Postupné splacení – umoření jistiny',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_EM: 'Postupné splacení – emitent může požadovat (jistina v nesplacené výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_DRZ: 'Postupné splacení – držitel může požadovat (jistina v nesplacené výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_OBA:
        'Postupné splacení – emitent i držitel mohou požadovat (jistina v nesplacené výši)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS: 'Neobsahují datum splatnosti',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_VEC: 'Věčné (perpetuální)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_EM: 'Věčné (perpetuální) - emitent může požadovat odkup',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_DRZ: 'Věčné (perpetuální) - držitel může požadovat odkup',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UMP: 'Umožňují možnost prodloužení',
    ISIN_ZRUSENI_SOUBOR: 'Vložte rozhodnutí emitenta nebo jiný dokument dokládající žádost o zrušení emise',
    ISIN_ZMENA_SOUBOR:
        'Vložte aktualizovaný dokument, který má v sobě zohledněnou změnu, kterou požadujete opravit na již přiděleném ISIN',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_NOVA: 'Nová frekvence výplaty kupónů',
    ISIN_EMISE_DLUHOPIS_FREKVENCE: 'Frekvence výplaty kupónů',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_A: 'Ročně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_S: 'Pololetně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_Q: 'Čtvrtletně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_M: 'Měsíčně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_W: 'Týdně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_D: 'Denně',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_B: 'Jednou za dva roky',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_X: 'Ostatní frekvence',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_NA: 'Nelze určit',
    ISIN_EMISE_DLUHOPIS_ZARUCENI: 'Informace o zaručení emise',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_VZ: 'Vládní záruka / Státní CP',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_SZ: 'Společná záruka (záruka jiným než vládním subjektem)',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_Z: 'Zajištěné (např. zástavním právem, pohledávkami)',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NEZ: 'Nezajištěné',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NZ: 'Negativní záruka',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_S: 'Seniorní',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_SP: 'Seniorní podřízený',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_J: 'Juniorní',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_JP: 'Juniorní podřízený',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NA: 'Nadnárodní',
    ISIN_EMISE_LIST_TYP: 'Typ podílového fondu',
    ISIN_EMISE_CERTIFIKAT_DRUH: 'Druh certifikátu',
    ISIN_EMISE_CERTIFIKAT_DRUH_PAKOVY: 'Pákový',
    ISIN_EMISE_CERTIFIKAT_DRUH_NEPAKOVY: 'Nepákový',
    ISIN_EMISE_CERTIFIKAT_SPLATNOST: 'Emisní podmínky připouštějí předčasnou splatnost',
    ISIN_EMISE_CERTIFIKAT_SAZBA_Z: 'Zero',
    ISIN_EMISE_CERTIFIKAT_SAZBA_POPISTE: 'Popište jiný způsob standardu',
    ISIN_EMISE_CERTIFIKAT_ZARUCENI: 'Informace o zaručení emise',
    ISIN_EMISE_CERTIFIKAT_CP_HELP: 'U certifikátu bez jmenovité hodnoty vyplňte 0',
    ISIN_EMISE_CERTIFIKAT_TYP: 'Typ certifikátu',
    ISIN_EMISE_CERTIFIKAT_TYP_S: 'Sledující',
    ISIN_EMISE_CERTIFIKAT_TYP_CNV: 'Certifikát s nadprůměrným výnosem',
    ISIN_EMISE_CERTIFIKAT_TYP_B: 'Bonusový',
    ISIN_EMISE_CERTIFIKAT_TYP_BNV: 'Bonusový s nadprůměrným výnosem',
    ISIN_EMISE_CERTIFIKAT_TYP_CDV: 'Certifikát s dvojí výhodou',
    ISIN_EMISE_CERTIFIKAT_TYP_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_VYPLATY: 'Výplaty',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_D: 'Dividendové',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_Z: 'Žádné',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_SPLACENI: 'Splacení',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_SH: 'Finanční splacení',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_FS: 'Fyzické splacení',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_VV: 'Volba při vypořádání',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_AKTIVA: 'Podkladová aktiva',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_K: 'Koše',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_A: 'Akcie',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_DN: 'Dluhové nástroje',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_D: 'Deriváty',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_KOM: 'Komodity',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_M: 'Měny',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_I: 'Indexy',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_UM: 'Úrokové míry',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_K: 'Koše',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_A: 'Akcie',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_DNUS: 'Dluhové nástroje / Úrokové sazby',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_KOM: 'Komodity',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_M: 'Měny',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_I: 'Indexy',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV: 'Typ závislosti na bariéře',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_PA: 'Bariéra založená na podkladovém aktivu',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_N: 'Bariéra založená na nástroji',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_DK: 'Dlouhé/krátké',
    ISIN_EMISE_CERTIFIKAT_DK_D: 'Dlouhé',
    ISIN_EMISE_CERTIFIKAT_DK_K: 'Krátké',
    ISIN_EMISE_CERTIFIKAT_DK_O: 'Ostatní',
    ISIN_EMISE_CERTIFIKAT_OPCE: 'Druh uplatnění opce',
    ISIN_EMISE_WARRANT_DRUH: 'Druh warrantu',
    ISIN_EMISE_WARRANT_SAZBA: 'Typ úrokové sazby',
    ISIN_EMISE_WARRANT_SAZBA_F: 'Fixní',
    ISIN_EMISE_WARRANT_SAZBA_V: 'Variabilní',
    ISIN_EMISE_WARRANT_SAZBA_Z: 'Jiná',
    ISIN_EMISE_WARRANT_SAZBA_N: 'Není stanovena',
    ISIN_EMISE_WARRANT_SAZBA_FIXNI_VYSE: 'Výše úrokové sazby',
    ISIN_EMISE_NE: 'Ne (např. perpetuitní investiční nástroj)',
    ISIN_EMISE_WARRANT_EMISNI_PODMINKY: 'Emisní podmínky obsahují datum splatnosti',
    ISIN_EMISE_WARRANT_PODKLAD: 'Druh podkladového aktiva',
    ISIN_EMISE_WARRANT_PODKLAD_KA: 'Koše aktiv',
    ISIN_EMISE_WARRANT_PODKLAD_A: 'Akcie',
    ISIN_EMISE_WARRANT_PODKLAD_DN: 'Dluhové nástroje',
    ISIN_EMISE_WARRANT_PODKLAD_K: 'Komodity',
    ISIN_EMISE_WARRANT_PODKLAD_M: 'Měny',
    ISIN_EMISE_WARRANT_PODKLAD_I: 'Indexy',
    ISIN_EMISE_WARRANT_PODKLAD_O: 'Ostatní',
    ISIN_EMISE_WARRANT_TYP: 'Typ warrantu',
    ISIN_EMISE_WARRANT_TYP_T: 'Tradiční',
    ISIN_EMISE_WARRANT_TYP_N: 'Nahý',
    ISIN_EMISE_WARRANT_TYP_K: 'Krytý',
    ISIN_EMISE_WARRANT_TYP_HELP:
        'Tradiční warranty – vydané emitentem podkladového nástroje. Nahé warranty – emitent warrantu nedrží tolik cenných papírů, kolik by potřeboval, kdyby byly všechny warranty uplatněny. Kryté warranty – emitent warrantu drží tolik cenných papírů, kolik by potřeboval, kdyby byly všechny warranty uplatněny.',
    ISIN_EMISE_WARRANT_WARR: 'Nákupní/Prodejní',
    ISIN_EMISE_WARRANT_WARR_N: 'Nákupní',
    ISIN_EMISE_WARRANT_WARR_P: 'Prodejní',
    ISIN_EMISE_WARRANT_WARR_NP: 'Nákupní a prodejní',
    ISIN_EMISE_WARRANT_OPCE: 'Způsob uplatnění opce',
    ISIN_EMISE_WARRANT_OPCE_E: 'Evropská',
    ISIN_EMISE_WARRANT_OPCE_A: 'Americká',
    ISIN_EMISE_WARRANT_OPCE_B: 'Bermudská',
    ISIN_EMISE_WARRANT_OPCE_O: 'Ostatní',
    ISIN_EMISE_WARRANT_ALIKVYNOS: 'Typ standardu',
    ISIN_EMISE_WARRANT_JINA_TEXT: 'CDCP si vyhrazuje právo nepočítat AÚV.',
    ISIN_EMISE_WARRANT_1: '30E/360',
    ISIN_EMISE_WARRANT_2: '30A/360',
    ISIN_EMISE_WARRANT_3: 'act/360',
    ISIN_EMISE_WARRANT_9: 'act/365',
    ISIN_EMISE_WARRANT_4: 'act/act dle standardu BCK',
    ISIN_EMISE_WARRANT_10: 'act/act dle standardu ICMA',
    ISIN_EMISE_WARRANT_ZERO_8: '30E/360 (000/360)',
    ISIN_EMISE_WARRANT_ZERO_7: '30A/360 (000/360)',
    ISIN_EMISE_WARRANT_ZERO_5: 'act/360 (000/360)',
    ISIN_EMISE_WARRANT_ZERO_11: 'act/365 (000/365)',
    ISIN_EMISE_WARRANT_ZERO_6: 'act/act (000/act) dle standardu BCK',
    ISIN_EMISE_WARRANT_ZERO_12: 'act/act (000/act) dle standardu ICMA',
    ISIN_EMISE_WARRANT_ZERO_JINA: 'jiný způsob',
    ISIN_EMISE_WARRANT_JINA: 'jiný způsob',
    ISIN_EMISE_WARRANT_KONEC_VYPORADANI: 'Způsob konečného vypořádání',
    ISIN_EMISE_WARRANT_KONEC_VYPORADANI_NATURAL: 'Naturální',
    ISIN_EMISE_WARRANT_KONEC_VYPORADANI_PENEZNI: 'Peněžní',
    ISIN_EMISE_WARRANT_KONEC_VYPORADANI_NEURCENO: 'Neurčeno',
    ISIN_EMISE_WARRANT_ZARUCENI: 'Informace o zaručení emise',
    ISIN_EMISE_WARRANT_ZARUCENI_ST: 'Státní',
    ISIN_EMISE_WARRANT_ZARUCENI_JS: 'Zaručená jiným subjektem',
    ISIN_EMISE_WARRANT_ZARUCENI_HZL: 'HZL/pohledávka',
    ISIN_EMISE_WARRANT_ZARUCENI_BEZ: 'Bez záruky',
    ISIN_EMISE_LIST_ZISK: 'Způsob použití zisku z výsledku hospodaření s majetkem fondu',
    ISIN_EMISE_LIST_ZISK_VF: 'Výnosové fondy',
    ISIN_EMISE_LIST_ZISK_AF: 'Akumulační fondy',
    ISIN_EMISE_LIST_ZISK_SF: 'Smíšené fondy',
    ISIN_EMISE_LIST_AKTIVA: 'Druhy aktiv, do kterých fond investuje',
    ISIN_EMISE_LIST_AKTIVA_N: 'Nemovitosti',
    ISIN_EMISE_LIST_AKTIVA_DN: 'Dluhové nástroje (fond investuje do dluhových nástrojů bez ohledu na jejich splatnost)',
    ISIN_EMISE_LIST_AKTIVA_A: 'Akcie',
    ISIN_EMISE_LIST_AKTIVA_VCP: 'Vyměnitelné cenné papíry',
    ISIN_EMISE_LIST_AKTIVA_S: 'Smíšené (fond investuje do různých aktiv)',
    ISIN_EMISE_LIST_AKTIVA_K: 'Komodity',
    ISIN_EMISE_LIST_AKTIVA_D: 'Deriváty',
    ISIN_EMISE_LIST_AKTIVA_RN: 'Referenční nástroje s vyloučením komodit',
    ISIN_EMISE_LIST_AKTIVA_U: 'Úvěry',
    ISIN_EMISE_LIST_AKTIVA_O: 'Ostatní (různé)',
    ISIN_EMISE_LIST_TYP_O: 'Otevřený',
    ISIN_EMISE_LIST_TYP_U: 'Uzavřený',
    ISIN_EMISE_LIST_TRIDA_FONDU: 'Vyplňte třídu PL dle statutu fondu',
    ISIN_EMISE_LIST_TRIDA_FONDU_TOOLTIP: 'Např. třída A CZK, třída B EUR',
    ISIN_EMISE_LIST_OMEZENI: 'Omezení pro investory',
    ISIN_EMISE_LIST_OMEZENI_RETAIL: 'PL (retailoví a/nebo kvalifikovaní/institucionální/profesionální investoři)',
    ISIN_EMISE_LIST_OMEZENI_KVALIF:
        'PL pro kvalifikované investory (jen kvalifikovaní/institucionální/profesionální investoři)',
    ISIN_EMISE_KOLEKTIVNI_ZKRACENY_NAZEV_HELP:
        'Jedná se o název investičních akcií SICAVu (IFPZK) nebo podfondu SICAVu (IFPZK) a pole je na max. 35 znaků včetně mezer.',
    ISIN_EMISE_KOLEKTIVNI_ZASADY: 'Zásady pro výplaty',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_V: 'Výnosové fondy (fond pravidelně rozděluje zisky z investic)',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_A: 'Akumulační fondy (fond zisky z investic obvykle reinvestuje)',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_S: 'Smíšené fondy (zisky z investic jsou částečně rozděleny a částečně reinvestovány)',
    ISIN_EMISE_KOLEKTIVNI_TYP: 'Typ cenného papíru a omezení pro investory',
    ISIN_EMISE_KOLEKTIVNI_TYP_RETAIL: 'Akcie (retailoví a/nebo kvalifikovaní/institucionální/profesionální investoři)',
    ISIN_EMISE_KOLEKTIVNI_TYP_KVALIF:
        'Akcie pro kvalifikované investory (jen kvalifikovaní/institucionální/profesionální investoři)',
    ISIN_EMISE_KOLEKTIVNI_NAV: 'NAV na jednu akcii',
    ISIN_EMISE_KOLEKTIVNI_NAV_DATUM: 'Datum kurzu NAV',
    ISIN_EMISE_SOUBORY_AKCIE_HELP: 'Vložte 2 soubory - výpis z OR a platné stanovy',
    ISIN_EMISE_SOUBORY_DLUHOPIS_HELP: 'Vložte emisní podmínky nebo obdobný dokument popisující cenný papír.',
    ISIN_EMISE_SOUBORY_JINY_HELP: 'Vložte dokument specifikující tento investiční nástroj.',
    ISIN_EMISE_SOUBORY_LIST_HELP: 'Vložte statut fondu nebo jiný dokument popisující investiční nástroj',
    ISIN_EMISE_SOUBORY_WARRANT_HELP: 'Vložte emisní podmínky nebo obdobný dokument popisující cenný papír.',
    STATUS: 'Status',
    ISIN_PODPIS_PODNADPIS: 'Zde vyplňte údaje o osobě, která podává žádost.',
    ISIN_PODPIS_PODAL: 'Žádost podal',
    VLOZTE_DOKUMENT: 'Vložte dokument',
    SOUBOR_CHYBA_PODPIS: 'Chybný podpis souboru, podepište jej, prosím, správným způsobem',
    SOUBOR_JINYSOUBOR_PODPIS: 'Nahrán jiný soubor, stáhněte si formulář k podpisu a podepsaný ho nahrajte',
    SOUBOR_CERTOSOBA_PODPIS: 'Přiložený certifikát neodpovídá uvedené osobě.',
    SOUBOR_JINAOSOBA_PODPIS: 'Pro daného uživatele jsou u jiné společnosti evidované rozdílné údaje. Prosím o kontrolu',
    SEZNAM_ISINU_ID_EMITENTA: 'ID emitenta (IČ)',
    SRD_DLAZDICE_NADPIS_SEZNAM: 'Seznam valných hromad a jiných akcí',
    SRD_DLAZDICE_DATUM_KONANI: 'Datum konání',
    SRD_DLAZDICE_ROZHODNY_DEN: 'Rozhodný den',
    SRD_DLAZDICE_VYPIS_AKCIONARU: 'Výpis akcionářů',

    SRD_NOVA_NADPIS: 'Emitent podává oznámení (žádost)',
    SRD_NOVA_OZNAMENI: 'Oznámení o',
    SRD_NOVA_OZNAMENI_HROMADA: 'Valná hromada',
    SRD_NOVA_OZNAMENI_JINA: 'Jiná akce',
    SRD_NOVA_OZNAMENI_ZADOST: 'Žádost o sdělení informací o totožnosti akcionáře',
    SRD_NOVA_ZPUSOB: 'Způsob zadání',
    SRD_NOVA_ZPUSOB_PRUVODCE: 'Průvodce',
    SRD_NOVA_ZPUSOB_PRUVODCE_BUTTON: 'Přejít na průvodce',
    SRD_STAHNOUT_XML: 'Stáhnout XML',
    SRD_NOVA_ZPUSOB_XML: 'XML',
    SRD_XML_ERR_NENALEZENO: 'Ověřte, že odpovídáte za správnou událost.',
    SRD_XML_ERR_PO_TERMINU: 'Již je po termínu, kdy lze hlasovat',
    SRD_XML_ERR_CHYBNY_UCET: 'Hlasování obsahuje chybný účet',
    SRD_XML_ERR_CHYBNA_OSOBA: 'Chybná osoba u účtu',
    SRD_XML_ERR_CHYBNE_HLASOVANI: 'Chybné hlasování (Nesedí např. počet hlasů)',

    SRD_CIS_UDALOST_VH: 'Oznámení o valné hromadě',
    SRD_CIS_UDALOST_VYPIS: 'Žádost o výpis',

    SRD_DETAIL_VYSLEDEK_VH: 'Výsledek VH',
    SRD_DETAIL_TL_VYPISODP: 'Stáhnout výpis',
    SRD_DETAIL_TL_VYPISZRUS: 'Zrušit výpis',
    SRD_DETAIL_TL_VHZRUS: 'Zrušit valnou hromadu',
    SRD_DETAIL_TL_VH: 'Změnit valnou hromadu',
    SRD_DETAIL_TL_VYPIS: 'Podat žádost o výpis',
    SRD_DETAIL_TL_VHODP: 'Stáhnout rozhodnutí',
    SRD_DETAIL_TL_VHODPZRUS: 'Zrušit rozhodnutí',
    SRD_DETAIL_TL_POT: 'Podat potvrzení oprávnění účasti na valné hromadě',
    SRD_DETAIL_TL_STR: 'Podat stvrzenku o hlasování na valné hromadě',
    SRD_DETAIL_TL_ZAP: 'Podat potvrzení o započtení hlasů',
    SRD_DETAIL_TL_VYSL: 'Podat oznámení o výsledku hlasování na valné hromadě',
    SRD_DETAIL_TL_JINA: 'Aktualizovat',
    SRD_DETAIL_INFO_VH: 'Vstupem je oznámení o valné hromadě dle ISO 20022 zprávy seev.001.001.11 MeetingNotification',
    SRD_DETAIL_INFO_VHZRUS:
        'Vstupem je zrušení oznámení o valné hromadě dle ISO 20022 zprávy seev.002.001.09 MeetingCancellation',
    SRD_DETAIL_INFO_VYPIS:
        'Vstupem je žádost o sdělení informací o totožnosti akcionáře dle ISO 20022 zprávy seev.045.001.04 ShareholdersIdentificationDisclosureRequest',
    SRD_DETAIL_INFO_VYPISZRUS:
        'Vstupem je zrušení žádosti o sdělení totožnosti akcionáře dle ISO 20022 zprávy seev.046.001.01 ShareholdersIdentificationDisclosureRequestCancellationAdvice',
    SRD_DETAIL_INFO_POT:
        'Vstupem je potvrzení oprávnění účasti na valné hromadě dle ISO 20022 zprávy seev.003.001.09 MeetingEntitlementNotification',
    SRD_DETAIL_INFO_STR:
        'Vstupem je stvrzenka o hlasování na valné hromadě dle ISO 20022 zprávy seev.006.001.10 MeetingInstructionStatus',
    SRD_DETAIL_INFO_ZAP:
        'Vstupem je potvrzení o započtení hlasů dle ISO 20022 zprávy seev.007.001.10 MeetingVoteExecutionConfirmation.',
    SRD_DETAIL_INFO_VYSL:
        'Vstupem je oznámení o výsledku hlasování na valné hromadě dle ISO 20022 zprávy seev.008.001.08 MeetingResultDissemination',
    SRD_DETAIL_INFO_JINA:
        'Vstupem je oznámení o jiné korporátní akci dle ISO 20022 zprávy seev.031.001.14 CorporateActionNotification',
    SRD_DETAIL_INFO_HLAS:
        'Vstupem je oznámení účasti a hlasování dle ISO 20022 zprávy seev.004.001.09 MeetingInstruction.',
    SRD_DETAIL_INFO_ZRUS: 'Vstupem je zpráva pro zrušení  seev.005.001.09 MeetingInstructionCancellationRequest.',

    SRD_PRUVODCE_VH_A: 'A. Specifikace emitenta',
    SRD_PRUVODCE_VH_B: 'B. Specifikace zprávy',
    SRD_PRUVODCE_VH_B_ID: 'Jedinečný identifikátor akce',
    SRD_PRUVODCE_VH_C: 'C. Specifikace valné hromady',
    SRD_PRUVODCE_VH_C_DATUM: 'Datum valné hromady (CET/CEST)',
    SRD_PRUVODCE_VH_C_TYPVH: 'Druh valné hromady',
    SRD_PRUVODCE_VH_C_TYPVH_XMET: 'Extraordinary',
    SRD_PRUVODCE_VH_C_TYPVH_GMET: 'General',
    SRD_PRUVODCE_VH_C_TYPVH_MIXD: 'Mixed',
    SRD_PRUVODCE_VH_C_TYPVH_SPCL: 'Special',
    SRD_PRUVODCE_VH_C_TYPVH_BMET: 'BondHolderMeeting',
    SRD_PRUVODCE_VH_C_TYPVH_CMET: 'CourtMeeting',
    SRD_PRUVODCE_VH_C_URLSCHUZKY: 'Jednotný lokátor zdroje (URL)',
    SRD_PRUVODCE_VH_C_MISTOKONANIVH: 'Místo konání valné hromady',
    SRD_PRUVODCE_VH_D: 'D. Účast na zasedání valné hromady',
    SRD_PRUVODCE_VH_D_PRIDAT: 'Přidat způsob účasti',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB: 'Způsob účasti akcionáře',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_MAIL: 'Correspondence',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHYS: 'InPerson',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHNV: 'NotVoting',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PRXY: 'Proxy',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_VIRT: 'Virtual',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_EVOT: 'ElectronicVoting',
    SRD_PRUVODCE_VH_D_PRIDAT_TYPFYZUCASTI: 'Způsob fyzické účasti na VH',
    SRD_PRUVODCE_VH_D_PRIDAT_NEPR:
        'Neutral proxy nominated by the issuer to execute votes on behalf of investors at the meeting.',
    SRD_PRUVODCE_VH_E_PRIDAT_PRAH: 'Základ prahu',
    SRD_PRUVODCE_VH_E_PRAH_ALSH: 'Celkový počet vydaných akcií ',
    SRD_PRUVODCE_VH_E_PRAH_ALSM: 'Celkový počet akcií zastoupených na valné hromadě účastníky',
    SRD_PRUVODCE_VH_E_PRAH_ALVO: 'Celkový počet odevzdaných hlasů pro usnesení',
    SRD_PRUVODCE_VH_D_PRIDAT_MASH: 'AllowedForShareholder',
    SRD_PRUVODCE_VH_D_PRIDAT_MAPO: 'AllowedOnBehalf',
    SRD_PRUVODCE_VH_D_PRIDAT_MAAL: 'AllowedWithAttendeeList',
    SRD_PRUVODCE_VH_D_PRIDAT_MALR: 'AllowedWithLetterOfRepresentation',
    SRD_PRUVODCE_VH_D_PRIDAT_MAHI: 'AllowedWithProof',
    SRD_PRUVODCE_VH_D_PRIDAT_MATK: 'AllowedWithTicket',
    SRD_PRUVODCE_VH_D_PRIDAT_MANP: 'NotPossible',
    SRD_PRUVODCE_VH_D_PRIDAT_PROXYTYPE: 'Typ proxe',
    SRD_PRUVODCE_VH_D_PRIDAT_CHRM: 'Chairman Chairman of the meeting is the proxy.',
    SRD_PRUVODCE_VH_D_PRIDAT_DISC: 'Discretionary Any type of proxy is allowed.',
    SRD_PRUVODCE_VH_D_PRIDAT_HLDR: 'SecurityHolder',
    SRD_PRUVODCE_VH_E: 'E. Pořad jednání',
    SRD_PRUVODCE_VH_E_PRIDAT: 'Přidat bod jednání',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT: 'Kvórum',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT_PROCENTA: 'Kvórum v procentech',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT_POCET: 'Kvórum počet ',
    SRD_PRUVODCE_VH_E_KVORUM_NE: 'Ne',
    SRD_PRUVODCE_VH_E_KVORUM_PROCENTA: 'V procentech',
    SRD_PRUVODCE_VH_E_KVORUM_POCET: 'Počet',
    SRD_PRUVODCE_VH_E_PRIDAT_ISSSRLABL: 'Jedinečný identifikátor bodu pořadu jednání',
    SRD_PRUVODCE_VH_E_PRIDAT_TITL: 'Název bodu pořadu jednání',
    SRD_PRUVODCE_VH_E_PRIDAT_TITL_EN: 'Název bodu pořadu jednání - en',
    SRD_PRUVODCE_VH_E_PRIDAT_INF: 'Informace o bodu',
    SRD_PRUVODCE_VH_E_PRIDAT_FORINFOONLY: 'Informativní bod',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP: 'Hlasování',
    SRD_PRUVODCE_VH_E_SUCCESS: 'Hlasování proběhlo úspěšně',
    SRD_PRUVODCE_VH_E_CHYBA_HODNOTY: 'Chyba hodnoty',
    SRD_PRUVODCE_VH_E_CHYBA_MAX: 'Nejde zadat vyšší než maximální počet',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_LHUTA: 'Lhůta pro hlasování uplynula',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_NEHLASOVANO: 'Nehlasováno',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_HLASOVANO: 'Hlasováno',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_ROZP: 'Rozpracováno',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_ADVI: 'Poradní hlasování',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_BNDG: 'Závazné hlasování',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_OPTIONS: 'Možnosti hlasování',
    SRD_PRUVODCE_VH_E_HLASOVAT_OD: 'Hlasovat lze od:',
    SRD_PRUVODCE_VH_E_TERMIN: 'Termín hlasování',
    SRD_PRUVODCE_VH_E_PRIDAT_HLASOVANI: 'Alternativní způsoby hlasování',
    SRD_PRUVODCE_VH_E_PRIDAT_NOSUBMIT: 'Nebyli zapsána všechna pole. Opravdu chcete pokračovat?',
    ADVI: 'Poradní hlasování',
    BNDG: 'Závazné hlasování',
    ABST: 'Zdržet se',
    CAGS: 'Hlasovat proti',
    CHRM: 'Hlasovat s předsedou',
    CFOR: 'Hlasovat pro',
    NOAC: 'Nehlasovat',
    WTHH: 'Zadržet hlas',
    ONEY: 'Jeden rok',
    THRY: 'Tři roky',
    TWOY: 'Dva roky',
    BLNK: 'Prázdný hlas - započítaný',
    NREC: 'Bez doporučení',
    AMGT: 'Hlasovat proti managementu',
    DISC: 'Diskreční',
    WMGT: 'With management	Hlasovat s managementem',
    NULL: 'Bez Hodnoty',

    SRD_PRUVODCE_VYPIS_MEZNIDATUM: 'Nejzazší lhůta emitenta',
    SRD_PRUVODCE_VYPIS_MEZNIDATUM_CET: 'Nejzazší lhůta emitenta',
    AKCIONAR: 'Akcionář',
    AKCIONAR_PRIPOJENI: 'Připojení majetkového účtu',
    AKCIONAR_PRIPOJENI_TXT:
        'Na základně SRD2 máte právo být informován emitentem o akcích u vám vlastněných akcií. Pro získání přístupu se musíte přihlásit do aplikace Můj depozit. Jestli nemáte založený učet, tak si ho můžete založit. Potvrzení navázaní daného majetkového učtu na daný učet proběhne pomocí SMS zprávy.',
    AKCIONAR_PRIPOJENI_400: 'Neplatný odkaz. Pro zadané URL nelze přihlásit majetkový účet.',
    AKCIONAR_PRIPOJENI_401: 'Majetkový učet byl již aktivován.',
    AKCIONAR_PRIPOJENI_USPECH: 'Proběhlo úspěšné přidání majetkového účtu',
    AKCIONAR_REGISTRACE_ERROR_TITLE: 'Čeká se na potvrzení e-mailu',
    AKCIONAR_REGISTRACE_ERROR_TEXT1:
        'Pro úspěšné dokončení registrace je potřeba aktivovat učet pomocí odkazu, který Vám byl odeslán na e-mail uvedený při registraci.',
    AKCIONAR_REGISTRACE_ERROR_TEXT2: 'Po aktivaci bude pokračovat dále v procesu. Neopouštějte stránku.',
    AKCIONAR_SMS_ZNOVU: 'Poslat SMS znovu',
    AKCIONAR_SMS_ODESLAT_ERR: 'Nepodařilo se odeslat SMS',
    AKCIONAR_PROFIL_MAJETKOVY_UCET: 'Majetkový účet',
    AKCIONAR_ZADNE_UDALOSTI: 'Žádné události nejsou k dispozici',
    AKCIONAR_HLASOVANI_POCET: 'Hlasováno / Počet celkem:',
    AKCIONAR_HLASOVANI_MAXPOCET: 'Hlasovat za celkový počet hlasů',
    AKCIONAR_MAXPOCET_ZMENA_ERR: 'Hodnota musí být větší než 1 a menší než {{maxPocet}}',
    AKCIONAR_MAXPOCET_SUBMIT_ERR: 'Jeden nebo více bodů přesahují maximální počet hlasů',
    AKCIONAR_PREDANO: 'Předáné emitentovi',
    AKCIONAR_POTVRDZENO: 'Potvrzeno emitentem',

    VH: 'Valná hromada',
    VYSL: 'Výsledky hlasování na valné hromadě',
    JINA: 'Jiná korporátní akci',
    VYPIS: 'Výpis akcionářů',

    KORPORATNI_AKCE: 'Korporátní akce',
    KORPORATNI_SRD: 'Služby SRD II',
    KORPORATNI_AKCE_ROZHODNY_DEN: 'Rozhodný den',
    KORPORATNI_AKCE_ROZPRACOVANO: ' - Rozpracováno',
    NOVA_UDALOST: 'Nová událost',
    DORUCENO_ODESLANO: 'Doručeno/Odesláno',

    TYPE_VH: 'Oznámeni o valné hromadě',
    TYPE_VHODP: 'Reakce na oznámení valné hromady',
    TYPE_VHZRUS: 'Zrušení oznámení o valné hromadě',
    TYPE_VYPIS: 'Žádost o výpis',
    TYPE_VYPISODP: 'Odpověď na výpis',
    TYPE_VYPISZRUS: 'Zrušení výpisu',
    TYPE_POT: 'Potvrzení oprávnění účasti na valné hromadě',
    TYPE_STR: 'Stvrzenka o hlasování na valné hromadě',
    TYPE_ZAP: 'Potvrzení o započtení hlasů',
    TYPE_VYSL: 'Oznámení o výsledku hlasování na valné hromadě',
    TYPE_JINA: 'Oznámení o jiné korporátní akci',
    MEPOZADAVKY: 'Mé požadavky',
    NEUSPREVODY: 'Neúspěšné převody',
    NEUSUPISY: 'Neúspěšné úpisy',
    NEUSNAVYSENI: 'Neúspěšné navýšení',
    NOVENAVYSENI: 'Nové navýšení',
    NOVYPREVOD: 'Nový převod',
    NOVYUPIS: 'Nový úpis',
    USPESNEPREVODY: 'Úspěšné převody',
    USPESNENAVYSENI: 'Úspěšné převody',
    USPESNEUPISY: 'Úspěšné úpisy',
    DOSUDNEODESLANE: 'Dosud neodeslané',
    EVIDOVANEVCDCP: 'Evidované v CDCP',
    SPECIALNI: 'Speciální služby',
    DUVERNAOBLAST: 'Důvěrné informace',
    EMISECENNYCHPAPIRU: 'Služby důvěrné oblasti',
    INFORMACEZAUPLATU: 'Hodnoty CP - průměry',
    NAVYSENI: 'Navýšení',
    PRVOTNIUPIS: 'Primární úpis',
    PREVODZTECHUCTU: 'Převod z technického účtu',
    SLUZBYPRONE: 'Služby pro navazující evidenci',
    UCTYVLASTNIKA: 'Účty vlastníka',
    WRSPRAVA: 'Správa uživatelů',
    WRUZIVATELE: 'Uživatelé',
    WRNOVYUZIVATEL: 'Nový uživatel',
    WRSEZNAMUZIVATELU: 'Seznam uživatelů',
    WRSPRAVATITL: 'Správa uživatelů',
    SLUZBY_ISIN: 'Služby ISIN',
    F15: 'F15',
    F16: 'F16',
    F17: 'F17',
    F18: 'F18',
    F24: 'F24',
    F5: 'F5',
    F6: 'F6',
    F7: 'F7',
    F8: 'F8',
    F20: 'F20',
    F50: 'F50',
    F52: 'F52',
    F53: 'F53',
    F56: 'F56',
    F58: 'F58',
    DALSIINFOMRACE: 'Další informace',
    DALSI_UDAJE: 'Další údaje',
    PXKLIC: 'PX Klíč',
    PXKLIC_TITLE:
        'Nepodařilo se potvrdit přihlášení do aplikace Můj depozitář v požadovaném čase pomocí aplikace PX Klíč.',
    PXKLIC_TEXT1:
        'V případě, že se nezobrazila notifikace v aplikaci PX Klíč, zkontroluje připojení k internetu a znovu se přihlaste.',
    PXKLIC_TEXT2:
        'V případě, že internet funguje, ověřte, že v PX Klíč je v sekci aplikace v seznamu Aplikace s autorizací uvedeno: Můj depozitář.',
    PXKLIC_TEXT3: 'V případě, že není, tak může pomoci tlačítka „Pokračovat“ požádat o zaslání autorizačního kódu.',
    PXKLIC_SMS_ODESLAN: 'Byl vám odeslán SMS kód na telefonní číslo:',
    PXKLIC_ODELSAT_CONFIRM: 'Opravdu si přejete zaslat nový autorizační kód pro autorizaci mobilní aplikace PX Klíč?',
    BANK_ID: 'Bank ID',
    VYPIS_Z_UCTU: 'Výpis z účtu v nezařazené evidenci',
    NEZARAZENY_UCET: 'Nezařazený účet',
    PRIHLASIT_SE_PPRES_BANKID: 'Přihlásit se přes Bank ID',
    PODMINKY_PRO_ZISKANI_VYSTUPU: 'Podmínky pro získání výpisu:',
    PROVEDENI_OBJEDNAVKY: 'Provedení objednávky',
    PREDANI_RODNEHO_CISLA: 'Předání rodného čísla pomoci BANK ID',
    CELE_JMENO: 'Celé jméno',
    ZADAM_O_VYPIS: 'Žádám o výpis z účtu nezařazené evidence',
    CELKOVA_CASTKA: 'Celková částka',
    SOUHLASIM_S_OBCHODNIMI_PODMINKAMI: 'Souhlasím s obchodními podmínkami',
    SOUHLASIM_S: 'Souhlasím s ',
    OBCHODNIMI_PODMINKAMI: 'obchodními podmínkami',
    ZADOST_BYLA_ODESLANA: 'Žádost o výpis pro Vaší osobu byla úspěšně odeslána.',
    O_ZPRACOVANI_BUDETE_INFORMOVANI: 'O zpracování žádosti budete informováni e-mailem.',
    POTVRDIT_SOUHLAS: 'Prosíme potvrďte souhlas',

    LOREM_IPSUM:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.',

    ME_POZADAVKY_DATUM1_POZADOVANE: 'Požadované datum výpisu',
    ME_POZADAVKY_PREHLED: 'Přehled přístupů k odpovědi',
    ME_POZADAVKY_DATUM1: 'Datum od',
    ME_POZADAVKY_DATUM2: 'Datum do',
    ME_POZADAVKY_DATUM2_DUALNI: 'Datum pro duální výpis',
    ME_POZADAVKY_IDENTIFIKATOR_MAJITELE: 'Identifikátor majitele',
    ME_POZADAVKY_IDENTIFIKATOR_OSOBYCDCP: 'Identifikátor osoby v CDCP',
    ME_POZADAVKY_KATEGORIE: 'Kategorie výstupu',
    ME_POZADAVKY_KATEGORIE_A: 'Správci',
    ME_POZADAVKY_KATEGORIE_S: 'Majitel / Správce (pokud je u účtu veden správce, informace o majiteli není uvedena)',
    ME_POZADAVKY_KATEGORIE_B: 'Majitelé a správci (výpis obsahuje informaci o všech majitelích a správcích)',
    ME_POZADAVKY_KATEGORIE_TYP: 'Typ výstupních dat',
    ME_POZADAVKY_DRUH_VYPISU: 'Označení emise',
    ME_POZADAVKY_KATEGORIE_MAJITELE: 'Kategorie majitele',
    ME_POZADAVKY_CISLO_ZNACKA: 'Spisova značka',
    ME_POZADAVKY_CISLO_JEDNACI_ZNACKA: 'Číslo jednací / Spisova značka',
    ME_POZADAVKY_CISLO_JEDNACI: 'Číslo jednací',
    ME_POZADAVKY_INDENTIFIKACE_SOUDU: 'Identifikace soudu',
    ME_POZADAVKY_CISLO_PPN: 'Číslo PPN',
    ME_POZADAVKY_CISLO_ZMLUVY: 'Číslo zástavní smlouvy',
    ME_POZADAVKY_IDIC_VERITEL: 'Id.č. zástav. věřitele',
    ME_POZADAVKY_IDIC_MAJITEL_SHORT: 'Id. č. majitele',
    ME_POZADAVKY_IDIC_DLUZNIK: 'Id.č. zástav. dlužníka',
    ME_POZADAVKY_IDIC_SUBJPPN: 'Id.č. subjektu, pro který je reg. PPN',
    ME_POZADAVKY_IDIC_SPRAVCE: 'Id.č. správce účtu',
    ME_POZADAVKY_IDIC_MAJITEL: 'Id.č. majitele / Rodné číslo',
    ME_POZADAVKY_IDIC_MAJITEL2: 'Id číslo majitele',
    ME_POZADAVKY_IDIC_OBECNY_SUBJ: 'Obecný subjekt',
    ME_POZADAVKY_ID1: 'Číslo první zástavy',
    ME_POZADAVKY_ID2: 'Číslo druhé zástavy',
    ME_POZADAVKY_ROLE: 'Role subjektu',
    ME_POZADAVKY_PREDCISLI_UCTU: 'Předčíslí účtu',
    ME_POZADAVKY_INDENTIFIKATOR_SPRAVCE: 'Identifikátor správce',
    ME_POZADAVKY_TITLE: 'Vybrané požadavky',
    ME_POZADAVKY_DETAIL_TITLE: 'Zadané vstupní parametry',
    ME_POZADAVKY_DETAIL_POZADAVEK: 'Požadavek',
    ME_POZADAVKY_JEN_MOJE: 'Jen moje požadavky',
    ME_POZADAVKY_PRIJMENO: 'Příjmení/1.část názvu',
    ME_POZADAVKY_JMENO: 'Jméno/2.část názvu',
    ME_POZADAVKY_ID_SUBJEKTU: 'ID subjektu (IČ)',
    ID_SUBJEKTU: 'ID subjektu',
    ME_POZADAVKY_ZADOST_TYP_1: 'Žádost o zobrazení odpovědí ve formátu XML',
    ME_POZADAVKY_ZADOST_TYP_2: 'Žádost o zobrazení odpovědí ve formátu PDF',
    ME_POZADAVKY_ZADOST_TYP_3: 'Žádost o zobrazení odpovědí ve formátu HTML',
    ME_POZADAVKY_ZADOST_TYP_4: 'Žádost o zobrazení odpovědí ve formátu ZIP',
    ZRUSENI_POZADAVKU: 'Zrušení požadavku',
    ZRUSENI_POZADAVKU_OK: 'Zrušení probehlo úspěšné',
    STAHNOUT_ZIP: 'Stáhnout ZIP',
    VYMAZAT_FILTR: 'Vymazat filtr',
    FILTROVAT: 'Filtrovat',
    PODANO_OD: 'Podáno od',
    PODANO_DO: 'Podáno do',
    KOD_SLUZBY: 'Kód služby',
    STAHNOUT_HTML: 'Stáhnout HTML',
    LEI_SEZNAM: 'Seznam všech vydaných LEI: ',
    IDENTIFIKATOR: 'Identifikátor',
    VYJADRENI: 'Vyjádření',
    DUVERNE_INFO_PODATUM: 'Průměry vypočteny až po datum',
    DUVERNE_INFO_POZADOVANY_DEN: 'Požadovaný den výpočtu',
    DUVERNE_INFO_ISIN_BUTTON: 'Vybrat ISIN',
    DUVERNE_INFO_BILL_WARNING:
        'Na tuto službu nemáte předplatné. Potvrzením požadavku souhlasíte s fakturováním služby.',
    DUVERNE_INFO_TITLE_F1A:
        'F1A - Výpočet průměrné ceny z obchodů kótovanými účastnickými cennými papíry za období 1 měsíce',
    DUVERNE_INFO_TITLE_F1:
        'F1 - Výpočet průměrné ceny z obchodů kótovanými účastnickými cennými papíry za období 6 měsíců',
    DUVERNE_INFO_TITLE_F3: 'F3 - Hodnoty cenných papírů pro oceňování majetku fondů',
    DUVERNE_INFO_TITLE_F30: 'F30 - Zjištění čísla majetkového účtu vedeného v centrální nebo navazující evidenci',
    DUVERNE_INFO_TITLE_F5: 'F5 - Výpis zástavních práv k zadanému datu',
    DUVERNE_INFO_TITLE_F6: 'F6 - Výpis platných PPN na CP k zadanému datu na účtu majitele',
    DUVERNE_INFO_TITLE_F7: 'F7 - Výpis správce účtu a účtů ve správě k zadanému datu',
    DUVERNE_INFO_TITLE_F8: 'F8 - Výpis z evidence zástav a blokací zastavených CP k danému datu',
    DUVERNE_INFO_TITLE_F9: 'F9 - Výpis z účtu majitele k zadanému datu (včetně zástav a PPN)',
    DUVERNE_INFO_TITLE_F12: 'F12 - Výpis z emise (bez zástav) k zadanému datu',
    DUVERNE_INFO_TITLE_F13: 'F13 - Výpis z emise vč.zástav a PPN k zadanému datu',
    DUVERNE_INFO_TITLE_F14: 'F14 - Výpis z emise (včetně zástav, PPN a majetkových účtů k zadanému datu)',
    DUVERNE_INFO_TITLE_F15: 'F15 - Výpis změn majitelů emise mezi dvěma daty (s uvedením protistrany)',
    DUVERNE_INFO_TITLE_F16: 'F16 - Výpis změn majitelů emise mezi dvěma daty (bez uvedení protistrany)',
    DUVERNE_INFO_TITLE_F17: 'F17 - Výpis změn na účtu/účtech majitele mezi dvěma daty (s uvedením protistrany)',
    DUVERNE_INFO_TITLE_F18: 'F18 - Výpis změn na účtu/účtech majitele mezi dvěma daty (bez uvedení protistrany)',
    DUVERNE_INFO_TITLE_F20: 'F20 - Výpis historie změn evidenčních údajů majitele účtu mezi dvěma daty',
    DUVERNE_INFO_TITLE_F24: 'F24 - Vyhledání čísla účtu',
    DUVERNE_INFO_TITLE_F25: 'F25 - Výpis změn majitelů emise mezi dvěma daty (s uvedením protistrany)',
    DUVERNE_INFO_TITLE_F26: 'F26 - Výpis změn majitelů emise mezi dvěma daty (bez uvedení protistrany)',
    DUVERNE_INFO_TITLE_F27: 'F27 - Výpis změn na účtu majitele mezi dvěma daty (s uvedením protistrany)',
    DUVERNE_INFO_TITLE_F28: 'F28 - Výpis změn na účtu majitele mezi dvěma daty (bez uvedení protistrany)',
    DUVERNE_INFO_TITLE_F37: 'F37 - Výpis z emise (včetně zástav, PPN a peněžních účtů)',
    DUVERNE_INFO_TITLE_F38: 'F38 - Informace pro zajištění předčasného splacení',
    DUVERNE_INFO_TITLE_F39:
        'F39 - Informace o vlastnících pro plnění informační povinnosti o fondovém kapitálu administrátory fondů',
    DUVERNE_INFO_TITLE_F50: 'F50 - Výpis osobních údajů o subjektu k danému datu',
    DUVERNE_INFO_TITLE_F52: 'F52 - Výpis historie subjektu v daném intervalu',
    DUVERNE_INFO_TITLE_F53: 'F53 - Výpis účtů majitele k danému datu',
    DUVERNE_INFO_TITLE_F56: 'F56 - Výpis historie zástavní smlouvy v daném intervalu',
    DUVERNE_INFO_TITLE_F58: 'F58 - Výpis historie PPN v daném intervalu',
    DUVERNE_INFO_TOOLTIP_DTVP:
        'Datum lze zadat do budoucnosti. Takto zadaná služba bude odeslána ke zpracování až den po zadaném datu.',
    DUVERNE_INFO_TOOLTIP_DTDV:
        'Pokud je vyplněné datum, tak vznikne tzv. duální výpis, to znamená, že dotaz bude zpracován pro obě zadaná data.',
    DUVERNE_INFO_DTVP: 'Výpis požadován k datu',
    DUVERNE_INFO_NEPOVINNE_ERR: 'Alespoň jeden z nepovinných parametrů musí být vyplněn',
    LEI_UPDATE_CONFIRM: 'Chcete aktualizovat LEI?',
    LEI_CONTACT_UPDATE_CONFIRM: 'Chcete aktualizovat kontaktní údaje?',
    LEI_AKTUALIZACE_TITLE: 'Žádost o aktualizaci Legal Entity Identifier (LEI)',
    LEI_ROZCESTNIK_TITLE: 'Žádost o registraci Legal Entity Identifier (LEI)',
    LEI_ROZCESTNIK_TEXT1:
        'Před vyplněním žádosti o registraci LEI se ujistěte, že společnost již nemá tento identifikátor přidělen nebo nebylo o registraci požádáno u jiného operátora.',
    LEI_ROZCESTNIK_CHOOSE: 'Vyberte kategorii osoby:',
    LEI_ROZCESTNIK_CHOOSE_SUB: 'Vyberte podkategorii osoby:',
    LEI_DISSOLUTION: 'Dissolution',
    LEI_TYP_ZMENY: 'Typ změny',
    LEI_SUCCESSOR_ENTITY: 'Nástupnická společnost LEI',
    LEI_SUCCESSOR_ENTITY_NAME: 'Nástupnická společnost název',
    LEI_ZRIZOVATEL: 'LEI Zřizovatele',
    LEI_GENERAL: 'OSTATNÍ / GENERAL',
    LEI_FUND: 'FOND / FUND',
    LEI_RESIDENT_GOVERNMENT_ENTITY: 'SUBJEKT STÁTNÍ SPRÁVY / RESIDENT GOVERNMENT ENTITY',
    LEI_SUBCATEGORY: 'Subcategory',
    LEI_INTERNATIONAL_ORGANIZATION: 'MEZINÁRODNÍ ORGANIZACE / INTERNATIONAL ORGANIZATION',
    LEI_BRANCH: 'ODŠTĚPNÝ ZÁVOD / BRANCH',
    LEI_SOLE_PROPRIETOR: 'PODNIKAJÍCÍ FYZICKÁ OSOBA / SOLE PROPRIETOR',
    CENTRAL_GOVERNMENT: 'ÚSTŘEDNÍ SPRÁVNÍ ORGÁNY / CENTRAL GOVERNMENT',
    STATE_GOVERNMENT: 'FEDERATIVNÍ SPRÁVNÍ ORGÁNY / STATE GOVERNMENT',
    LOCAL_GOVERNMENT: 'MÍSTNÍ SAMOSPRÁVA / LOCAL GOVERNMENT',
    SOCIAL_SECURITY: 'SYSTÉM SOCIÁLNÍHO ZABEZPEČENÍ / SOCIAL SECURITY',
    LEI_GENERAL_BR: 'OSTATNÍ br() GENERAL',
    LEI_FUND_BR: 'FOND br() FUND',
    LEI_RESIDENT_GOVERNMENT_ENTITY_BR: 'SUBJEKT STÁTNÍ SPRÁVY br() RESIDENT GOVERNMENT ENTITY',
    LEI_INTERNATIONAL_ORGANIZATION_BR: 'MEZINÁRODNÍ ORGANIZACE br() INTERNATIONAL ORGANIZATION',
    LEI_BRANCH_BR: 'ODŠTĚPNÝ ZÁVOD br() BRANCH',
    LEI_SOLE_PROPRIETOR_BR: 'PODNIKAJÍCÍ FYZICKÁ OSOBA br()  SOLE PROPRIETOR',
    CENTRAL_GOVERNMENT_BR: 'ÚSTŘEDNÍ SPRÁVNÍ ORGÁNY br()  CENTRAL GOVERNMENT',
    STATE_GOVERNMENT_BR: 'FEDERATIVNÍ SPRÁVNÍ ORGÁNY br()  STATE GOVERNMENT',
    LOCAL_GOVERNMENT_BR: 'MÍSTNÍ SAMOSPRÁVA br() LOCAL GOVERNMENT',
    SOCIAL_SECURITY_BR: 'SYSTÉM SOCIÁLNÍHO ZABEZPEČENÍ br() SOCIAL SECURITY',
    CENTRAL_GOVERNMENT_SUB_NAPR: 'Např.: ministerstva, NBÚ, ČTÚ, ÚOHS, ERÚ, RRTV, SÚJB, atp.',
    CENTRAL_GOVERNMENT_SUB: 'Ústřední správní orgány s celostátní působností a neziskové organizace jimi ovládané.',
    STATE_GOVERNMENT_SUB_NAPR: 'Např.: spolkové země v Německu či Rakousku.',
    STATE_GOVERNMENT_SUB:
        'Správní orgány ve federativním státním uspořádání, které vykonávají svou působnost na úrovni nižší než je ústřední a vyšší než místní. Jde o správní orgány, které vykonávají svou daňovou, zákonodárnou a výkonnou moc na území jednotlivých států, na které může být země rozdělena. V některých, zejména malých, zemích jednotlivé státy a státní vlády nemusí existovat.',
    LOCAL_GOVERNMENT_SUB_NAPR: 'Např.: kraje, města či obce.',
    LOCAL_GOVERNMENT_SUB:
        'Místní správa (samospráva) jako samostatné správní útvary. Rozsah působnosti je obecně mnohem menší než ústřední či státní veřejné moci a nemusí být oprávněny ukládat daně či poplatky pro své rezidenty.',
    SOCIAL_SECURITY_SUB_NAPR: 'Např.: zdravotní pojišťovny, ČSSZ, atp.',
    SOCIAL_SECURITY_SUB:
        'Systémy sociálního zabezpečení zahrnující celou společnost nebo podstatnou část společnosti a jsou uloženy a kontrolovány veřejnou mocí. O systémy sociálního zabezpečení se jedná tehdy, pokud jsou organizačně odděleny od ostatních činností veřejné moci, drží svá aktiva a pasiva odděleně a vystupují ve finančních transakcích na vlastní účet.',
    LEI_GENERAL_TEXT: 'Kategorii osoby zvolte, pokud žadatel nespadá do žádné z uvedených kategorií.',
    LEI_FUND_TEXT:
        'Kategorii osoby zvolte, pokud je žadatel investičním fondem nebo akciovou společností s proměnným základním kapitálem (SICAV).',
    LEI_FUND_TEXT3:
        'Vždy je nutné vyplnit alespoň jeden vztah s investiční společností, která je obhospodařovatelem fondu (v případě samostatně spravovaného fondu bude žadatel o LEI uveden i ve vztahu: Investiční společnost (Obhospodařovatel fondu).',
    LEI_FUND_TEXT2:
        'FOND může požádat o přidělení LEI kódu pouze v případě, že má LEI kód přidělen i subjekt, který je obhospodařovatelem fondu nebo fondem jemu nadřazeným.',
    LEI_FUND_TEXT1:
        'S účinností od 1. 4. 2022 mají všechny investiční fondy žádající o přidělení LEI povinnost uvést a doložit kompletní strukturu vztahů mezi žadatelem a nadřazenými subjekty (obhospodařovatel fondu, nadřazený fond), a to na základě nařízení Global Legal Entity Identifier Foundation (GLEIF).',
    LEI_BRANCH_TEXT2:
        'Odštěpný závod / BRANCH může požádat o přidělení LEI pouze v případě, že má LEI kód přidělen i zahraniční (mateřská) společnost, která je zřizovatelem.',
    LEI_BRANCH_TEXT:
        'Kategorii osoby zvolte, pokud je žadatel trvalou pobočkou zahraniční právnické osoby, zapsané v obchodním rejstříku dané jurisdikce. Jedná se o osobu bez právní subjektivity, tj. do všech právních vztahů vstupuje zahraniční (mateřská) společnost.',
    LEI_SOLE_PROPRIETOR_TEXT:
        'Kategorii osoby zvolte, pokud je žadatel provozován/vlastněn jednou osobou a neexistuje v něm žádný právní rozdíl mezi majetkem a závazky vlastníka a podnikatelským subjektem.',
    LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT2:
        'Státem vlastněný, ale nezávislý obecný právní subjekt nebo fond, který není součástí instituce veřejné moci nebo jí není kontrolován, nepatří do kategorie Subjekt státní správy, ale spíše do kategorie Ostatní nebo Fond.',
    LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT:
        'Kategorii osoby zvolte, pokud je žadatel netržním subjektem, který je součástí ústřední, státní nebo místní veřejné moci, případně fondem sociálního zabezpečení nebo neziskovou institucí kontrolovanou vládní institucí.',
    LEI_INTERNATIONAL_ORGANIZATION_TEXT:
        'Kategorii zvolte, pokud je žadatel subjektem zřízeným na základě mezinárodní dohody tří a více států za účelem realizace společných cílů. Organizace má vlastní mezinárodní subjektivitu, tj. jedná svým jménem prostřednictvím interně zřízených řídících orgánů.',
    REJSTRIK_KOD: 'Kód  - Rejstřík (v rámci dané jurisdikce)',
    REJSTRIK_NAZEV: 'Rejstřík název',
    LEI_ICO: 'Identifikační číslo osoby (IČO)',
    FAILED_ATTEMPTS_ERR: 'Příliš mnoho neúspěšných pokusů o přihlášení, zkuste to prosím znovu za 5 minut',
    LEI_OSOBA_TITLE: 'Specifikace právnické osoby',
    LEI_OSOBA_UPLOAD_TEXT:
        'V případě, že žádost vyplňujete jako pověřená osoba, připojte prosím kopii plné moci za účelem přidělení LEI podepsané oprávněnou osobou.',
    LEI_OSOBA_UPLOAD_TOOLTIP:
        'Uveďte odkaz nebo přiložte dokument prokazující oprávněnost uvedené osoby jednat jménem společnosti. V dokumentu musí být uvedeno jméno a pozice oprávněné osoby. V případě, že přiložený dokument nebude obsahovat požadované informace, nebude možné Žádost o přidělení LEI/Aktualizaci LEI zpracovat.',
    LEI_DETAIL_INFO_TITLE: 'Detailní informace o společnosti žádající o přidělení LEI',
    LEI_DETAIL_INFO_TITLE_TABLE: 'Informace o společnosti',
    LEI_DETAIL_JINY: 'Jiný název právnické osoby / společnosti',
    LEI_DETAIL_JINY_TRANS: 'Název právnické osoby/společnosti (Anglicky)',
    LEI_DETAIL_PRAVFORMA: 'Právní forma - KÓD',
    LEI_DETAIL_PRAV_NENALEZENO: 'Právní forma',
    LEI_DETAIL_DATUM_SPOL_FUND: 'Datum založení fondu',
    LEI_DETAIL_STATUS: 'Status',
    LEI_DETAIL_DATUM_SPOL: 'Datum založení právnické osoby / společnosti',
    LEI_DETAIL_DATUM_SPOL_TOOLTIP: 'Zde uveďte datum založení společnosti dle veřejného rejstříku.',
    LEI_VZNIKSPOLECNOSTI_ERR: 'Chybí datum založení společnosti, změňte údaje o společnosti',
    LEI_UPDATE_DATA_ERR: 'Nelze odeslat stejné hodnoty jako hodnoty uložené v cdcp',
    LEI_DETAIL_ADRESA_TITLE: 'Adresa sídla',
    LEI_DETAIL_ADRESA_TITLE_UPDATE: 'Adresa sídla - původní',
    LEI_DETAIL_ADRESA_HQ_FUND_VARIANTA: 'Adresa investiční společnosti (Obhospodařovatel fondu) - jazyková varianta',
    LEI_DETAIL_ALT_JAZYK: 'Alternativní jazyková varianta',
    LEI_DETAIL_ADRESA_SHODUJE: 'Adresa centrály se shoduje',
    LEI_DETAIL_ADRESA_HQ: 'Adresa centrály',
    LEI_DETAIL_ADRESA_HQ_UPDATE: 'Adresa centrály - původní',
    LEI_DETAIL_ADRESA_HQ_FUND_UPDATE: 'Adresa investiční společnosti (Obhospodařovatel fondu) - původní',
    LEI_DETAIL_ADRESA_HQ_FUND: 'Adresa investiční společnosti (Obhospodařovatel fondu)',
    LEI_DETAIL_ADRESA_TITLE_VARIANTA: 'Adresa sídla - jazyková varianta',
    LEI_DETAIL_ADRESA_HQ_VARIANTA: 'Adresa centrály - jazyková varianta',
    LEI_DETAIL_KOD_JAZYKA: 'Jazyk',
    LEI_DETAIL_MAT_TITLE: 'Detailní informace o přímé mateřské společnosti',
    LEI_AKTUALIZACE_OPRAVNENI_SUB_ZAHRANICNI: 'Vložte přílohu s oprávněním.',
    LEI_DETAIL_MAT_TITLE_BRANCH:
        'Detailní informace o zahraniční společnosti, která je zřizovatelem odštěpného závodu.',
    LEI_VLOZTE_REJSTRIK: 'Vložte prosím výpis z veřejného rejstříku, ne starší než 3 měsíce',
    LEI_VLOZTE_MAT:
        'Vložte: Výroční zprávu mateřské společnosti, konsolidovanou účetní závěrku nebo jiné dokumenty, dle kterých bude možné ověřit vztah mateřské a dceřiné společnosti',
    LEI_DETAIL_MAT_SUBTEXT: 'Přímou mateřskou společností nemůže být sám žadatel o LEI',
    LEI_DETAIL_MAT_TEXT3:
        'V tomto případě vyberte „Ne, neuvedu přímou mateřskou společnost, která sestavuje konsolidovanou účetní závěrku.“ -> Důvod: „Neexistuje konsolidace“.',
    LEI_DETAIL_MAT_TEXT2:
        'Mateřskou společnost uveďte pouze v případě, že je společnost součástí konsolidačního celku. Neuvádějte mateřskou společnost, která vykonává kontrolu, ale nesestavuje konsolidovanou účetní závěrku.',
    LEI_DETAIL_MAT_TEXT:
        'Přímou konsolidovanou mateřskou společností se rozumí ovládající právnická osoba nejnižší úrovně, která sestavuje konsolidovanou účetní závěrku v souladu s účetními pravidly platnými pro mateřskou společnost.',
    LEI_DETAIL_MAT_SELECT: 'Má společnost přímou mateřskou společnost, která sestavuje konsolidovanou účetní závěrku?',
    LEI_DETAIL_MAT_SELECT_BRANCH: 'Má společnost International branch of?',
    LEI_DETAIL_MAMATKA: 'Má přímá mateřská společnost LEI?',
    LEI_DETAIL_MAMATKA_BRANCH: 'Má International branch of společnost LEI?',
    LEI_DETAIL_MATKA_DATUM: 'Datum - začátek konsolidace',
    LEI_DETAIL_MATKA_PODIL: 'Podíl na společnosti %',
    LEI_DETAIL_MATKA_KONSOLIDACE: 'Konsolidace dle účetních standardů',
    LEI_DETAIL_MATKA_KONSOLIDACE_CONFIRM: 'Typ souboru',
    LEI_DETAIL_REGULATORY: 'Odkaz k ověření - URL',
    LEI_DETAIL_UCETNI_OBDOBY: 'Poslední účetní období',
    LEI_DETAIL_UCETNI_OBDOBY_OD: 'Poslední účetní období od',
    LEI_DETAIL_UCETNI_OBDOBY_DO: 'Poslední účetní období do',
    LEI_DETAIL_PLATNOSTDOKUMENTU: 'Platnost dokumentu',
    LEI_DETAIL_PLATNOSTDOKUMENTU_OD: 'Začátek platnosti dokumentu',
    LEI_DETAIL_PLATNOSTDOKUMENTU_DO: 'Konec platnosti dokumentu',
    LEI_DETAIL_MATER_SPOLOCNOSTI: 'LEI přímé mateřské společnosti',
    LEI_DETAIL_MATER_SPOLOCNOSTI_BRANCH: 'LEI Zřizovatele',
    LEI_DETAIL_MATER_SPOLOCNOSTI_FIN: 'LEI finální mateřské společnosti',
    LEI_DETAIL_MATER_NAZEV: 'Název přímé mateřské společnosti',
    LEI_DETAIL_MATER_NAZEV_FINAL: 'Název finální mateřské společnosti',
    LEI_DETAIL_MATER_NAZEV_BRANCH: 'Název International branch of',
    LEI_DETAIL_JURISDICKE: 'Jurisdikce',
    LEI_DETAIL_REJSTRIK: 'Rejstřík',
    LEI_DETAIL_IDMAT: 'Identifikační číslo přímé mateřské společnosti',
    LEI_DETAIL_DUVOD_SELECT: 'Vyberte důvod',
    LEI_MA_FOND_ID: 'Byl fondu přidělen identifikátor?',
    LEI_FOND_ID: 'Identifikátor fondu',
    LEI_DETAIL_NE_TEXT2:
        'V případě, že přímá mateřská společnost je stejná jako finální mateřská společnost, vyplňte informace o Přímé mateřské společnosti a vyberte: „Stejné hodnoty jako přímá mateřská společnost“',
    LEI_DETAIL_NE_TEXT:
        'Pokud neuvádíte přímou mateřskou společnost, hodnoty pro finální mateřskou společnost jsou doplněny automaticky.',
    LEI_DETAIL_NELZEUVEST_INPUT: 'Podrobnosti důvodu',
    LEI_DETAIL_PRAV_SPOL: 'Název právnické osoby / společnosti',
    LEI_FINAL_TITLE: 'Detailní informace o finální mateřské společnosti',
    LEI_FINAL_SUBTEXT: 'Finální mateřskou společností nemůže být sám žadatel o LEI',
    LEI_FINAL_TEXT:
        'Finální mateřskou společností se rozumí ovládající právnická osoba nejvyšší úrovně, která sestavuje konsolidovanou účetní závěrku v souladu s účetními pravidly platnými pro mateřskou společnost.',
    LEI_FINAL_MASPOL_SELECT:
        'Má společnost finální mateřskou společnost, která sestavuje konsolidovanou účetní závěrku?',
    LEI_FINAL_MASPOL_SELECT_ALT: 'Má společnost finální mateřskou společnost?',
    LEI_FINAL_MASPOL_MALEI: 'Má finální mateřská společnost LEI?',
    LEI_FINAL_ID_KONSOL: 'Identifikační číslo finální mateřské společnosti',
    LEI_FINAL_STATSIDLA: 'Stát sídla finální mateřské společnosti',
    LEI_NOVYZADATEL: 'Nový žadatel',
    LEI_AKTUALIZACE: 'Aktualizace',
    LEI_AKTUALIZACE_ZMENA_IC: 'Došlo ke změně IČ?',
    LEI_AKTUALIZACE_ZMENA_NAZVU: 'Došlo ke změně názvu společnosti?',
    LEI_OZIVENI: 'Oživení',
    LEI_PRAVNI_FORMA_KOD: 'Pravní kód z ELF',
    LEI_JINEID_SUBJ: 'Jiné ID subjektu',
    LEI_FONDU: 'LEI fondu',
    LEI_DETAIL_NAZEV_TYP: 'Typ názvu',
    LEI_DETAIL_NAZEV_JAZYK: 'Jazyk názvu',
    LEI_FOND_TITLE: 'Detailní informace o struktuře vztahů fondu',
    LEI_FOND_NENI: 'Není uvedena žádná struktura fondu',
    LEI_IS_SUBFUND_OF_SELECT:
        'Žadatel je podfond investičního fondu, uvedu LEI zastřešujícího investičního fondu (Umbrella structure)',
    LEI_IS_FEEDER_TO_SELECT:
        'Žadatel je podřízeným standardním fondem, uvedu LEI nadřazeného investičního fondu (Master-Feeder structure)',
    LEI_IS_FUND_MANAGED_BY_SELECT:
        'Žadatel je investičním fondem, uvedu LEI investiční společnosti (obhospodařovatele fondu)',
    LEI_IS_SUBFUND_OF: 'Zastřešující investiční fond (Umbrella structure)',
    LEI_IS_FEEDER_TO: 'Nadřazený investiční fond (Master-Feeder structure)',
    LEI_IS_FUND_MANAGED_BY: 'Investiční společnost (Obhospodařovatel fondu)',
    LEI_IS_FUND_MANAGED_BY_ERR: 'Vyplňte vztah s investiční společností (obhospodařovatelem fondu)',
    LEI_REJSTRIK_INY: 'Jiný rejstřík',
    LEI_FOND_UPLOAD_TEXT:
        'Vložte: Statut fondu, KIID nebo jiné dokumenty, dle kterých bude možné ověřit strukturu fondu',
    TYP_FONDU: 'Typ fondu',
    FOND_LEI: 'Fond LEI',
    FOND_STATUT: 'Statut fondu',
    FOND_NAZEV: 'Název fondu',
    DATUM_ZACATEK_VZTAHU: 'Datum - začátek vztahu',
    LEI_ICO_CHECK_ERR_JINY: 'Pro zadané IČO byla již podána/rozpracována žádost jiným uživatelem',
    LEI_ICO_CHECK_ERR_GOV: 'Jestli máte právo přistupovat tak prosím kontaktujte CDCP.',
    LEI_ICO_CHECK_ERR_DUPL:
        'Pro zadané IČO již máte rozpracovanou žádost. Než budete pokračovat, zrušte probíhající požadavek',
    LEI_ICO_CHECK_ERR_JINELOU_LOGINLESS:
        'Společnost má kód LEI registrován u LOU {{LOU}}. Chcete převést tento kód LEI do Centrálního depozitáře cenných papírů? Pokud ano, klikněte na Pokračovat.',
    LEI_ICO_CHECK_ERR_JINELOU:
        'Společnost má kód LEI registrován u LOU {{LOU}}. Pokud chcete převést tento kód LEI do Centrálního depozitáře cenných papírů, použijte volbu Žádost o převod LEI.',
    LEI_ICO_CHECK_ERR:
        'Pro zadané IČO byl LEI kód již přidělen. Seznam přidělených LEI kódů naleznete na internetových stránkách www.gleif.org. Případné dotazy zodpovíme na emailové adrese lei@pse.cz.',
    LOGIN_JMENOHESLO: 'Přihlášení pomoci jména a hesla',
    LOGIN_PXKLIC: 'Přihlášení pomoci jména a hesla a PX klíče',
    LOGIN_CERT: 'Přihlášení pomocí komerčního certifikátu',
    LOGIN_BANKID: 'Přihlášení pomoci BankID',
    LOGIN_LEI: 'Přihlašení pomoci LEI (pro převod účtu)',
    LEI_MIGRACE: 'Migrace účtu LEI do Můj depozítář',
    LEI_MIGRACE_ERR:
        'Uvedené LEI není ve správě naší společnosti. V případě, že si přejete převést LEI pod naší správu, kontaktujte nás na lei@pse.cz',
    LEI_LOGIN_ERR: 'Účet již byl přemigrován. Přihlašte se svým učtem do Můj depozitář',
    LEI_LOGIN_SUCCESS: 'Účet byl úspěsně přemigrován',
    LEI_LOGIN_SUCCESS_BUTTON: 'Pokračovat do Můj depozítář',
    LEI_LOGIN_SUCCESS_TEXT: 'Pro zpravování LEI nyní již použivateje jen Vámi zvolený přístup.',
    LEI_MIGRUJETE_SPOLECNOST: 'Migrujete společnost',
    LEI_SPRAVOVANE: 'Spravované LEI',
    LEI_MIGRACE_TEXT: 'Pro migraci LEI můžete využít bud již existujicí účet nebo si založit nový. ',
    LEI_STAVUCTU_ROZP: 'Rozpracováná žádost',
    LEI_STAVUCTU_HOTOVO: 'Odesláno do CDCP',
    LEI_STAVUCTU_KONTROLA: 'Kontrola u CDCP',
    LEI_STAVUCTU_PLACENI: 'Čeka se na platbu',
    LEI_STAVUCTU_ISSUED: 'ISSUED',
    GLEIF_NEVEDENO: 'Nevedený',
    LEI_STAV_GLEIF: 'Status v GLEIF',
    LEI_POSLEDNA_ZMENA: 'Datum poslední změny',
    LEI_NEXT_CERT: 'Datum příští certifikace',
    LEI_PROBIHA: 'Probíhá',
    LEI_IDENTIFIKATOR: 'Variabilní symbol',
    LEI_MENU_NOVY: 'Registrovat nové LEI',
    LEI_MENU_GLEIF: 'Údaje v GLEIF',
    LEI_MENU_DETAIL: 'Detail LEI',
    LEI_MENU_AKTUALIZACE_CARD: 'Aktualizace LEI',
    LEI_MENU_AKTUALIZACE: 'Aktualizace / Prodloužení platnosti LEI',
    LEI_MENU_AKTUALIZACE_LOGIN: 'Ověření LEI',
    LEI_MENU_PLATBA: 'Platební instrukce',
    PLATEBNI_INSTRUKCE: 'Platební instrukce',
    LEI_PLATOBNE_INFO_TITLE: 'Informace k platební instrukci',
    LEI_PLATOBNE_INFO_TITLE_PRIDELENI: 'Informace k platební instrukci - Přidělení',
    LEI_PLATOBNE_INFO_TITLE_AKTUALIZACE: 'Informace k platební instrukci - Aktualizace',
    LEI_PLATOBNE_INFO_SPECSYMBOL: 'Specifický symbol',
    LEI_PLATOBNE_INFO_VARSYMBOL: 'Variabilní symbol',
    LEI_PLATOBNE_INFO_TEXTCR: 'Pokud chcete zaplatit poplatek v Kč na bankovní účet CDCP vedený v ČR',
    LEI_PLATOBNE_INFO_TEXTSK: 'Pokud chcete zaplatit poplatek v EUR na bankovní účet CDCP vedený v SR',
    LEI_PLATOBNE_INFO_AMOUNTCR: 'Částka v Kč',
    LEI_PLATOBNE_INFO_AMOUNTSK: 'Částka v EUR',
    LEI_PLATOBNE_INFO_KODBANKY: 'Kód banky',
    LEI_PLATOBNE_INFO_ADRESA: 'Název a adresa banky',
    LEI_PLATOBNE_INFO_ADRESA1_SK: 'UniCredit Bank Czech Republic and Slovakia, a.s.,',
    LEI_PLATOBNE_INFO_ADRESA2_SK: 'pobočka zahraničnej banky',
    LEI_PLATOBNE_INFO_ADRESA3_SK: 'Šancová 1/A',
    LEI_PLATOBNE_INFO_ADRESA4_SK: '813 33 Bratislava',
    LEI_PLATOBNE_INFO_ADRESA1_CZ: 'UniCredit Bank Czech Republic and Slovakia, a.s.,',
    LEI_PLATOBNE_INFO_ADRESA3_CZ: 'Želetavská 1525/1',
    LEI_PLATOBNE_INFO_ADRESA4_CZ: '140 92 Praha 4',
    ACCOUNTS_FILING:
        'Výroční zpráva konsolidující mateřské společnosti, podklady pro vytvoření konsolidované účetní závěrky',
    REGULATORY_FILING: 'Výkazy pro regulátora',
    SUPPORTING_DOCUMENTS: 'Výpisy z veřejného rejstříku',
    CONTRACTS: 'Smlouvy',
    OTHER_OFFICIAL_DOCUMENTS: 'Jiné relevantní oficiální dokumenty',
    LEI_PLATOBNE_INFO_PRIJEMCE: 'Název a adresa příjemce',
    LEI_PLATOBNE_INFO_PRIJEMCE1: 'Centrální depozitář cenných papírů, a.s.,',
    LEI_PLATOBNE_INFO_PRIJEMCE2: 'Rybná 14',
    LEI_PLATOBNE_INFO_PRIJEMCE3: '110 05 Praha 1',
    LEI_TYPZADOSTI_REGISTRACE: 'Nová registrace',
    LEI_TYPZADOSTI_AKTUALIZACE: 'Aktualizace',
    LEI_TYPZADOSTI_PREVOD: 'Převod',
    LEI_TYPZADOSTI_KONTAKTNIUDAJE: 'Změna kontaktních údajů',
    LEI_CHANGE_LEGAL_NAME: 'Název právnické osoby / společnosti',
    LEI_CHANGE_OTHER_NAMES: 'Jiný název právnické osoby / společnosti',
    LEI_CHANGE_LEGAL_ADDRESS: 'Adresa sídla',
    LEI_CHANGE_HQ_ADDRESS: 'Adresa centrály',
    LEI_CHANGE_LEGAL_FORM: 'Právní forma - Kód',
    LEI_DIC: 'Plátce DPH',
    CHCI_ZMENIT: 'Chci změnit',
    CHCI_ZMENIT_OSTATNI: 'Typ Korporátní akce',
    LEI_VZNIKSPOLECNOSTI: 'Datum založení právnické osoby / společnosti',
    LEI_OSTATNI: 'Korporátní akce',
    LEI_AKTUALIZACE_CHANGE_LEGAL_NAME: 'Změna názvu právnické osoby / společnosti',
    LEI_AKTUALIZACE_CHANGE_OTHER_NAMES: 'Změna jiného názvu právnické osoby /společnosti',
    LEI_AKTUALIZACE_CHANGE_LEGAL_ADDRESS: 'Změna adresy sídla',
    LEI_AKTUALIZACE_CHANGE_HQ_ADDRESS: 'Změna adresy centrály',
    LEI_AKTUALIZACE_CHANGE_LEGAL_FORM: 'Změna právní formy',
    LEI_AKTUALIZACE_DIC: 'Změna Plátce DPH',
    LEI_AKTUALIZACE_VZNIKSPOLECNOSTI: 'Změna data založení společnosti',
    LEI_AKTUALIZACE_OSTATNI: 'Změna Korporátní akce',
    SPRAVCELEI: 'Správa kódů LEI',
    LEI_ZOBRAZIT_PROBELHI: 'Zobrazit již proběhlí události',
    ZMENIT_UDAJE: 'Změnit údaje',
    LEI_ZMENIT_EVENT_BUTTON: 'Změnit údaje o společnosti',
    LEI_ZMENIT_EVENT_OSTATNI_BUTTON: 'Oznámit korporátní akci',
    LEI_DATUM_ZMENY: 'Datum účinnosti',
    LEI_DATUM_OZNAMENI: 'Datum oznámení',
    LEI_DATUM_POTVRDENI: 'Datum potvrzení',
    POTVRDENI: 'Potvrzení',
    LEI_HLASENA_ZMENA: 'Hlášená změna',
    LEI_ZMENA_PODKLADY: 'Podklady ke změně',
    LEI_CHECK_ERROR: 'Zadané lei nebylo nalezeno v rejstříku',
    LEI_CHECK_ERROR2: 'Pro zadanou kombinaci nebylo nalezeno LEI',
    LEI_MATKE_STEJNE_HODNOTY: 'Stejné hodnoty jako přímá mateřská společnost.',
    LEI_ENTITYCHECK_ERR: 'Zadané IČO již má přiřazeno LEI {{LEI}}',
    LEI_ENTITYSHODNE_ERR: 'LEI matky nesmí být stejné jako lei společnosti',
    LEI_OSOBACHECK_ERROR:
        'Uvedenou osobu nebylo možné automaticky ověřit v OR nebo v ARES. Vložte soubor, který potvrzuje oprávnění této osoby jednat za společnost (výpis z OR, plnou moc apod.)',
    LEI_COMPLETE_THREEDAYS: 'Lze potvřdit jen tři dny pred realizací',
    LEI_PROFONDY_ERROR: 'Ve zvýrazněných řádcích chybí jedna nebo více položek',
    ALTERNATIVE_LANGUAGE_LEGAL_NAME: 'Název právnické osoby / společnosti v jiném jazyce',
    PREVIOUS_LEGAL_NAME: 'Předchozí název právnické osoby / společnosti',
    TRADING_OR_OPERATING_NAME: 'Obchodní nebo provozní název právnické osoby / společnosti',
    UCETNISTANDARDY_JINE: 'Jiné účetní standardy',
    JINY_PRAVNI_KOD: 'Jiná právní forma',
    LEI_MATKA_UVEST: 'Ano, uvedu přímou mateřskou společnost, která sestavuje konsolidovanou účetní závěrku.',
    LEI_MATKA_NEUVEST: 'Ne, neuvedu přímou mateřskou společnost, která sestavuje konsolidovanou účetní závěrku.',
    LEI_MATKA_KONSOLIDOVANA_UVEST:
        'Ano, uvedu finální mateřskou společnost, která sestavuje konsolidovanou účetní závěrku.',
    LEI_MATKA_KONSOLIDOVANA_NEUVEST: 'Ne, neuvedu finální mateřskou společnost',
    LEI_SUBMIT_APPROVAL:
        'Potvrzuji správnost zaslaných údajů a beru na vědomí, že potvrzením žádosti bude uzavřena smlouva mezi žadatelem a Centrálním depozitářem cenných papírů ve smyslu článku 3 Pravidel přidělování a vedení LEI.',
    LEI_SUBMIT_INFO:
        'Subjekt poskytující osobní údaje bere na vědomí, že CDCP bude zpracovávat jako správce poskytnuté osobní údaje. Zpracování bude prováděno pro účely realizace tohoto smluvního vztahu a případně pro účely ochrany oprávněných zájmů správce (vymáhání plnění povinností dle této smlouvy). Další nezbytné informace o zpracování osobních údajů jsou uvedeny na webových stránkách http://www.cdcp.cz v sekci "Ochrana osobních údajů".',
    LEI_ZMENA_KONTAKT: 'Změna kontaktních údajů',
    LEI_GLEIF_STAV_LAPSED: 'Lapsed',
    LEI_GLEIF_STAV_MERGED: 'Merged',
    LEI_GLEIF_STAV_RETIRED: 'Retired',
    LEI_GLEIF_STAV_ANNULLED: 'Annulled',
    LEI_GLEIF_STAV_CANCELLED: 'Cancelled',
    LEI_GLEIF_STAV_TRANSFERRED: 'Transferred',
    LEI_GLEIF_STAV_PENDING_TRANSFER: 'Pending transfer',
    LEI_GLEIF_STAV_PENDING_ARCHIVAL: 'Pending archival',
    LEI_GLEIF_STAV_PENDING_VALIDATION: 'Nevedený',
    LEI_GLEIF_STAV_ISSUED: 'Issued',
    LEI_UPLOAD_FILLIN: 'Před nahráním souboru vyplňte všechny požadované údaje',
    LEI_AKTUALIZACE_MATKA_ERR: 'údaje matek jsou neúplné, prosím upravte údaje',
    TYP_PRIHLASENI_PXKLIC: 'PX Klíč',
    TYP_PRIHLASENI_PXKL: 'PX Klíč',
    TYP_PRIHLASENI_CERT: 'Certifikát',
    TYP_PRIHLASENI_UZIV: 'Jméno a heslo',
    TYP_PRIHLASENI_BANKID: 'Bank ID',
    TYP_PRIHLASENI_BI: 'Bankovní idendita',
    TYP_PRIHLASENI_DLT: 'Bankovní idendita',
    POSLEDNI_PRIHLASENI: 'Poslední přihlášení',
    DATUM_REGISTRACE: 'Datum registrace',
    AUTH_PRVEK: 'Autentizační prvek',
    INFORMACNI_SLUZBA: 'Historie',
    TRANSFORMATION_SUBSIDIARY_TO_BRANCH: 'Transformace dceřinné společnosti na odštěpný závod',
    REVERSE_TAKEOVER: 'Zpětné převzetí společnosti',
    ABSORPTION: 'Zánik sloučením',
    BANCRUPTCY: 'Bankrot',
    BREAKUP: 'Rozdělení společnosti',
    DEMERGER: 'Zpětná fúze',
    SPINOFF: 'Přeměna odštěpením',
    INSOLVENCY: 'Insolvence',
    DISSOLUTION: 'Zrušení společnosti (bez nástupnické společnosti)',
    VOLUNTARY_ARRANGEMENT: 'Věřitelská dohoda - reorganizace společnosti',
    LIQUIDATION: 'Likvidace',
    ACQUISITION_BRANCH: 'Akvizice odštěpného závodu',
    TRANSFORMATION_UMBRELLA_TO_STANDALONE: 'Transformace zastřešujícího fondu na samostatný',
    MERGERS_AND_ACQUISITIONS: 'Akvizice a fúze',
    TRANSFORMATION_BRANCH_TO_SUBSIDIARY: 'Transformace odštěpného závodu na dceřinnou společnost',
    LEI_LOGIN_TITLE: 'Můj depozitář – informační portál',
    LEI_PRIHLASENI_LEI_MENO:
        'Upozorňujeme, že od 1.4.2022 došlo ke změně v přihlašování k účtu LEI a nově je nutné přistupovat ke správě LEI prostřednictvím uživatelského účtu portálu Můj depozitář. Přihlašovacími údaji jsou bold(e-mail a heslo). Pokud ještě nemáte vytvořený uživatelský účet v portálu Můj depozitář, zaregistrujte se pomocí tlačítka Registrovat nového uživatele.',
    LEI_PRIHLASENI_SUB1:
        'Můj depozitář, je webový portál, prostřednictvím kterého jsou žadatelům/držitelům LEI poskytovány služby elektronickou cestou. Pro přístup ke službám je nutná registrace.',
    LEI_PRIHLASENI_SUB3: 'Pokud ještě registraci nemáte, klikněte na tlačítko „Registrovat nového uživatele“',
    LEI_PRIHLASENI_SUB4:
        'V případě, že nemáte přistup k již existujícímu uživatelskému účtu, který spravuje Váš LEI, kontaktuje prosím CDCP prostřednictvím e-mail lei@pse.cz.',
    LEI_LOGIN_SUB1: 'Žádost o LEI může podat pouze registrovaný uživatel.',
    LEI_LOGIN_REGISTER: 'Registrovat nového uživatele',
    LEI_AKTUALIZACE_LOGIN_SUB: 'Zde prosím uveďte Váš LEI kód.',
    LEI_AKTUALIZACE_LOGIN_ZADAJTE_LEI: 'Zadejte LEI, které vedete u CDCP',
    LEI_PORTAL_TITLE: 'Aktualizace LEI',
    LEI_PORTAL_SUCCESS:
        'bold(Pozor:) Změna přístupových autentizačních prvků u Vašeho LEI účtu.  Z důvodu bezpečnosti již není možné, aby byl jedním z Vašich přihlašovacích údajů kód LEI. Novým přihlašovacím údajem bude Vámi stanovené uživatelské jméno, kterým je e-mail. Změnu a potvrzení nových přihlašovacích údajů proveďte prostřednictvím níže zobrazeného formuláře.',
    LEI_PORTAL_SUCCESS_SUB: 'Pokračovat pomocí e-mailu',
    ZAPOMENUTE_HESLO_LEI: 'Nové / Zapomenuté heslo',
    ZAPOMENUTE_HESLO_LEI_TITLE: 'Žádost o nové heslo',
    ZAPOMENUTE_HESLO_LEI_TITLE2: 'Nové heslo pro LEI',
    ZAPOMENUTE_HESLO_LEI_SUB2: 'Prosíme, zadejte své nové heslo pro přístup do portálu LEI',
    ZAPOMENUTE_HESLO_LEI_SUB:
        'Prosíme, zadejte LEI společnosti a Váš kontaktní email pro komunikaci s CDCP. Odkaz pro obnovu hesla obdržíte pouze v případě, že jste uvedli e-mail, který je totožný s e-mailem uvedeným v žádosti o registraci LEI',
    ZAPOMENUTE_HESLO_LEI_SENT:
        'Odkaz pro obnovu hesla obdržíte pouze v případě, že jste pro LEI uvedli e-mail, který je totožný s e-mailem uvedeným u LEI.',
    LEI_PORTAL_SUB_JINY: 'Jiný účet',
    LEI_PORTAL_SUB: 'Vložte své přihlašovací údaje ke správě LEI.',
    LEI_AKTUALIZACE_SUCCESSOR_ERR: 'Musí být vyplněno jméno nebo LEI',
    IN_PROGRES: 'Probíhá',
    IN_PROGRESS: 'Probíhá',
    COMPLETED: 'Dokončeno',
    WITHDRAWN_CANCELLED: 'Změna zrušena',
    UPLOAD_INVALID_FORMAT: 'Formát souboru, který se pokoušíte nahrát, je neplatný',
    UPLOAD_INVALID_NAME: 'Název souboru je příliš dlouhý nebo obsahuje zakázané znaky',
    VYPIS_REGISTER: 'Výpis z emise',
    INFORMACNI_SLUZBY: 'Informační služby',
    LEI_REGISTRACE_TEXT:
        'Z důvodu snahy o zajištění maximálně možného zabezpečení a ochrany Vašeho účtu jsme od stejného data změnili i rozsah povinných registračních údajů, které nám musí každý uživatel poskytnout. Z tohoto důvodu si Vás dovolujeme požádat o vyplnění krátkého registračního formuláře, který naleznete níže. V případě neposkytnutí požadovaných registračních údajů, Vám nebude umožněn přístup k online službám CDCP, které jsou nabízeny v portálu MD. Předem děkujeme na Vaši ochotu a vstřícnost.',
    SLUZBY_LEI: 'LEI – žádost, aktualizace, správa',
    SLUZBY_EMITENT: 'EMITENT – Přehled, správa, služby',
    ZADOST_NOVY_LEI: 'Žádost o nový LEI',
    SPRAVA: 'Správa',
    SPRAVA_LEI: 'Správa LEI',
    UCET_NOVY_ADMEMIT: 'Nový účet administrátora emise',
    UCET_NOVY_EMITENT: 'Nový účet emitenta',
    UCET_EMITENT: 'Účet emitenta',
    UCET_LEGALENTITY: 'Bankovní účet právnické osoby',
    UCET_LEGALENTITY_TOOLTIP: 'Bankovní účet pro účely vypořádání převodů s penězi a pro účely výplat výnosů.',
    PREDANI_LEI_DO_SPRAVY: 'Předání LEI do správy',
    LEI_NEEVIDOVANE: 'Toto LEI neevidujeme.',
    LEI_NEEVIDOVANE_PARAGRAPH:
        'Pokud si přejete převést LEI pod správu CDCP, a.s., kontaktujte nás na emailové adrese lei@pse.cz. Formulář Žádosti o přesun LEI ke stažení ',
    LEI_SPRAVA_UCTU_ZADOST_NEZNAM: 'Chcete poslat žádost o předání LEI do Vaší správy?',
    LEI_SPRAVA_UCTU_ZADOST: 'LEI je ve správě jiného uživatele. Chcete poslat žádost o předání LEI do Vaší správy?',
    LEI_SPRAVA_UCTU_PREVODHESLO: 'Znáte heslo do původního portálu LEI?',
    ODESLAT_ZADOST: 'Odeslat žádost',
    LEI_SPARAVA_ZADOST_SUCCESS_TITLE: 'Žádost byla úspěšně odeslána',
    LEI_SPARAVA_ZADOST_PREDBEZNE_SUCCESS_TITLE: 'Žádost byla úspěšně odeslána k předběžné kontrole',
    ZNAM_HESLO: 'Znám heslo',
    NEZNAM_HESLO: 'Neznám heslo',
    LEI_SPRAVA_UCTU_PW_NESPRAVNE: 'Nebylo zadané správné heslo. Chcete poslat žádost o předání LEI do Vaší správy?',
    MENU_LEI_SPRAVA: 'Přiřadit LEI k mému účtu',
    MENU_LEI_PREVOD: 'Žádost o převod LEI',
    UCEL_NOVEHO_UCTU: 'Zvolte účel založení účtu',
    ZVOLTE_UCET: 'Zvolte agendu',
    LEI_PRIDELENI_TITLE: 'Přidělení LEI do správy',
    LEI_PRIDELENI_TEXT: 'Opravdu chcete LEI {{lei}} přidat do své správy?',
    LEI_ZADOST_SPRAVA_TITLE: 'Žádost o přidání LEI do správy',
    LEI_ZADOST_SPRAVA_TEXT:
        'LEI se Vám objeví ke správě, až bude žádost schválená. O schválení Vás budeme informovat e-mailem.',
    DUVERNE_INFO_TITLE_F42: 'F42 - Výpis z emise včetně práv, ESM a čísel bankovních účtů k zadanému datu',
    F45: 'F45 - Výpis z emise',
    DUVERNE_INFO_TITLE_F45: 'F45 - Výpis z emise',
    DASHBOARD_CARD_PROFIL_ADMINVFO: 'Profil Administrátor investičního fondu',
    DASHBOARD_CARD_PROFIL_EMITENT: 'Profil Emitent',
    DASHBOARD_CARD_PROFIL_LEI: 'Profil LEI',
    DASHBOARD_CARD_PROFIL_AKCIONAR: 'Profil Majetkový účet',
    DASHBOARD_CARD_PROFIL_CDCPSRD: 'Profil CDCP SRD',
    DASHBOARD_CARD_PROFIL_ADMEMIT: 'Profil Administrátor emise',
    DASHBOARD_CARD_PROFIL_UCASTNIK: 'Profil Účastník',
    DASHBOARD_CARD_PROFIL_SPRAVCEUCTU: 'Profil Správce majetkového účtu',
    DASHBOARD_CARD_PROFIL_SPRAVCELEI: 'Profil Správa kódů LEI',
    DASHBOARD_CARD_PROFIL_ADMINISTRATOR: 'Profil Administrátor',
    DASHBOARD_CARD_PROFIL_2: 'Profil ČNB',
    DASHBOARD_CARD_PROFIL_39: 'Profil Dlužník',
    DASHBOARD_CARD_PROFIL_5: 'Profil Emitent',
    DASHBOARD_CARD_PROFIL_6: 'Profil Notář',
    DASHBOARD_CARD_PROFIL_40: 'Profil Notář-interní',
    DASHBOARD_CARD_PROFIL_41: 'Profil Exekutor-interní',
    DASHBOARD_CARD_PROFIL_9: 'Profil System',
    DASHBOARD_CARD_PROFIL_10: 'Profil Ostatní státní orgány',
    DASHBOARD_CARD_PROFIL_28: 'Profil Státní zastupitelství',
    DASHBOARD_CARD_PROFIL_29: 'Profil Soud',
    DASHBOARD_CARD_PROFIL_26: 'Profil Finanční úřad',
    DASHBOARD_CARD_PROFIL_42: 'Profil Finanční úřad-interní',
    DASHBOARD_CARD_PROFIL_43: 'Profil Ins.spr.,spr.konkurz.podstaty,likvidátor-interní',
    DASHBOARD_CARD_PROFIL_45: 'Profil Smluvní odběratel',
    DASHBOARD_CARD_PROFIL_100: 'Profil Testovací navazující evidence',
    DASHBOARD_CARD_PROFIL_46: 'Profil Ins.spr.,spr.konkur.podstaty,likvidátor',
    DASHBOARD_CARD_PROFIL_49: 'Profil Emitent-s právem k úpisu',
    DASHBOARD_CARD_PROFIL_25: 'Profil Exekutor',
    DASHBOARD_CARD_PROFIL_50: 'Profil Administrátor emise-s právem k úpisu',
    DASHBOARD_CARD_PROFIL_38: 'Profil Administrátor emise',
    DASHBOARD_CARD_PROFIL_34: 'Profil Přepážka CDCP',
    DASHBOARD_CARD_PROFIL_35: 'Profil Centrální depozitář',
    DASHBOARD_CARD_PROFIL_3: 'Profil Správa administrátorù',
    DASHBOARD_CARD_PROFIL_44: 'Profil Správa uživatelù zákazníka',
    DASHBOARD_CARD_PROFIL_52: 'Profil Administrátor investičního fondu',
    DASHBOARD_CARD_PROFIL_70: 'Profil Emitent SRD',
    DASHBOARD_CARD_PROFIL_53: 'Profil Zneplatněny profil 46 - ins.spr.,spr.konkurz.podstaty,likvidátor',
    DASHBOARD_CARD_PROFIL_56: 'Profil Referent Emitentské oblasti',
    DASHBOARD_CARD_PROFIL_71: 'Profil Administrátor SRD',
    DASHBOARD_CARD_PROFIL_72: 'Profil CDCP SRD',
    DASHBOARD_CARD_PROFIL_M: 'Profil Majetkový účet',
    PRISTUPY_SRDKORPAKCE: 'SRD (korporátní akce)',
    DOTAZNIK_PEP: 'Dotazník PEP',
    DOTAZNIK_PEP_TEXT:
        'S ohledem na uvedení politicky exponované osoby (PEP) v AML dotazníku musí CDCP jako povinná osoba dle AMLZ získat dostatečné ujištění, že zná jednání svého klienta a rozumí mu a že v rámci tohoto obchodního vztahu nedochází k nezákonné činnosti ve smyslu AMLZ. Existence PEP u emitenta nebude mít negativní dopad na obchodní vztah s CDCP s tou výjimkou, že si CDCP může vyžádat více dodatečných informací o jeho úkonech. Poskytnuté důvěrné informace jsou v CDCP chráněny přísnou povinností mlčenlivosti. V případě neposkytnutí součinnosti však musíme odmítnout uskutečnění obchodu. Děkujeme za pochopení.',
    DOTAZNIK_PEP_TEXT2: 'Proto Vás tímto zdvořile žádáme o zodpovězení následujících dodatečných otázek:',
    DOTAZNIK_PEP_FUNKCE:
        'Z jaké konkrétní funkce vyplývá označení osoby jednající za klienta nebo skutečného majitele jako PEP? Uveďte dle znění zákona níže.',
    DOTAZNIK_PEP_PUVODMAJETKU: 'Jaký je původ majetku PEP (zdroj finančních prostředků; zvolte max. 3 možnosti)',
    DOTAZNIK_PEP_ROZSAHMAJETKU:
        'Přibližný celkový rozsah majetku? Nejedná o původ prostředků užívaných v transakci v rámci vztahu s CDCP, ale obecně (Zvolte jednu možnost)',
    DOTAZNIK_PEP_ZRIZOVATELMAJ:
        'Původ majetku a jeho rozsah neuvádí z důvodu, že klientem je právnická osoba zřízená státními institucemi, územně-samosprávnými subjekty nebo je jimi ovládána',
    DOTAZNIK_PEP_MAJETKOVEPOMERY:
        'Má PEP povinnost uvádět majetkové poměry do Registru oznámení ve smyslu zákona č. 159/2006 Sb., o střetu zájmů?',

    DOTAZNIK_PEP_PREVZDROJMAJETKU:
        'Dále uveďte převažující zdroj majetku emitenta a jeho předpokládanou výši v následujících třech letech. (Zvolte jednu možnost).',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO1: 'Vlastní zdroje',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO2: 'Plat či mzda',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO3: 'Příjem z podnikání',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO4: 'Výhra v loterii',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO5: 'Státní nebo soukromé důchodové pojištění',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO6: 'Výnosy z investic a fondů',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO7: 'Vypořádání společného jmění manželů',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO8: 'Dědictví',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO9: 'Výnosy z nemovitostí',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO10: 'Sociální dávky',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO11: 'Studijní granty a stipendia',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO12: 'Výnosy ze svěřenského fondu',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO13: 'Přímé investice do firem',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO14: 'Cizí zdroje',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO15: 'Zápůjčka',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO16: 'Příjem partnera(ky)',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO17: 'Jiné (uveďte)',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO1: 'do 5 000 000 Kč',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO2: 'do 10 000 000 Kč',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO3: 'do 50 000 000 Kč',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO4: 'nad 50 000 000 Kč',
    DOTAZNIK_PEP_PREVZDROJMAJETKU_RADIO1: 'Výnosy vlastní podnikatelské činnosti',
    DOTAZNIK_PEP_PREVZDROJMAJETKU_RADIO2: 'Cizí zdroje',
    DOTAZNIK_PEP_PREDPVYSEMAJETKU: 'Uveďte informaci o předpokládané výši zdrojů majetku.',
    EMITENT_PREHLED_ISINY: 'Seznam ISIN vydaných v CDCP',
    UPOZORNENI_CHYBNYCERT: 'Nesouhlasí vydavatel certifikátu nebo jméno majitele',
    UPOZORNENI_NENIPREDPLATNE:
        'Na tuto službu nemáte předplatné. Potvrzením požadavku souhlasíte s fakturováním služby.',
    UPOZORNENI_ODESLANO: 'Požadavek byl úspěšně zaregistrován.',
    UPOZORNENI_NOTIFIAKCE: 'O zpracování služby budete informování e-mailem.',
    UPOZORNENI_KLICZAMITNUTO: 'Zápis požadavku nebyl potvrzen. Opakujte akci.',
    UPOZORNENI_BUDENOTIFIKACE: 'O zpracování služby budete informování e-mailem.',
    UPOZORNENI_NEVALIDNIISIN: 'Upozornění: CDCP neeviduje zadanou emisi. Prověřte její správnost.',
    UPOZORNENI_NEVALIDNIRC:
        'Zadané rodné číslo/IČ/NID může být chybné. Prověřte jeho správnost a v případě rodného čísla nevyplňujte znak lomítka.',
    UPOZORNENI_BUDEODESLANO:
        'Tato služba bude odeslána do zpracování následující den po zadaném dnu/dnech na vstupu služby.',
    LEI_NESHODNE_UDAJE: 'Údaje se neshodují s informacemi v OR',
    LEI_NESHODNE_LEGAL_FORM: 'Právní forma se neshoduje s informacemi v OR',
    LEI_NESHODNE_LEGAL_ADDRESS: 'Adresa sídla se neshoduje s informacemi v OR',
    LEI_NESHODNE_LEGAL_NAME: 'Název právnické osoby se neshoduje s informacemi v OR',
    PRIDAT_UCET: 'Přidat účet',
    LEI_PREHLED_ODESLANO_NOVY_TITLE: 'Odeslána žádost o registraci Legal Entity Identifier (LEI)',
    LEI_PREHLED_ODESLANO_AKTUALIZACE_TITLE: 'Odeslána žádost o aktualizaci Legal Entity Identifier (LEI)',
    BUTTON_UPRAVIT_DOTAZNIK: 'Upravit dotazník',
    LEI_NEPLATNY_KOD: 'Neplatný kód LEI',
    LEI_MAT_SOUBOR_STEJNY: 'Soubor je stejný jako u přímé mateřské společnosti',
    SPRAVOVANE_PRAVICKE_ZADNE_TEXT:
        'Aktuálně nemáte přístup k žádnému majetkovému účtu DLT pro právnickou osobu. V případě, že jste oprávněn přistupovat k majetkovému účtu DLT pro právnickou osobu, použijte volbu bold(Nová právnická osoba).',
    SPRAVOVANE_PODLT: 'Právnické osoby',
    SPRAVOVANE_EMITENT: 'Spravované účty Emitent',
    SPRAVOVANE_ADMEMIT: 'Spravované účty Administrátor emise',
    SPRAVOVANE_UCASTNIK: 'Spravované účty Účastník SRD II',
    SPRAVOVANE_AKCIONAR: 'Spravované účty Akcionář',
    SPRAVOVANE_SPRAVCEUCTU: 'Spravované účty Správce SRD II',
    SPRAVOVANE_STATNISPRAVA: 'Spravované účty Statní správa',
    SPRAVOVANE_CDCPSRD: 'Spravované účty CDCPSRD',
    SPRAVOVANE_ADMINVFO: 'Spravované účty Investiční fond',
    PREHLED_EMITENTU: 'Přehled emitentů',
    DUVERNE_INF_ERR_401: 'Chybně zvolený certifikát',
    CHYBA_SLUZBY: 'Chyba služby, zkuste to znovu později',
    CHYBA_SLUZBY_NELZEISIN: 'Neplatný ISIN',
    CHYBA_SLUZBY_DATUM: 'Zadané datum je mimo povolený interval',
    DASHBOARD_CARD_UCTY_ADMINVFO: 'Administrátor investičního fondu – Přehled, správa, služby',
    DASHBOARD_CARD_UCTY_ADMEMIT: 'Administrátor emise – Přehled, správa, služby',
    DASHBOARD_CARD_UCTY_UCASTNIK: 'Účastník – majetkové účty, přehled události, služby',
    DASHBOARD_CARD_UCTY_AKCIONAR: 'Akcionář – majetkové účty, přehled události, služby',
    DASHBOARD_CARD_UCTY_SPRAVCEUCTU: 'Správce – majetkové účty, přehled události, služby',
    DASHBOARD_CARD_UCTY_STATNISPRAVA: 'Státní správa – Přehled účtů, správa, služby',
    DASHBOARD_CARD_UCTY_CDCPSRD: 'Profil CDCPSRD',
    DASHBOARD_CARD_ZADOST_PRIDELENI: 'Žádost o přidělení',
    DASHBOARD_CARD_ZADOST_PRODLOUZENI: 'Žádost o prodloužení platnosti',
    DASHBOARD_CARD_LEI_PRODLOUZENI: 'Prodloužení platnosti LEI',
    DASHBOARD_CARD_OZNAMENI_UDALOSTI: 'Oznámení o korporátní události',
    DASHBOARD_CARD_AKTUALIZACE_KONTAKT: 'Aktualizace kontaktní osoby',
    DASHBOARD_CARD_PREVOD_LEI: 'Převod LEI do správy',
    DASHBOARD_CARD_REGISTER_VYPIS: 'Výpisy z evidence emise',
    DASHBOARD_CARD_SPRAVA_EMITENTA: 'Správa',
    DASHBOARD_CARD_INFORMACE_UPLATU: 'Informace za úplatu – Emise cenných papírů',
    DASHBOARD_CARD_UCTY_VLASTNIKU: 'Důvěrné informace – Účty vlastníků',
    DASHBOARD_CARD_EMISE_CP: 'Emise cenných papírů',
    DASHBOARD_CARD_MAJETKOVE_UCTY: 'Přehled majetkových účtů',
    DASHBOARD_CARD_SLUZBY_ACKIONAR: 'Služby pro akcionáře',
    DASHBOARD_CARD_SLUZBYVH: 'Služby informující o VH',
    DASHBOARD_CARD_HLASOVANI: 'Služby pro hlasování',
    DASHBOARD_CARD_PREHLED_MU: 'Přehled majetkových účtů ve správě',
    INVALID_RCMA: 'položka vyžaduje 1 až 12 znaků (číslice, velká písmena, -,/)',
    PRBL_SELECT_0: 'vyhledat účty ve všech stavech',
    PRBL_SELECT_1: 'vyhledat účty se změnou stavu blokace',
    ADMINISTRATOR_EMISE: 'Administrátor emise',
    SPRAVCE_EMISE: 'Správce emise',
    LOGIN_NAVOD_LEI_PRIDELENI: 'NÁVOD: Jak zažádat o přidělení LEI?',
    LOGIN_NAVOD_LEI_AKTUALIZACE: 'NÁVOD: Jak prodloužit LEI a aktualizovat údaje?',
    SPISOVA_ZNACKA: 'Spisová značka',
    DLUZNIK_MSG:
        'Přístup k elektronickým službám portálu Můj depozitář byl zablokován z důvodu evidence dlužných faktur po splatnosti. Pro více informací nás kontaktuje na adrese fakturace@pse.cz',
    PREHLED_UZIVATELU: 'Přehled uživatelů',
    POZADAVKY_OSTATNYCH_PRAVO: 'Povoleno vidět požadavky ostatních',
    DETAIL_UZIVATELE: 'Detail uživatele',
    VYSTAVITEL_CERTIFIKATU: 'Vystavitel certifikátu',
    USERNAME: 'Username',
    STAV_UZIVATELE: 'Stav uživatele',
    STAV_UCTU: 'Stav účtu',
    UZIVATEL_STAV_A: 'Aktivní',
    UZIVATEL_STAV_N: 'Neaktivní',
    UZIVATEL_STAV_B: 'Neaktivní',
    CERT_POUZITY_U: 'Certifikát je již použití u účtů',
    ZNEAKTIVNIT_MSG: 'Opravdu si přejete zneaktivnit tento účet?',
    ZNEAKTIVNIT_SUCCESS: 'Deaktivace účtu proběhla úspěšně',
    USER_EDIT_SUCCESS: 'Úprava uživatele proběhla úspěšně',
    LOGIN_ERR_409: 'Uživatelský účet je deaktivován',
    LOGIN_ERR_409_ALT: 'Uživatelský účet není aktivován',
    C4_ESM_STAV_ESMDOPL: 'Načteno z ESM',
    C4_ESM_STAV_ESMOK: 'Načteno z ESM',
    C4_ESM_STAV_ESMODEB: 'Odebráno uživatelem',
    C4_ESM_STAV_RUCNE: 'Přidáno uživatelem',
    C4_OSOBY_RELOAD: 'Seznam skutečných majitelů není aktuální a bude přenačten aktuálními hodnotami',
    C4_C_ERR:
        'V Evidenci skutečných majitelů byly nalezeny údaje o skutečném majiteli subjektu a není proto možné vybrat tuto variantu. Zvolte prosím variantu A nebo B.',
    PXKLIC_NOT_SETUP: 'Prosím o dokončení spárování mobilní aplikace PX Klíč',
    C4_AB_PRAVNIFORMA_ERR: 'Podléháte povinnosti vyplnit skutečného majitele. Vyplňte variantu A nebo B.',
    C4_C_PRAVNIFORMA_ERR: 'Nepodléháte povinnosti vyplnit skutečného majitele. Zvolte variantu C.',
    NEPLATNE_AML_ERR_NODATE: 'Pro podání elektronické služby je nejdříve nutné podat AML.',
    NEPLATNE_AML_ERR: 'Platnost AML vypršela, pro podání elektronické služby je nejdříve nutné aktualizovat AML.',
    LEI_ZADOST_DUPLICITA:
        'Žádost o Přiřazení LEI k mému účtu již byla odeslána, prosíme vyčkejte. Informace o vyřízení žádosti Vám bude odeslána emailem.',
    PRIDAT_LEI_KUCTU_TOOLTIP:
        'Zvolte, pokud si přejete Aktualizovat / Prodloužit platnost již přiděleného LEI, které se Vám nezobrazuje v přehledu Spravované LEI.',
    LEI_NONE_INFO:
        'Pro Aktualizaci / Prodloužení platnosti již přiděleného LEI, které se Vám nezobrazuje v přehledu “Spravované LEI”, je nutné nejdříve převést dané LEI do správy. Zvolte: Přiřadit LEI k mému účtu a postupujte dle instrukcí.',
    LEI_PAYMENT_BUTTON: 'Pokračovat na výběr způsobu platby',
    LEI_PAYMENT_TITLE: 'Výběr způsobu úhrady',
    LEI_PAYMENT_ONLINE: 'Online platba bankovním převodem nebo platební kartou',
    LEI_PAYMENT_TRANSFER: 'Bankovní převod',
    PLATEBNI_BRANA_REDIRECT: 'Budete přesměrování na platební bránu',
    LEI_VYSTAVENE_FAKTURY: 'Vystavené faktury',
    REGISTRACNI_POPLATEK: 'Poplatek za registraci',
    LEI_PAYMENT_SUCCESS: 'Platba proběhla úspěšně',
    LEI_PAYMENT_PENDING:
        'Platbu je nutné dokončit. Budete přesměrováni na platební bránu. Chcete-li platit jiným způsobem, zvolte na platební bráně možnost Zrušit platbu.',
    LEI_CARD_TRANSFERED: 'LEI je aktuálně pod jinou LOU, pokud chcete pokračovat, převeďte tento LEI do CDCP',
    ZRUSIT_UCET_TITLE: 'Zrušit účet',
    ZRUSIT_UCET_SUCCESS: 'Účet byl úspěšně smazán',
    ZNEAKTIVNIT_UCET_SUCCESS: 'Účet byl úspěšně deaktivován',
    ZRUSENI_UCTU: 'Zrušení účtu',
    ZRUSIT_UCET: 'Zrušit účet',
    ZRUSIT_UCET_MSG: 'Opravdu si přejete zrušit svůj účet?',
    PREHLED_ODPOVEDI: 'Přehled odpovědí',
    EDITACNI_MOD: 'Editační mód',
    EDITACE: 'Editace',
    DASHBOARD_CARD_UCTY_TEXTY: 'Správce – aplikační text',
    SPRAVCE_TEXTY_TEXT: 'Zde je možné v editačním režimu měnit texty aplikace',
    CZ_PUVODNI: 'CZ původní',
    CZ_NOVY: 'CZ nový',
    EN_PUVODNI: 'EN původní',
    EN_NOVY: 'EN nový',
    ME_ZMENENE_POZADAVKY: 'Jen změněné požadavky',
    APLIKACNI_TEXTY: 'Aplikační texty',
    C5_DOTAZNIK_ERROR: 'Před pokračováním prosím upravte dotazníky pro zvýrazněné řádky',
    LEI_MATKA_STEJNE_ERR: 'LEI mateřské společnosti nemůže být stejný jako váš LEI',
    LEI_FUND_STEJNE_ERR: 'LEI fondu nemůže být stejný jako váš LEI',
    WARNING_MEPOZADAVKY_RC:
        'Upozornění: Vyhledávání probíhá na základě zadaného rodného čísla. Pokud k danému RČ jsou v centrální evidenci evidovány jiné jmenné údaje, než které jste uvedli na vstupním formuláři, jsou Vám tyto údaje také poskytnuty v tomto výstupu a je nutné z Vaší strany provést kontrolu osoby oproti základním registrům. V případě potřeby kontaktujte CDCP.',
    URL_ADRESA: 'URL adresa',
    TYPZADOSTI_EU: 'Zjištění',
    TYPZADOSTI_NZ: 'Výpis',
    SRD_PRUVODCE_VYPIS_C: 'C. Přijemce odpovědi',
    AMLZ_ZADOST_MENU: 'Žádost o přístup k AML',
    AMLZ_ZADOST_TEXT:
        'Není u Vás povoleno právo pro aktualizaci AMLZ. V případě, že jste oprávněn podat AMLZ. Tak použijte Oprávnění podat AMLZ',
    OSOBY_LEGALENTITY: 'Osoby jednající za právnickou osobu',
    OSOBY: 'Osoby jednající za emitenta',
    OSOBY_ADMIN: 'Osoby jednající za administrátora emise',
    ZADOST_PRAVO_TEXT: 'Pro ostatní oprávnění je potřeba změnit způsob autentizace',
    ZADOST_PRAVO_TEXT2:
        'Žádost o ISIN může podat osoba oprávněná zastupovat emitenta.  Pro tuto žádost CDCP nepožaduje doložení zástupčího oprávnění.',
    ZADOST_PRAVO_OPRAVNENI: 'Oprávnění osoby',
    ZADOST_PRAVO_IDENTIFIKACE_EL: 'Podpis - kvalifikovaný certifikát',
    ZADOST_PRAVO_IDENTIFIKACE_BI: 'BankID',
    ZADOST_PRAVO_IDENTIFIKACE_SC: 'Kopie dvou dokladů totožnosti',
    ZADOST_PRAVO_IDENTIFIKACE_DOC_TEST: 'Nejdříve vyplňte všechny údaje a poté stáhněte dokument a podepište',

    ZADOST_PRAVO_AMLZ: 'Správce AML',
    ZADOST_PRAVO_PRIKAZY: 'Příkazy / oznámení emitenta',
    ZADOST_PRAVO_SMLOUVY: 'Smlouvy / dodatky',
    ZADOST_PRAVO_UZIVATELE: 'Osoby jednající za emitenta (správa uživatelů)',
    ZADOST_PRAVO_VYPIS: 'Výpis z emise a služby pro výpočet průměrných cen',
    ZADOST_PRAVO_VIDETVYPIS: 'Právo vidět výpisy podané dalšími uživateli emitenta',
    ZADOST_PRAVO_UPIS: 'Právo primární úpis (snížení / navýšení)',
    ZADOST_PRAVO_UPISSICAV: 'Primární úpis SICAV/OPF (snížení / navýšení)',
    ZADOST_PRAVO_SRD: 'Služby dle SRD II',

    ZADOST_PRAVO_AMLZ_TOOLTIP:
        'podává/aktualizuje AML a provádí správu osob jednajících za emitenta. Pokud emitent nemá povinnost podat AML provede pouze identifikaci osob jednajících za emitenta (C2)',
    ZADOST_PRAVO_PRIKAZY_TOOLTIP:
        'Změna údajů o emitentovi, snížení / zvýšení ZK, štěpení, splynutí, vytěsnění a další operace',
    ZADOST_PRAVO_SMLOUVY_TOOLTIP: 'Uzavření smlouvy o vedení / registrace emise, snížení / zvýšení počtu CP v emisi',
    ZADOST_PRAVO_VIDETVYPIS_TOOLTIP:
        'Uživatel může vidět a stáhnout výpis z emise, který podal jiný uživatel emitenta  (zastupitelnost více osob)',
    ZADOST_PRAVO_UPIS_TOOLTIP: 'Zadání pokynů pro úpis – seznam nabyvatelů',
    ZADOST_PRAVO_SRD_TOOLTIP:
        'Emitent zasílá informace např. o VH (pro emitenta na regulovaném trhu EU je povinností takto informovat o VH)',

    ZADOST_PRISTUP: 'Může přistupovat do aplikace Můj depozitář?',
    ZADOST_PRISTUP_AUTH: 'Nový způsob autentizace do Můj depozitář',
    ZADOST_PRISTUP_AUTH_NEMA: 'Způsob autentizace do Můj depozitář',
    ZADOST_PRISTUP_AUTH_TEXT: 'Ke změně způsobu přihlašování dojde po schválení dotazníku AMLZ referentem',
    ZADOST_PRISTUP_AUTH_BI_TEXT:
        'Pokud se chcete přihlašovat (autorizovat) pomocí Bank iD, musíte vybrat způsob identifikace osoby Bank iD.',
    ZADOST_PRISTUP_BAKIND_BTN: 'Pokračovat BankID',
    ZADOST_C2_BANKUCET: 'Číslo bankovního účtu emitenta',
    PRAVO_ZADOST_EXPIRED: 'Platnost tohoto odkazu vypršela',
    EMITENT_PREHLED_TITLE_LEGALENTITY: 'Osoby oprávněné zastupovat právnickou osobu',
    EMITENT_PREHLED_TITLE_EMITENT: 'Osoby oprávněné zastupovat emitenta',
    EMITENT_PREHLED_TITLE_ADMEMIT: 'Osoby oprávněné zastupovat administrátora emise',
    EMITENT_PREHLED_TEXT_LEGALENTITY:
        'Aktuálně nemáte přístup k právnické osobě. V případě, že jste oprávněn přistupovat k právnické osobě, použijte volbu bold(Žádost o přístup k právnické osobě).',
    EMITENT_PREHLED_TEXT_EMITENT:
        'Pro zobrazení seznamu osob musíte mít povoleno právo Osoby jednající za emitenta (správa uživatelů) nebo AMLZ. V případě, že máte právo jednat z emitenta, tak prosím podejte žádost o doplnění.',
    EMITENT_PREHLED_TEXT_ADMEMIT:
        'Pro zobrazení seznamu osob musíte mít povoleno právo Osoby jednající za administrátora emise (správa uživatelů) nebo AMLZ. V případě, že máte právo jednat z emitenta, tak prosím podejte žádost o doplnění.',
    EMITENT_ZASTUPUJICI_OSOBY_ROZP: 'Oprávnění podat AMLZ',
    EMITENT_ZASTUPUJICI_OSOBY_BEZPRAVA:
        'Pro zobrazení seznamu osob musíte mít povoleno právo Osoby jednající za emitenta (správa uživatelů) nebo AMLZ. V případě, že máte právo jednat za emitenta, prosím podejte žádost o doplnění.',
    NOVY_UCET_DUPLICITA: 'Účet pro daného zákazníka již existuje',
    NOVY_UCET_CERTIFIKAT: 'neplatný certifikát',
    ID_OSOBY_EVIDENCE: 'ID osoby v navazující evidenci',
    ID_MAJITELE: 'ID osoby v navazující evidenci',
    LZE_ODESLAT: 'Lze odeslat do',
    PREDCISLI_UCTU: 'Předčíslí účtu',
    CISLO_BANKY: 'Číslo banky',
    ZADOST_O_DOPLNENI_OSOBY: 'Žádost o přístup ke správě osob',
    STAVZADOSTI_SIMPLE_CEKA: 'Probíhá zpracování',
    STAVZADOSTI_SIMPLE_ZAMITNUTO: 'Zamítnuto',
    STAVZADOSTI_SIMPLE_HOTOVO: 'Zpracováno',
    STAVZADOSTI_SIMPLE_HOTOVOIIS: 'Zpracováno',
    STAVZADOSTI_SIMPLE_ROZP: 'Rozpracovaná',
    STAVZADOSTI_SIMPLE_DOPL: 'Rozpracovaná',
    STAVZADOSTI_SIMPLE_CDCPCEKA: 'Čeká na zpracování CDCP',
    STAVZADOSTI_SIMPLE_CDCPDOPL: 'Vráceno k doplnění',
    STAVZADOSTI_SIMPLE_UZIVKDOPL: 'Čeká na doplnění údajů',
    STAVZADOSTI_SIMPLE_UZIVDOPL: 'Zkontrolujte údaje',
    STAVZADOSTI_SIMPLE_UZIVCEKA: 'Čeká na doplnění údajů',
    STAVZADOSTI_SIMPLE_UZIVEMAIL: 'Znovu poslat e-mail',
    STAVZADOSTI_SIMPLE_UZIVEMAIL_ALT: 'Poslat odkaz k doplnění údajů',
    STAVZADOSTI_SIMPLE_AUTKONTROLA: 'Probíhá zpracování',
    STAVZADOSTI_SIMPLE_KDOPL: 'Čeká na doplnění',
    STAVZADOSTI_SIMPLE_CDCPKEKONTR: 'Probíhá zpracování',
    STAVZADOSTI_SIMPLE_CDCPKEKONTR_ALT: 'Zpracováno',
    STAVZADOSTI_SIMPLE_CDCPKONTR: 'Probíhá zpracování',
    STAVZADOSTI_SIMPLE_INI: 'K doplnění',
    STAVZADOSTI_SIMPLE_CDCPKDOPL: 'K doplnění',
    STAVZADOSTI_SIMPLE_ZNEPLATNENO: 'Zneplatněno',
    STAVZADOSTI_SIMPLE_PRIDAT: 'Možné osoby',
    SMS_RESEND_TXT: 'Nepřišla Vám SMS?',
    SMS_RESEND_BTN: 'Znovu zaslat SMS kód',
    SMS_INVALID: 'Neplatný sms kód',
    GIIN_INVALID: 'Neplatný GIIN kód',
    C2_OSOBA_DOKLADY_TOTOZ_TEXT:
        'Upozornění: Poplatek za ověření každé osoby jednající za emitenta prostřednictvím dvou dokladů totožnosti je {{suma}} Kč. Pro dokončení identifikace v rámci AML je nutné přiložit doklad o zaplacení poplatku z účtu vedeného na jméno emitenta. Můžete využít bezplatnou možnost identifikace prostřednictvím Bankovní identity nebo prostřednictvím certifikátu',
    PRISTUPDEPOZITAR_ANO: 'Ano',
    PRISTUPDEPOZITAR_NE: 'Ne',
    PRISTUPDEPOZITAR_POZDEJI: 'Později',
    C2_OSOBA_PODEPSAT_BANKID: 'Podepsat pomocí BankID',
    ZADANO_CDCP: 'Podáno přes CDCP',
    ZAEVIDOVANE_CP: 'Zaevidované CP',
    UPSANE_CP: 'Upsané CP',
    NEUPSANE_CP: 'Neuspané CP',
    ZAEVIDOVANE_UCTY: 'Zaevidované účty',
    KONTROLA: 'Kontrola probíhá',
    TYP_PREVODU: 'Typ převodu',
    DATUN_UHRADY_LATEST: 'Nejzazší datum úhrady',
    CENA_CP: 'Cena za CP',
    PREDPOKLADANY_POCET_CP: 'Předpokládaný počet CP v emisi',
    POCET_CP_ZMENA: 'Změna v počtu CP',
    MIN_POCET_CP: 'Minimální počet uhrazených CP pro automatické provedení úpisu',
    MIN_POCET_CP_SHORT: 'Minimální počet uhrazených CP',
    VYPLATA_BANKUC: 'Číslo bankovního účtu pro výplatu / Kód banky',
    TYP_PREVODU_BEZZAPLACENI: 'Bez zaplacení',
    TYP_PREVODU_PROTIZAPLACENI: 'Proti zaplacení',
    TYP_PREVODU_PROTIABEZZAPL: 'Proti zaplacení a bez zaplacení',
    TYP_PREVODU_PXVNABEZZAPL: 'PX Veřejná nabídka a bez zaplacení',
    DFP_TEXT1: 'DFP - Delivery free payment',
    DFP_TEXT2: 'platby jsou prováděny na účet emitenta uvedený v rámci registrace',
    DVP_TEXT1: 'DVP - Delivery versus payment',
    DVP_TEXT2: 'platba přes CDCP',
    TYP_PREVODU_DFP: 'Bez zaplacení',
    TYP_PREVODU_DVP: 'Proti zaplacení',
    MIN_POCET_CP_ERR: 'Hodnota pole nesmí být větší než Předpokládaný počet CP v emisi.',
    UHRAZENE_CP: 'Uhrazené CP',
    NEUHRAZENE_CP: 'Neuhrazené CP',
    NEUHRAZENE_UCTY: 'Neuhrazené účty',
    ZASTAVENE_CP: 'Počet zastavených CP',
    EDITOVAT_UPIS: 'Editovat úpis',
    EDITOVAT_ZRUSIT: 'Zrušit úpis',
    EDITOVAT_POTVRDIT: 'Potvrdit úpis',
    EDITOVAT_SMAZAT: 'Smazat úpis',
    POTVRZENI_DLT_TEXT: 'Potvrzením úpisu snížíte objem emise na ',
    ZRUSENI_DLT_TEXT: 'Potvrzením zrušení úpisu dojde k refundaci uhrazených CP v hodnotě ',
    POTVRZENI_DLT_TEXT_TOP: 'Potvrďte prosím, že si opravdu přejete provést úpis.',
    ZRUSENI_DLT_TEXT_TOP: 'Potvrďte prosím, že si opravdu přejete zrušit úpis.',
    ZMAZAT_DLT_CONFIRM_SHORT: 'Přejete si opravdu tyto položky smazat?',
    ZMAZAT_DLT_CONFIRM:
        'Některé z položek vybraných ke smazání jsou ve stavu Uhrazeno. Pokud tyto položky smažete, DLT provede automatickou refundaci těchto plateb. Přejete si opravdu tyto položky smazat?',
    AKTUALNI_STAV_UPISU: 'Aktuální stav úpisu:',
    OBJEM_EMISE: 'Objem emise',
    POTVRZENI_UPISU: 'Potvrzení úpisu',
    ZRUSENI_UPISU: 'Zrušení úpisu',
    ZRUSENI_DLT_SUCCESS: 'Požadavek na úpis byl úspěšně zrušen.',
    ZRUSENI_DLT_ERR: 'Zrušení požadavku na úpis se nezdařilo. Pro další postup nás kontaktujte na mujdepozitar@pse.cz.',
    POTVRZENI_DLT_SUCCESS: 'Požadavek na úpis byl úspěšně potvrzen a objem emise byl snížen.',
    POTVRZENI_DLT_ERR:
        'Potvrzení požadavku na úpis a snížení emise se nezdařilo. Pro další postup nás kontaktujte na mujdepozitar@pse.cz.',
    POTVRDIT_UDAJE: 'Potvrdit správnost údajů',
    CESTINA: 'Čeština',
    ENGLISH: 'Angličtina',
    POCET: 'Počet',
    SRD_HLASOVANI_STAV_A: 'Nehlasováno',
    SRD_HLASOVANI_STAV_B: 'Rozpracováno',
    SRD_HLASOVANI_STAV_C: 'Hlasováno ve všech bodech',
    SRD_HLASOVANI_STAV_D: 'Lhůta pro hlasování uplynula',
    SRD_HLASOVANI_MAX_POC_HLASU: 'Počet zahlasovaných/maximální počet hlasů',
    HROMADNE_HLASOVAT: 'Hromadně hlasovat',
    POTVRZENI_PLATBY: 'Potvrzení platby',
    AMLZ_AGENDA_ZADOST_CONFIRM: 'Opravdu si přejete podat žádost?',
    INVALID_PREDCISLI: 'Neplatné předčíslí účtu',
    INVALID_CISLOUCTU: 'Neplatné číslo účtu',
    INVALID_KODBANKY: 'Neplatný kód banky',
    NELZE_POKRACOVAT_NELZEC2: 'Nelze pokračovat z důvodu aktualizace osob, provádí uživatel:',
    NELZE_POKRACOVAT_NELZEAML: 'Nelze pokračovat z důvodu aktualizace AMLZ, provádí uživatel:',
    AMLZ_POSLAT_EMAIL: 'Poslat odkaz k doplnění udajů',
    AUTH_PUVODNI: 'Původní přihlášení',
    AUTH_NOVY: 'Nové přihlášení',
    OBCANSTVI_DOKLAD_OBCANKA: 'Občanský průkaz',
    OBCANSTVI_DOKLAD_PAS: 'Pas',
    OBCANSTVI_DOKLAD_RIDICAK: 'Řidičský průkaz',
    OBCANSTVI_DOKLAD_JINE: 'jiný doklad',
    AMLZ: 'AMLZ',
    LANG_SELECT_PDF: 'Jazyk PDF',
    PREDVOLBA_VAL_ERR: 'Prosím vyberte předvolbu',
    NEVALIDNI_TEL: 'Neplatné telefonní číslo',
    AMLZ_OSOBA_PODPIS_TEXT:
        'V případě, že chcete provést změnu Vámi zadaných údajů, odstraňte nejprve podepsaný soubor.',
    NASTAVENI: 'Nastavení',
    ODHLASIT_PRO_NEAKTIVITU: 'Odhlášení za',
    FUND_SELFMANAGED: 'Je fond samosprávný?',
    LEI_DATA_AKTUALIZOVANE: 'Údaje žádosti byly aktualizovány',
    SRD_HROMADNE_TEXT: 'Vyberte účty, pro které chcete hlasovat',
    BANKSIGN_ERR: 'BankID se nepodařilo dokončit požadovanou akci. Zkuste později nebo kontaktuje správce.',
    AMLZ_C6_DISABLED_C2_DUPLICITA: 'Z důvodu duplicity osob nelze pokračovat',
    AMLZ_C6_DISABLED: 'Nejsou zpracované všechny osoby v C2',
    AMLZ_C6_DISABLED_C2: 'Jedna osoba zastupující emitenta (C2) musí mít vyplněna v oprávnění osoby položku Vše.',
    AMLZ_C6_DISABLED_C2DLT:
        'Chyba při načtení osoby zastupující právnickou osobu. Dotazník ke kontrole právnické osoby podle AMLZ nelze odeslat.',
    AMLZ_C2_DISABLED: 'Jedna osoba zastupujicího emitenta musí mít vyplněna v opravnění osoby položku Vše.',
    AMLZ_C2_CHECKBOXERR_AML: 'Pro podání žádosti musí mít osoba vyplněno oprávnění AML nebo vše.',
    AMLZ_C2_CHECKBOXERR_OSOBY: 'Pro podání žádosti musí mít osoba vyplněno oprávnění správa uživatelů nebo vše.',
    AMLZ_C2_PUT_SUCCESS: 'Údaje byly uloženy',
    UPIS_NAVYSENI_DATE_ERR: 'není povolen datum navýšení emise',
    AMLZ_AGENDA_MODAL_TITLTE: 'Zjištěna změna dat',
    AMLZ_AGENDA_MODAL_TEXT: 'Chcete uložit změny, které jste provedli?',
    UCET_NEEXISTUJE: 'Pro Vás není evidován žádný uživatelský přistup.',
    ZMENA_UCTU: 'Změna účtu',
    F12: 'F12 - bez zástav',
    F13: 'F13 - včetně zástav, PPN',
    F14: 'F14 - včetně zástav, PPN, majetkových účtu',
    F37: 'F37 - včetně zástav, PPN, peněžních účtů',
    F42: 'F42 - včetně zástav, PPN, peněžních účtů, ESM',
    F1: 'F1 - výpočet průměrné ceny 6M',
    F1A: 'F1A - výpočet průměrné ceny 1M',
    AMLZ_TYPZADOSTI_PRISTUPAMLZ: 'Přistup k AMLZ',
    AMLZ_TYPZADOSTI_PRISTUPAMLZPO: 'Přistup k AMLZ',
    AMLZ_TYPZADOSTI_AMLZ: 'Amlz',
    AMLZ_TYPZADOSTI_AMLZPO: 'Amlz',
    AMLZ_TYPZADOSTI_C2ZRUSEM: 'Zrušený přistup',
    AMLZ_TYPZADOSTI_C2ZRUSAM: 'Zrušený přistup',
    AMLZ_TYPZADOSTI_C2ZRUSEMPO: 'Zrušený přistup',
    AMLZ_TYPZADOSTI_C2ZRUSAMPO: 'Zrušený přistup',
    AMLZ_TYPZADOSTI_PRISTUPC2EM: 'Přístup ke správě osob emitenta',
    AMLZ_TYPZADOSTI_PRISTUPC2EMPO: 'Přístup ke správě osob právnické osoby',
    AMLZ_TYPZADOSTI_PRISTUPC2AMLZ: 'Přístup ke správě osob administrátora emise',
    AMLZ_TYPZADOSTI_C2AKTEM: 'Emitent aktualizuje osobu',
    AMLZ_TYPZADOSTI_C2AKTEM_PO: 'právnická osoba aktualizuje osobu',
    AMLZ_TYPZADOSTI_C2NOVYEM: 'Emitent zakládá novou osobu',
    AMLZ_TYPZADOSTI_C2NOVYEM_PO: 'právnická osoba zakládá novou osobu',
    AMLZ_TYPZADOSTI_C2AKTAM: 'Administrátor emise aktualizuje osobu',
    AMLZ_TYPZADOSTI_C2NOVYAM: 'Administrátor emise zakládá novou osobu',
    AMLZ_OSOBY_MENU_LEGALENTITY: 'Seznam osob jednajících za právnickou osobu',
    AMLZ_OSOBY_MENU: 'Seznam osob jednajících za emitenta',
    AMLZ_OSOBY_TEXT: 'Pokud chcete upravit osoby, aktualizujte požadavek amlz.',
    LOADING_PXKLIC: 'Čeká na schválení v aplikaci PX Klíč',
    DELETE_CONFIRM_TEXT: 'Opravdu si přejete smazat',
    DELETE_CONFIRM_C2_TEXT: 'Opravdu si přejete odebrat tuto osobu?',
    DELETE_CONFIRM_C2_TEXT_ALT: 'Opravdu si přejete zrušit tuto žádost?',
    AMLZ_C2_PLATINSTRUKCE_ERR: 'Vložte potvrzení platby',
    EMITENT_UCET_ZRUSENI_SUCC: 'Účet byl úspěšně deaktivován',
    AMLZ_C2_DUPLICITA: 'duplicitní výskyt',
    AMLZ_C2_OBCANSTVI_ERR: 'Nepředané platné doklady. Kontaktuje svou banku.',
    AMLZ_C2_ADRESA_ERR:
        'Bankovní Identita nám nepředala požadované údaje pro identifikaci osoby. Kontaktujte Vaši banku.',
    ZKONTROLUJTE: 'Zkontrolovat',
    ODSTRANIT_OSOBU: 'Odbebrat osobu',
    AMLZ_CERT_TEXT: 'Certifikát musí doplnit osoba přes odkaz.',
    KLICZAMITNUTO: 'Akce byla zamítnuta v aplikaci PX Klíč',
    LANG_SELECT: 'Jazyk',
    AMLZ_C5_PEP_DEL_ERR:
        'Osobu nejde odstranit z důvodu , že v předaných informací od BankdId je uvedeno, že je osoba PEP.',
    AMLZ_C2_ISIN_PRAVA:
        'Tento uživatel může podat za Vaši společnost jen žádost o ISIN. Pokud si nepřejete, aby uživatel nadále mohl podávat žádosti, kontaktujte uživatele.',
    LZE_EVIDOVAT_DO: 'Lze zaevidovat do',
    NOTFOUND_TITLE: 'Stránka nenalezena',
    NOTFOUND_TEXT: 'Omlouváme se, ale požadovaná stránka nebyla nalezena',
    C2_BANKID_LOGIN_ERR: 'Chcete-li použít pro novou autentizaci BankID, musíte zvolit způsob identifikace BankID.',
    DLT_MENU_PRAVNICKE_OSOBY_PREHLED: 'Přehled právnických osob',
    DLT_MENU_PRAVNICKE_OSOBY_DETAIL: 'Správa právnické osoby',
    ISIN_PODKLADOVEHO_AKTIVA: 'ISIN podkladového aktiva',
    VYMENNY_POMER_CISLO: 'Výměnný poměr',
    VYMENNY_POMER_TOOTLTIP: 'Kolik nových za jeden původní (číslo na 6 desetinných míst)',
    VYMENNY_POMER: 'Výměnný poměr',
    STRIKE_CENA: 'Strike cena',
    STRIKE_MENA: 'Měna strike ceny',
    MENA_JMENOVITEHODNOTY: 'Měna jmenovité hodnoty',
    NOVA_JMENOVITAHODNOTA: 'Nová jmenovitá hodnota',
    DATUM_SPLACENI_EMISE: 'Datum postupného splacení emise',
    MENA_VYPORADANI: 'Měna vypořádání',
    NOVA_PRAVNICKA: 'Nová právnická osoba',
    CENTRALNI_DEPOZITAR: 'CENTRÁLNÍ DEPOZITÁŘ CENNÝCH PAPÍRŮ',
    CENNE_PAPIRY_BLOCKCHAIN: 'CENNÉ PAPÍRY NA BLOCKCHAINOVÉ TECHNOLOGII',
    PRVNI_OVERENY_ZPUSOB: 'PRVNÍ OVĚŘENÝ POSTUP PRO BEZPEČNÝ OBCHOD',
    ERR_BOUNDARY_HEAD: 'Chyba aplikace',
    ERR_BOUNDARY_TEXT: 'Omlouváme se, ale nastala neočekávaná chyba v aplikaci:',
    ERR_BOUNDARY_ZNOVU: 'Přejděte na úvodní stránku a pokuste se akci opakovat znovu.',
    AMLZ_C2_UCTY_MSG_NOVYVSECHNYUCTY: 'Všechny spravované účty uživatele budou přesunuty pod nový způsob přihlášení.',
    AMLZ_C2_UCTY_MSG_UZIVJEDENUCET:
        'Bude Vám přesunut jen daný učet emitenta. Ostatní spravované účty zůstanou pod stávajícím způsobem přihlášení. V případě, že potřebuje přesunout i ostatní účty je potřeba aktualizovat příslušné AML.',
    AMLZ_C2_UCTY_MSG_UZIVVSECHNYUCTY: 'Všechny spravované účty uživatele budou přesunuty pod nový způsob přihlášení.',
    BANK_USEDTO_LOGIN: 'Banka použitá k přihlášení',
    AMLZ_DLT_POTVRZENI_TITLE: 'Souhlas s podmínkami smlouvy o zřízení účtu v DLT evidenci',
    AMLZ_DLT_POTVRZENI_SUB: 'Podmínky smluvního ujednání',
    AMLZ_DLT_POTVRZENI_I: 'I. Práva a závazky',
    AMLZ_DLT_POTVRZENI_I1:
        '(1) Touto smlouvou se CDCP zavazuje zřídit pro majitele účtu účet vlastníka cenných papírů v DLT evidenci zaknihovaných cenných papírů vedené centrálním depozitářem a poskytovat následně majiteli účtu služby spojené s jeho obsluhou. ',
    AMLZ_DLT_POTVRZENI_I2:
        '(2) Na základě této smlouvy CDCP umožní majiteli účtu dávat pokyny k zápisu či změně údajů o majiteli účtu, k vypořádání převodů či přechodů zaknihovaných cenných papírů, k vyhotovení výpisu z majetkového účtu a k provedení dalších služeb týkajících se zaknihovaných cenných papírů, předpokládaných právními předpisy či Pravidly DLT evidence. ',
    AMLZ_DLT_POTVRZENI_I3:
        '(3) Majitel odpovídá za správnost a úplnost pokynů podávaných centrálnímu depozitáři. Majitel účtu podává CDCP pokyny v souladu s Pravidly DLT evidence a v souladu se skutečnostmi opravňujícími ho provedení pokynu požadovat. Na základě požadavku je majitel účtu povinen oprávněnost pokynu CDCP prokázat a doložit doklady. ',
    AMLZ_DLT_POTVRZENI_I4:
        '(4) CDCP a majitel účtu se dohodli, že majitel účtu bude předávat CDCP požadavky na vyhotovení výpisů, pokyny k zápisům do evidence a vypořádání převodů prostřednictvím aplikace DLT Depozitář. Na základě dohody CDCP s majitelem účtu může být pokyn poskytnut na základě písemného požadavku, doloženého dokumenty prokazujícími požadovaný zápis. ',
    AMLZ_DLT_POTVRZENI_II: 'II. Cena a platební podmínky',
    AMLZ_DLT_POTVRZENI_II1:
        '(1) Majitel účtu se zavazuje uhradit CDCP ceny za poskytnuté služby ve výši a způsobem stanovenými DLT Ceníkem centrálního depozitáře (dále jen „ceník“), zveřejněným na internetových stránkách CDCP. ',
    AMLZ_DLT_POTVRZENI_II2:
        '(2) Majitel účtu je povinen uhradit CDCP také poplatky stanovené ceníkem za porušení příslušných povinností vyplývajících mu z Pravidel DLT evidence nebo ceníkem. ',
    AMLZ_DLT_POTVRZENI_II3:
        '(3) CDCP je oprávněn ceny stanovené ceníkem změnit. CDCP oznamuje změny ceníku majiteli účtu prostřednictvím webové a mobilní aplikace DLT depozitář. Pokud majitel účtu, před navrhovaným datem účinnosti změn, změny ceníku týkající se jeho postavení neodmítne, stává se nové znění závazné pro obě strany; v opačném případě může změny odmítnout písemnou výpovědí smlouvy.',
    AMLZ_DLT_POTVRZENI_III: 'III. Ostatní ujednání',
    AMLZ_DLT_POTVRZENI_III1:
        '(1) Vzájemná práva a povinnosti smluvních stran neupravená touto smlouvou se řídí zejména také Pravidly DLT evidence, ZPKT a nařízením (EU) 858/2022 o pilotním režimu pro tržní infrastruktury založené na technologii sdíleného registru a o změně nařízení (EU) č. 600/2014 a (EU) č. 909/2014 a směrnice 2014/65/EU (dále jen „DLTR“).',
    AMLZ_DLT_POTVRZENI_III2:
        '(2) CDCP je oprávněn Pravidla DLT evidence změnit. Účinnosti pak změny nabývají uveřejněním na internetových stránkách www.cdcp.cz (dále jen „internetové stránky“), nestanoví-li centrální depozitář jinak. Pokud majitel účtu, před navrhovaným datem účinnosti změn, změny Pravidel DLT evidence týkající se jeho postavení neodmítne, stává se nové znění závazné pro obě strany; v opačném případě může změny odmítnout písemnou výpovědí smlouvy.',
    AMLZ_DLT_POTVRZENI_III3:
        '(3) Majitel účtu bere na vědomí, že DLT evidence je vedena v pilotním režimu podle DLTR, má dočasný charakter a může být kdykoli ukončena. V případě ukončení pilotního režimu bude emitentům v DLT evidenci nabídnuta možnost bezplatného převodu jejich záznamů do centrální evidence, která se nevede na DLT. Otevření účtu v centrální evidenci vyžaduje služeb účastníka centrálního depozitáře. ',
    AMLZ_DLT_POTVRZENI_III4:
        '(4) Smlouva se sjednává na dobu neurčitou a může být vypovězena kteroukoliv ze smluvních stran s měsíční výpovědní lhůtou, jejíž běh počíná prvního dne kalendářního měsíce následujícího po měsíci, v němž byla výpověď doručena druhé smluvní straně. Výpověď smlouvy majitelem účtu nemá do doby převedení zaknihovaných cenných papírů na nový účet vůči CDCP právní účinky a majitel účtu se zavazuje hradit CDCP cenu za služby dle platného ceníku i po vypovězení smlouvy. K ukončení této smlouvy dochází i v případě rozhodnutí o ukončení pilotního režimu. ',
    AMLZ_DLT_POTVRZENI_III5:
        '(5) Majitel účtu bere na vědomí, že CDCP bude zpracovávat jako správce poskytnuté osobní údaje. Zpracování bude prováděno pro účely realizace smluvního vztahu a případně pro účely ochrany oprávněných zájmů CDCP. Další informace o zpracování osobních údajů jsou uvedeny na internetových stránkách CDCP',
    AMLZ_DLT_POTVRZENI_CHECKBOX: 'Souhlasím s podmínkami smlouvy o zřízení účtu v DLT evidenci',
    POTVRZENI_CHECKBOX: 'Souhlasím s podmínkami',
    TYP_DOKUMENTU: 'Typ dokumentu',
    TYP_DOKUMENTU_SMLUVA: 'Smlouva / Dodatek',
    TYP_DOKUMENTU_PRIKAZ: 'Příkaz emitenta',
    TYP_DOKUMENTU_ZADOST: 'Žádost o výpis z emise',
    TYP_SMLOUVY: 'Typ smlouvy',
    TYP_SMLOUVY_SMLOUVY: 'Smlouva o vedení evidence emise',
    TYP_SMLOUVY_SMLOUVA: 'Smlouva o vedení evidence emise',
    TYP_SMLOUVY_SMLOUVYDLT: 'Smlouva o vedení evidence emise v DLT evidenci',
    TYP_SMLOUVY_SMLOUVADLT: 'Smlouva o vedení evidence emise v DLT evidenci',
    TYP_SMLOUVY_DODATEK: 'Dodatek o zápisu nové emise do evidence',
    TYP_SMLOUVY_DODATEKDLT: 'Dodatek o zápisu nové emise do DLT evidence',
    TYP_SMLOUVY_NAVYSENI: 'Dodatek o zápisu zvýšení počtu zaknihovaných cenných papírů',
    TYP_SMLOUVY_NAVYSENIDLT: 'Dodatek o zápisu zvýšení počtu zaknihovaných cenných papírů DLT evidenci',
    DOKMUNET_IDENTIFIKACE_TITLE: 'Smlouva o vedení evidence emise',
    DOKMUNET_IDENTIFIKACE_SUBTITLE: 'Identifikace smluvních stran',
    DOKMUNET_IDENTIFIKACE_CDCP: 'Centrální depozitář cenných papírů',
    JINY_DRUH_AKCIE_POPIS: 'Popis jiného druhu akcie',
    ROZCESTNIK_LOGIN_EMITENT_TITLE: 'Můj depozitář – Emitent / Emitent DLT',
    ROZCESTNIK_LOGIN_EMITENT_TEXT:
        'Můj depozitář, je webový portál, prostřednictvím kterého jsou emitentům poskytovány služby elektronickou cestou. Pro přístup ke službám je nutná registrace.',
    ROZCESTNIK_LOGIN_SRD_TITLE: 'Můj depozitář – Výkon akcionářských práv dle SRD II',
    ROZCESTNIK_LOGIN_SRD_TITLE_SHORT: 'Výkon akcionářských práv dle SRD II',
    ROZCESTNIK_LOGIN_SRD_TEXT:
        'Můj depozitář, je webový portál, prostřednictvím kterého může akcionář společnosti obchodované na regulovaném trhu EU provést výkon svých akcionářských práv za předpokladu, že tuto možnost emitent umožňuje. Pro přístup ke službám je nutná registrace, kterou provedete prostřednictvím účastníka CDCP, u kterého máte veden majetkový účet.',
    ROZCESTNIK_LOGIN_STATNISPRAVA_TITLE: 'Můj depozitář – Státní správa',
    ROZCESTNIK_LOGIN_STATNISPRAVA_TEXT:
        'Můj depozitář, je webový portál, prostřednictvím kterého jsou orgánům veřejné moci poskytovány služby elektronickou cestou. Pro přístup ke službám je nutné uzavření smlouvy s CDCP.',
    ROZCESTNIK_LOGIN_SUBTITLE: 'Chci se přihlásit v roli /k online službám:',
    ROZCESTNIK_LOGIN_NU: 'Výpis z nezařazeného účtu online',
    ROZCESTNIK_LOGIN_NU_TEXT:
        'Služba umožňuje majiteli účtu v nezařazené evidenci získat online výpis k aktuálnímu datu',
    ROZCESTNIK_LOGIN_MU: 'Zjištění nezařazeného majetkového účtu zemřelého',
    ROZCESTNIK_LOGIN_MU_TEXT:
        'Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví umožňuje dědici zjistit, zda v evidenci nezařazených účtů (tzv. nezařazený účet převzatý po zaniklém Středisku cenných papírů) je nebo není veden účet zůstavitele (zemřelého). Služba je určena těm, kteří již mají ukončeno dědické řízení.',
    ROZCESTNIK_LOGIN_NUE: 'Změny údajů u majitele nezařazeného účtu',
    ROZCESTNIK_LOGIN_NUE_TEXT:
        'Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní, či adresní údaje a zapsat nebo změnit číslo bankovního účtu (např. pro účely výplaty výnosů. Údaje lze změnit pouze údaji evidovanými o majiteli účtu v základních registrech a předanými bankovní identitou.)',
    ROZCESTNIK_LOGIN_EMITENT: 'Emitent / Emitent DLT',
    ROZCESTNIK_LOGIN_EMITENT_SUB: 'Registrace emise / Příkazy emitenta',
    ROZCESTNIK_LOGIN_DLT: 'Majitel účtu DLT',
    ROZCESTNIK_LOGIN_LEI: 'Identifikátor LEI',
    ROZCESTNIK_LOGIN_LEI_SUB1: 'Přidělení LEI',
    ROZCESTNIK_LOGIN_LEI_SUB2: 'Prodloužení platnosti LEI',
    ROZCESTNIK_LOGIN_LEI_SUB3: 'Transfer LEI',
    ROZCESTNIK_LOGIN_LEI_SUB4: 'Aktualizace LEI',
    VYPIS_Z_EMISE: 'Výpis z emise',
    ZALOZENI_UCTU: 'Založení účtu',
    VSTUP_UCET: 'Vstup na účet',
    MAJITEL_NU: 'Majitel nezařazeného účtu',
    VYPIS_Z_UCTU_SIMPLE: 'Výpis z účtu',
    ZAPIS_ZMENY_UDAJU: 'Zápis změny údajů',
    ZJISTENI_UCTU: 'Zjištění účtu zemřelého',
    MAJITEL_UCTU: 'Majitel účtu',
    UCASTNIK_CDCP: 'Účastník CDCP',
    STATNI_SPRAVA: 'Státní správa',
    STATNI_SPRAVA_1: 'Notáři',
    STATNI_SPRAVA_2: 'Insolvenční správci',
    STATNI_SPRAVA_3: 'Likdvidátoři',
    STATNI_SPRAVA_4: 'Soudy',
    STATNI_SPRAVA_5: 'Státní zastoupitelství',
    STATNI_SPRAVA_6: 'Ostatní',
    OSTATNI: 'Ostatní',
    HLASOVANIE_DO: 'Hlasovat lze do',
    AKCIONAR_HLASOVANI_MAXPOCET_SELECT: 'Hlasovat za maximální počet hlasů',
    AGENDA_FORMULAR_OPPAS: 'Doplňte do Státní občanství druh dokladu občanský průkaz nebo pas',
    BANKOVNI_UCET: 'Bankovní účet',
    DOKUMNETY_DODATEK_IDENTIFIKACE_TEXT:
        'Emitent a centrální depozitář se tímto dodatkem dohodli, že centrální depozitář pro emitenta založí evidenci nové emise zaknihovaných cenných papírů specifikovaných níže („zaknihované cenné papíry“), provede vypořádání primární emise zaknihovaných cenných papírů a povede jejich evidenci. Podmínky vydání zaknihovaných cenných papírů, vedení evidence emise a práva a povinnosti smluvních stran jsou uvedeny ve Smlouvě o vedení evidence emise uzavřené mezi emitentem a centrálním depozitářem, v Provozním řádu centrálního depozitáře a Pravidlech vypořádacího systému centrálního depozitáře.',
    DOKUMNETY_DODATEKDLT_IDENTIFIKACE_TEXT:
        'Emitent a centrální depozitář se tímto dodatkem dohodli, že centrální depozitář pro emitenta založí evidenci nové emise zaknihovaných investičních nástrojů specifikovaných níže („zaknihované cenné papíry“), provede vypořádání primární emise zaknihovaných cenných papírů a povede jejich evidenci v rámci DLT evidence. Podmínky vydání zaknihovaných cenných papírů, vedení evidence emise a práva a povinnosti smluvních stran jsou uvedeny ve Smlouvě o vedení evidence emise uzavřené mezi emitentem a centrálním depozitářem a v Pravidlech DLT evidence.',
    DOKUMNETY_SMLOUVA_IDENTIFIKACE_DLT_TEXT:
        'Smluvní strany uzavírají ve smyslu ustanovení § 1746 odst. 2 zákona č. 89/2012 Sb., občanský zákoník, v platném znění (dále jen “NOZ”) a ustanovení § 94a zákona č. 256/2004 Sb., o podnikání na kapitálovém trhu, v platném znění (dále jen „ZPKT“) tuto smlouvu o vedení evidence emise zaknihovaných cenných papírů v DLT evidenci.',
    DOKUMNETY_SMLOUVA_IDENTIFIKACE_TEXT:
        'Smluvní strany uzavírají ve smyslu ustanovení § 1746 odst. 2 zákona č. 89/2012 Sb., občanský zákoník, v platném znění (dále jen “NOZ”) a ustanovení § 94a zákona č. 256/2004 Sb., o podnikání na kapitálovém trhu, v platném znění (dále jen „ZPKT“) tuto smlouvu o vedení evidence emise zaknihovaných cenných papírů v centrální evidenci cenných papírů.',
    DOKUMENTY_SLOUVA_PREDMET_TITLE: 'Předmět smlouvy',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_I1:
        '1. Předmětem této smlouvy je založení a vedení evidence emise nebo emisí zaknihovaných cenných papírů (dále jen „evidence emise“), vydaných emitentem a uvedených v dodatcích této smlouvy (dále jen „emise cenných papírů“), v centrální evidenci cenných papírů ve smyslu ustanovení § 92 ZPKT (dále jen „centrální evidence“).',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_I2:
        '2. Založením evidence emise se pro účely této smlouvy rozumí zápis údajů o emitentovi a o jeho emisi do centrální evidence a pod vedením emise všechny služby centrálního depozitáře vyplývající z obecně závazných právních předpisů a poskytované emitentovi na základě této smlouvy.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_II: 'II. Podmínky poskytování služeb a jejich rozsah',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_II1:
        '1. Centrální depozitář poskytuje služby evidence emise podle příslušných ustanovení ZPKT a podle ustanovení této smlouvy. Rozsah a způsob poskytování služeb se řídí Provozním řádem Centrálního depozitáře cenných papírů, a.s. (dále jen „Provozní řád“).',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_II2:
        '2. Emisi zaknihovaných cenných papírů vedené v centrální evidenci musí být přiděleno identifikační označení podle mezinárodního systému číslování pro identifikaci cenných papírů (ISIN).',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III: 'III. Forma a způsob podávání příkazů a oznámení emitenta',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III1:
        '1. Emitent podává žádosti, příkazy a oznámení (dále jen „příkazy“) centrálnímu depozitáři',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III1A: 'a) vyplněním požadované služby do webové aplikace Můj Depozitář nebo',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III1B: 'b) doručením do datové schránky centrálního depozitáře.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III2:
        '2. Příkazy podané emitentem, které mají za následek provedení změny v evidenci emise, musí být učiněny v souladu s Provozním řádem, v souladu s obecně závaznými právními předpisy a doloženy doklady, které oprávněnost provedení takových změn prokazují.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III3:
        '3. Příkazy emitenta kótovaných cenných papírů, které mají za následek provedení změn v evidenci emise, musí být centrálnímu depozitáři oznámeny nejméně 5 pracovních dnů před jejich zápisem. Má-li být lhůta zkrácena, musí centrální depozitář obdržet písemný souhlas příslušných regulovaných trhů.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_III4:
        '4. Žádost o výpis z evidence emise podává emitent především prostřednictvím webového portálu Můj depozitář, jejíž užívání je emitentovi zpřístupněno prostřednictvím certifikátu vydaného certifikační autoritou nebo prostřednictvím aplikace PX klíč a nebo prostřednictvím Bankovní identity. Způsob užívání webového portálu Můj depozitář je uveden na internetových stránkách.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV: 'IV. Práva a povinnosti emitenta',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV1:
        '1. Emitent je za podmínek v této Smlouvě stanovených oprávněn využívat služby centrálního depozitáře.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV2:
        '2. Emitent je povinen bez zbytečného odkladu a v souladu s touto smlouvou a Provozním řádem informovat o všech skutečnostech majících vliv na údaje zapsané do evidence emise, dále o zahájení insolvenčního řízení a o všech rozhodnutích o úpadku.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV3:
        '3. Emitent je též v souladu s Provozním řádem povinen centrální depozitář neprodleně informovat o změně údajů týkajících se jeho osoby zapsaných do evidence emitentů.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV4:
        '4. Podmínky vypořádání primární emise zaknihovaných cenných papírů, tj. vydání zaknihovaných cenných papírů na účty vlastníků cenných papírů, a podmínky speciálních operací se zaknihovanými cennými papíry uvedených v Provozním řádu, o které emitent v souvislosti s touto smlouvou centrální depozitář písemně požádá, jsou upravovány formou dodatků k této Smlouvě.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV5:
        '5. Emitent zaknihovaných dluhopisů s variabilní úrokovou sazbou je povinen centrálnímu depozitáři oznámit úrokovou sazbu pro nové úrokové období bezprostředně poté, kdy tuto sazbu stanovil. V případě, že tak neučiní, centrální depozitář povede v údajích evidence emise informaci o poslední oznámené úrokové sazbě, která bude použita k výpočtu alikvotního úrokového výnosu, který vstupuje do vypořádání obchodů a transakcí s cennými papíry.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_IV6:
        '6. Emitent má právo požádat centrální depozitář o bezplatné zveřejnění informací uvedených v §120 odst. 7 ZPKT na internetových stránkách centrálního depozitáře. Centrální depozitář zveřejní na svých internetových stránkách údaje i bez žádosti emitenta, pokud tak stanoví platné právní předpisy. Centrální depozitář je oprávněn poskytovat informace poskytnuté emitentem účastníkům centrálního depozitáře.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_V: 'V. Cenové, platební a fakturační podmínky ',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_V1:
        'Ceny za služby poskytnuté podle této smlouvy, jakož i platební a fakturační podmínky, se řídí Ceníkem centrálního depozitáře.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI: 'VI. Další ujednání',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI1:
        '1. Centrální depozitář je oprávněn na svých internetových stránkách a ve Věstníku centrálního depozitáře uveřejňovat veřejně přístupné informace o emitentovi a emisi cenných papírů získané ze své evidence. Na základě dohody mezi emitentem a centrálním depozitářem může centrální depozitář stejným způsobem zveřejnit za smluvní úplatu i další informace o emitentovi a emisi zaknihovaných cenných papírů kromě informací uvedených v čl. IV odst. 6.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI2:
        '2. Emitent prohlašuje, že ke dni podpisu této smlouvy jsou splněny všechny podmínky, které právní předpisy České republiky stanoví pro vydání zaknihovaných cenných papírů.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI3:
        '3. Smluvní strany se dohodly, že pokud emitent podáním nesprávného, neúplného, opožděného nebo jinak chybného příkazu prokazatelně způsobí centrálnímu depozitáři zvýšení nákladů, které by mu jinak nevznikly, uhradí emitent takto vzniklé náklady v plné výši na základě centrálním depozitářem vystavené faktury.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI4:
        '4. Smluvní strany se dohodly, že pokud centrální depozitář nesprávným, neúplným, opožděným nebo jinak chybným zpracováním řádně podaného a jinak správného příkazu emitenta prokazatelně způsobí emitentovi zvýšení nákladů, které by mu jinak nevznikly, uhradí centrální depozitář takto vzniklé náklady v plné výši na základě emitentem vystavené faktury.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI5:
        '5. Náhradu podle odstavců 3 a 4 lze nárokovat nejdéle do jednoho roku ode dne, kdy se oprávněná strana prokazatelně dozvěděla o tom, že nastaly důvody pro její uplatnění podle této smlouvy.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI6:
        '6. Uplatněním institutu náhrady nákladů podle odstavce 3 a 4 není dotčeno právo smluvních stran na náhradu vzniklé škody ve smyslu příslušných ustanovení obecně závazných právních předpisů a není ani dotčena odpovědnost smluvních stran z těchto předpisů vyplývající.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VI7:
        '7. Smluvní strany se dohodly, že jakékoliv spory vznikající z této smlouvy budou řešit přednostně vzájemnou dohodou.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII: 'VII. Ukončení a zánik smluvních vztahů',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1: '1. Smlouva může být ukončena',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1A: 'a) dohodou smluvních stran',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII1B: 'b) výpovědí jedné ze smluvních stran',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII2:
        '2. Podmínkou pro ukončení smlouvy podle odstavce 1 písm. b) je, že v centrální evidenci není veden žádný zaknihovaný cenný papír emise zaknihovaných cenných papírů emitenta. Pro ukončení smlouvy tímto způsobem se sjednává dvouměsíční výpovědní lhůta, která začíná běžet prvním dnem kalendářního měsíce následujícího po dni doručení výpovědi.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3: '3. Smlouva zaniká',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3A:
        'a) zrušením emitenta s právním nástupcem v důsledku jeho sloučení, splynutí nebo rozdělení,',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3B:
        'b) ukončením likvidace emitenta, vydáním potvrzení o zrušení emise na příkaz likvidátora,',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3C: 'c) přeměnou investičního fondu na otevřený podílový fond,',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VII3D:
        'd) zrušením všech emisí zaknihovaných cenných papírů emitenta zapsaných v evidenci centrálního depozitáře v důsledku jeho rozhodnutí o přeměně zaknihovaných cenných papírů na cenné papíry.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII: 'VIII. Společná a závěrečná ustanovení',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII1:
        '1. Smlouva se uzavírá na dobu neurčitou. Účinnosti nabývá dnem podpisu obou smluvních stran.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII2: '2. Tato smlouva může být změněna pouze písemnou dohodou smluvních stran.',
    DOKUMENTY_SLOUVA_PREDMET_TEXT_VIII3:
        '3. Tato smlouva je vyhotovena ve dvou stejnopisech s platností originálu, z nichž každá ze smluvních stran obdrží po jednom výtisku.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I: 'I.	Předmět smlouvy',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I1:
        '1.	Předmětem této smlouvy je založení a vedení evidence emise nebo emisí zaknihovaných cenných papírů (dále jen „evidence emise“), vydaných emitentem a uvedených v dodatcích této smlouvy (dále jen „emise cenných papírů“), v DLT evidenci. DLT evidencí se rozumí centrální evidence cenných papírů ve smyslu ustanovení § 92 ZPKT (dále jen „centrální evidence“) vedená v pilotním režimu na technologii sdíleného registru (dále jen „DLT“) ve smyslu nařízení (EU) 858/2022 o pilotním režimu pro tržní infrastruktury založené na technologii sdíleného registru (dále jen „DLTR“). DLT evidence je zcela oddělena od centrální evidence zaknihovaných cenných papírů, která se na DLT nevede.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_I2:
        '2.	Založením evidence emise se pro účely této smlouvy rozumí zápis údajů o emitentovi a o jeho emisi do DLT evidence a pod vedením emise všechny služby centrálního depozitáře vyplývající z obecně závazných právních předpisů a poskytované emitentovi na základě této smlouvy.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II: 'II.	Podmínky poskytování služeb a jejich rozsah',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II1:
        '1.	Centrální depozitář poskytuje služby evidence emise podle příslušných ustanovení ZPKT a podle ustanovení této smlouvy. Rozsah a způsob poskytování služeb se řídí Pravidly DLT evidence (dále jen „pravidla“).',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_II2:
        '2.	Emisi zaknihovaných cenných papírů vedené v DLT evidenci musí být přiděleno identifikační označení podle mezinárodního systému číslování pro identifikaci cenných papírů (ISIN).',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III: 'III.	Forma a způsob podávání příkazů a oznámení emitenta',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III1:
        '1.	Emitent podává žádosti, příkazy a oznámení (dále jen „příkazy“) centrálnímu depozitáři vyplněním požadované služby do webové aplikace Můj Depozitář.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III2:
        '2.	Podávat příkazy centrálnímu depozitáři mohou za emitenta pouze osoby, které jsou k tomu určeny prostřednictvím webového portálu Můj Depozitář. ',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III3:
        '3.	Příkazy podané emitentem, které mají za následek provedení změny v evidenci emise, musí být učiněny v souladu s pravidly, v souladu s obecně závaznými právními předpisy a doloženy doklady, které oprávněnost provedení takových změn prokazují.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_III4:
        '4.	Žádost o výpis z evidence emise podává emitent zásadně prostřednictvím webového portálu Můj  depozitář',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV: 'IV.	Práva a povinnosti emitenta',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV1:
        '1.	Emitent je za podmínek v této Smlouvě stanovených oprávněn využívat služby centrálního depozitáře.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV2:
        '2.	Emitent je povinen bez zbytečného odkladu a v souladu s touto smlouvou a pravidly informovat o všech skutečnostech majících vliv na údaje zapsané do evidence emise, dále o zahájení insolvenčního řízení a o všech rozhodnutích o úpadku.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV3:
        '3.	Emitent je povinen centrální depozitář neprodleně informovat o změně údajů týkajících se jeho osoby zapsaných do evidence emitentů.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV4:
        '4.	Podmínky vypořádání primární emise zaknihovaných cenných papírů, tj. vydání zaknihovaných cenných papírů na účty vlastníků cenných papírů, a podmínky speciálních operací se zaknihovanými cennými papíry uvedených v pravidlech, o které emitent v souvislosti s touto smlouvou centrální depozitář písemně požádá, jsou upravovány formou dodatků k této Smlouvě.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_IV5:
        '5.	Emitent zaknihovaných dluhopisů s variabilní úrokovou sazbou je povinen centrálnímu depozitáři oznámit úrokovou sazbu pro nové úrokové období bezprostředně poté, kdy tuto sazbu stanovil. V případě, že tak neučiní, centrální depozitář povede v údajích evidence emise informaci o poslední oznámené úrokové sazbě, která bude použita k výpočtu alikvotního úrokového výnosu, který vstupuje do vypořádání obchodů a transakcí s cennými papíry.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_V: 'V.	Cenové, platební a fakturační podmínky',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_V1:
        'Ceny za služby poskytnuté podle této smlouvy, jakož i platební a fakturační podmínky, se řídí DLT Ceníkem centrálního depozitáře.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI: 'VI.	Další ujednání',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI1:
        '1.	Centrální depozitář je oprávněn na svých internetových stránkách a v DLT Věstníku centrálního depozitáře uveřejňovat veřejně přístupné informace o emitentovi a emisi cenných papírů získané z DLT evidence. ',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI2:
        '2.	Smluvní strany se dohodly, že pokud emitent podáním nesprávného, neúplného, opožděného nebo jinak chybného příkazu prokazatelně způsobí centrálnímu depozitáři zvýšení nákladů, které by mu jinak nevznikly, uhradí emitent takto vzniklé náklady v plné výši na základě centrálním depozitářem vystavené faktury.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI3:
        '3.	Smluvní strany se dohodly, že pokud centrální depozitář nesprávným, neúplným, opožděným nebo jinak chybným zpracováním řádně podaného a jinak správného příkazu emitenta prokazatelně způsobí emitentovi zvýšení nákladů, které by mu jinak nevznikly, uhradí centrální depozitář takto vzniklé náklady v plné výši na základě emitentem vystavené faktury.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI4:
        '4.	Náhradu podle odstavců 2 a 3 lze nárokovat nejdéle do jednoho roku ode dne, kdy se oprávněná strana prokazatelně dozvěděla o tom, že nastaly důvody pro její uplatnění podle této smlouvy.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI5:
        '5.	Uplatněním institutu náhrady nákladů podle odstavce 2 a 3 není dotčeno právo smluvních stran na náhradu vzniklé škody ve smyslu příslušných ustanovení obecně závazných právních předpisů a není ani dotčena odpovědnost smluvních stran z těchto předpisů vyplývající.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VI6:
        '6.	Smluvní strany se dohodly, že jakékoliv spory vznikající z této smlouvy budou řešit přednostně vzájemnou dohodou.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII: 'VII.	Ukončení a zánik smluvních vztahů',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1: '1.	Smlouva může být ukončena',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1A: 'a)	dohodou smluvních stran',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII1B: 'b)	výpovědí jedné ze smluvních stran.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII2:
        '2.	Podmínkou pro ukončení smlouvy emitentem podle odstavce 1 písm. b) je, že v DLT evidenci není veden žádný zaknihovaný cenný papír emise zaknihovaných cenných papírů emitenta. Pro ukončení smlouvy tímto způsobem se sjednává dvouměsíční výpovědní lhůta, která začíná běžet prvním dnem kalendářního měsíce následujícího po dni doručení výpovědi.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3: '3.	Smlouva zaniká',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3A: 'a)	ukončením pilotního režimu vedení DLT evidence, ',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3B:
        'b)	zrušením emitenta s právním nástupcem v důsledku jeho sloučení, splynutí nebo rozdělení,',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3C: 'c)	ukončením likvidace emitenta, ',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3D: 'd)	vydáním potvrzení o zrušení emise na příkaz likvidátora,',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3E: 'e)	přeměnou investičního fondu na otevřený podílový fond,',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VII3F:
        'f)	zrušením všech emisí zaknihovaných cenných papírů emitenta zapsaných v DLT evidenci v důsledku jeho rozhodnutí o přeměně zaknihovaných cenných papírů na cenné papíry nebo změně evidence zaknihovaných cenných papírů.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII: 'VIII.	Společná a závěrečná ustanovení',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII1:
        '1.	Smlouva se uzavírá na dobu neurčitou. Účinnosti nabývá dnem podpisu obou smluvních stran.',
    DOKUMENTY_SLOUVADLT_PREDMET_TEXT_VIII2: '2.	Tato smlouva může být změněna pouze písemnou dohodou smluvních stran.',
    DOKUMENTY_OSOBY_CDCP: 'Centrální depozitář cenných papírů zastupují',
    DOKUMENTY_OSOBY_JINA_PODEPSANO_TEXT: 'Pokud chcete přidat další osobu, nejprve povolte úpravy',
    DOKUMENTY_OSOBY_TEXT:
        'V případě, že si přejete, aby smlouvu podepsali jiné fyzické osoby zastupující emitenta, proveďte aktualizaci osob C2 - Údaje o všech fyzických osobách zastupujících emitenta v dotazníku AMLZ.',
    DOKUMENTY_OSOBY_NACIST_BTN: 'Načíst osoby z AMLZ',
    DOKUMENTY_OSOBY_STAV_NEPODEPSANO: 'Dokument není podepsán',
    DOKUMENTY_OSOBY_STAV_ODESLANO: 'Odesláno k podpisu',
    DOKUMENTY_OSOBY_STAV_PODEPSANO: 'Podepsáno',
    ZPUSOB_ZSTUPENI: 'Způsob zastoupení',
    OSOBA_JE: 'Osoba je',
    DOKUMENTY_OSOBY_NACIST: 'Přejete si opravdu načíst osoby z aktuálně platného AMLZ?',
    DOKUMENTY_OSOBY_ZMENIT_JINA: 'Po úpravě údajů budete muset tento dokument znovu podepsat',
    DOKUMENTY_OSOBY_ZMENIT:
        'Přejete si opravdu změnit nastavení podepisování dokumentu? Některé osoby dokument již podepsaly nebo jim byl odeslán e-mail s odkazem k podpisu. Pokud odpovíte "Ano", všechny osoby budou muset dokument podepsat znovu.',
    DOKUMENTY_PODPISY_TITLE: 'Podpis smlouvy',
    PRIKAZY_PODPISY_TITLE: 'Podpis Příkazu',
    PODEPSAT: 'Podepsat',
    ZNOVU_PODEPSAT: 'Znovu podepsat',
    ODESLAT_K_PODPISU: 'Odeslat k podpisu',
    ZPUSOB_PODEPSANI: 'Způsob podepisování',
    BISIGN: 'BankID SIGN',
    PODEPSAT_BISIGN: 'Podepsat pomocí BankID SIGN',
    PODEPSAT_CERT: 'Nahrát podepsaný dokument',
    PODEPSAT_CERT_BTN: 'Stáhnout dokument k podpisu certifikátem',
    DOKUMENTY_STAV_ROZP: 'Rozpracovaný',
    DOKUMENTY_STAV_DOPL: 'Čeká na doplnění',
    DOKUMENTY_STAV_KDOPLNENI: 'K doplnění',
    DOKUMENTY_STAV_AUTKONTROLA: 'Probíhá zpracování',
    DOKUMENTY_STAV_AUTKONTROLAPRED: 'Probíhá předběžná kontrola',
    DOKUMENTY_STAV_CDCPKEKONTR: 'Probíhá zpracování',
    DOKUMENTY_STAV_CDCPKONTRPRED: 'Předběžná kontrola probíhá',
    DOKUMENTY_STAV_CDCPKONTR: 'Probíhá zpracování',
    DOKUMENTY_STAV_KPODPISU: 'Probíhá zpracování',
    DOKUMENTY_STAV_PODEPSANO: 'Probíhá zpracování',
    DOKUMENTY_STAV_ODESLANO: 'Odesláno k podpisu',
    DOKUMENTY_STAV_HOTOVOIIS: 'Zpracováno',
    DOKUMENTY_STAV_ZAMITNUTO: 'Zamítnuto',
    DOKUMENTY_STAV_ZRUSENO: 'Zrušeno',
    DOKUMENTY_STAV_NEOVERENO: 'Podepsáno',
    DOKUMENTY_STAV_OVERENO: 'Podepsáno',
    DOKUMENTY_STAV_AKCEPTOVANO: 'Akceptováno',
    DOKUMENTY_STAV_CDCPKEKONTRPRED: 'Probíhá předběžná kontrola',
    DOKUMENTY_STAV_ZPRACOVANO: 'Zpracováno',
    DOKUMENTY_STAV_ZKONTROLOVANO: 'Lze podepsat',
    DOKUMENTY_STAV_CHYBNYPODPIS: 'Pokusili jste se podepsat soubor jako jiná osoba. Soubor nebyl podepsán.',
    DOKUMENTY_STAVPODPISU_NEPODEPSAL: 'Dokument není podepsán',
    DOKUMENTY_STAVPODPISU_ODESLANO: 'Odesláno k podpisu',
    DOKUMENTY_STAVPODPISU_ODESLANO_SELF: 'K podpisu',
    DOKUMENTY_STAVPODPISU_PODEPSANO: 'Podepsáno',
    DOKUMENTY_STAVPODPISU_NEOVERENO: 'Podepsáno',
    DOKUMENTY_STAVPODPISU_OVERENO: 'Podepsáno',
    DOKUMENTY_STAVPODPISU_ZAMITNUTO: 'Referent zamítl podpis',
    DOKUMENTY_STAVPODPISU_CHYBNYPODPIS: 'Neprošlo podepsání přes Bank ID',
    DOKUMENTY: 'Dokumenty',
    DOKUMENTY_NENI_PRAVO:
        'Pro zobrazení dokumentů musíte mít jako osoba jednající za emitenta nastaveno právo Smlouvy a dodatky a /nebo Příkazy emitenta. Kontaktujete osobu emitenta oprávněnou provést změnu nastavení.',
    DOKUMENTY_NENI_ISIN: 'Doposud nemáte schválenou Žádost emitenta o přidělení ISIN. V záložce ISIN zvolte nový ISIN.',
    DOKUMENTY_NENI_SMLOUVA:
        'Doposud nemáte uzavřenou rámcovou smlouvu o vedení evidence emise. V záložce Nový dokument zvolte Smlouva o vedení evidence emise, nebo Smlouva o vedení evidence emise v DLT evidenci.',
    DOKUMENTY_PREHLED_SMLOUVA: 'Smlouva o vedení evidence emise byla uzavřena v listinné podobě.',
    DOKUMENTY_PREHLED_SMLOUVA_EL: 'Smlouva o vedení evidence emise byla uzavřena v elektronické podobě.',
    DOKUMENTY_PREHLED_SMLOUVADLT: 'Smlouva o vedení evidence emise v DLT evidenci byla uzavřena v listinné podobě.',
    DOKUMENTY_PREHLED_SMLOUVADLT_EL:
        'Smlouva o vedení evidence emise v DLT evidenci byla uzavřena v elektronické podobě.',
    NOVY_DOKUMNET: 'Nový dokument',
    DOKUMENTY_MENU: 'Dokumenty a Emisní operace',
    ODESLAT_CDCP: 'Odeslat do CDCP',
    PODEPISUJICI_OSOBA: 'Podepisující osoba',
    PODPIS_DOKUMENTU: 'Podpis dokumentu',
    PODPIS_DOKUMENTU_TEXT: 'Pro přístup k podpisu dokumentu Vám bude zaslána SMS s kódem',
    PODPIS_CONFIRM_SUCC: 'Podpis byl úspěšný',
    PODANE_DOKUMENTY: 'Podané dokumenty',
    DOKUMENTY_SOUBOR_CHYBNYPODPIS: 'Neprošel podpis - jiná osoba',
    DOKUMENTY_SOUBOR_SOUBORHASH: 'Byl nahrán jiný soubor',
    DOKUMENTY_SOUBOR_BEZPODPISU: 'Byl nahrán soubor bez podpisu. Soubor smažte a nahrajte podepsaný soubor',
    DOKUMENTY_SOUBOR_NEPLATNYCERT: 'Byl nahrán soubor s neplatným podpisem',
    DOKUMENTY_SOUBOR_NEZNAMYCERT: 'Soubor je podepsán nepodporovanou autoritou',
    PODPIS_ODKAZ_SUCC_TEXT: 'Dokument byl úspěšně podepsán.',
    DOKUMENTY_PRIKAZ_ZMENY: 'Příkaz emitenta k zápisu změny údajů o emitentovi',
    DOKUMENTY_PRIKAZ_SPLYNUTI: 'Příkaz emitenta ke splynutí emisí — hromadná výměna zaknihovaných akcií',
    DOKUMENTY_PRIKAZ_SNIZENI: 'Příkaz emitenta ke snížení počtu zaknihovaných cenných papírů v emisi',
    DOKUMENTY_PRIKAZ_PREVODITELNOST: 'Příkaz emitenta k zápisu nebo zrušení zápisu omezené převoditelnosti akcií',
    DOKUMENTY_PRIKAZ_ZRUSENI: 'Příkaz emitenta ke zrušení evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_FORMA: 'Příkaz emitenta ke změně zápisu formy nebo druhu zaknihovaných akcií (§342 ZOK)',
    DOKUMENTY_PRIKAZ_VYTESNENI: 'Příkaz emitenta k zápisu přechodu vlastnictví v důsledku vytěsnění (§ 386 ZOK)',
    DOKUMENTY_PRIKAZ_JMENOVITA: 'Příkaz emitenta ke změně jmenovité hodnoty zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_STEPENI: 'Příkaz emitenta k provedení štěpení',
    DOKUMENTY_PRIKAZ_ADMINZMENY: 'Příkaz emitenta k zápisu nebo změně zápisu o administrátorovi emise',
    DOKUMENTY_PRIKAZ_ADMINZRUS: 'Příkaz emitenta ke zrušení administrátora emise bez náhrady',
    DOKUMENTY_PRIKAZ_ZRUSPPN: 'Příkaz emitenta ke zrušení zápisu PPN (např. na zaměstnaneckých akciích)',
    DOKUMENTY_PRIKAZ_PRODLUZ: 'Příkaz emitenta k prodloužení splatnosti dluhopisu',
    DOKUMENTY_PRIKAZ_ZMENEMISI: 'Příkaz emitenta ke změně vybraných údajů emise',
    DOKUMENTY_PRIKAZ_ZAPISBLOK: 'Příkaz emitenta k zápisu blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_SEZUPIS: 'Příkaz emitenta k vydání zaknihovaných cenných papírů na účty nabyvatelů',
    DOKUMENTY_PRIKAZ_BLOKACE: 'Příkaz emitenta k zápisu blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_PREVODNASL: 'Příkaz emitenta k zápisu PPN k zaměstnaneckým akciím při následných převodech',
    DOKUMENTY_PRIKAZ_PREVODZPET: 'Příkaz emitenta ke zrušení zápisu PPN a zpětný převod na zaměstnaneckých akciích',
    DOKUMENTY_PRIKAZ_EMISELIKV: 'Příkaz jiné osoby ke zrušení emise - likvidace',
    DOKUMENTY_PRIKAZ_EMISEFUZE: 'Příkaz jiné osoby ke zrušení emise - fúze/dle zákona o přeměnách',
    DOKUMENTY_PRIKAZ_EMISELIST: 'Příkaz jiné osoby ke zrušení emise - přeměna na cenný papír (listinný)',
    DOKUMENTY_PRIKAZ_ZMENFUZE: 'Příkaz jiné osoby ke změně emitenta (převzetí závazků) - fúze',
    DOKUMENTY_PRIKAZ_ZMENJINA: 'Příkaz jiné osoby k jiné změně',
    DOKUMENTY_PRIKAZ_ZMENREGI: 'Příkaz emitenta ke změně místa registrace evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_OMEZPREVOD: 'Souhlas emitenta s převodem zaknihovaných cenných papírů s omezenou převoditelností.',
    DOKUMENTY_PRIKAZ_VYPIS: 'Žádost o výpis z emise',
    DOKUMENTY_PRIKAZ_SHORT_OMEZPREVOD:
        'Souhlas emitenta s převodem zaknihovaných cenných papírů s omezenou převoditelností.',
    DOKUMENTY_PRIKAZ_SHORT_ZMENREGI: 'ke změně místa registrace evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_SHORT_ZRUSPPN: 'ke zrušení zápisu PPN (např. na zaměstnaneckých akciích)',
    DOKUMENTY_PRIKAZ_SHORT_PRODLUZ: 'k prodloužení splatnosti dluhopisu',
    DOKUMENTY_PRIKAZ_SHORT_ZMENEMISI: 'ke změně vybraných údajů emise',
    DOKUMENTY_PRIKAZ_SHORT_ZAPISBLOK: 'k zápisu blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_SHORT_ZMENY: 'k zápisu změny údajů o emitentovi',
    DOKUMENTY_PRIKAZ_SHORT_SPLYNUTI: 'ke splynutí emisí — hromadná výměna zaknihovaných akcií',
    DOKUMENTY_PRIKAZ_SHORT_SNIZENI: 'ke snížení počtu zaknihovaných cenných papírů v emisi',
    DOKUMENTY_PRIKAZ_SHORT_PREVODITELNOST: 'k zápisu nebo zrušení zápisu omezené převoditelnosti akcií',
    DOKUMENTY_PRIKAZ_SHORT_ZRUSENI: 'ke zrušení evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_SHORT_FORMA: 'ke změně zápisu formy nebo druhu zaknihovaných akcií (§342 ZOK)',
    DOKUMENTY_PRIKAZ_SHORT_VYTESNENI: 'k zápisu přechodu vlastnictví v důsledku vytěsnění (§ 386 ZOK)',
    DOKUMENTY_PRIKAZ_SHORT_JMENOVITA: 'ke změně jmenovité hodnoty zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_SHORT_STEPENI: 'k provedení štěpení',
    DOKUMENTY_PRIKAZ_SHORT_ADMINZMENY: 'k zápisu nebo změně zápisu o administrátorovi emise',
    DOKUMENTY_PRIKAZ_SHORT_ADMINZRUS: 'ke zrušení administrátora emise bez náhrady',
    DOKUMENTY_PRIKAZ_SHORT_SEZUPIS: 'k vydání zaknihovaných cenných papírů na účty nabyvatelů',
    DOKUMENTY_PRIKAZ_SHORT_BLOKACE: 'k zápisu blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_SHORT_PREVODNASL: 'k zápisu PPN k zaměstnaneckým akciím při následných převodech',
    DOKUMENTY_PRIKAZ_SHORT_PREVODZPET: 'ke zrušení zápisu PPN a zpětný převod na zaměstnaneckých akciích',
    DOKUMENTY_PRIKAZ_SHORT_EMISELIKV: 'ke zrušení emise - likvidace',
    DOKUMENTY_PRIKAZ_SHORT_EMISEFUZE: 'ke zrušení emise - fúze',
    DOKUMENTY_PRIKAZ_SHORT_ZMENFUZE: 'ke změně emitenta (převzetí závazků) - fúze',
    DOKUMENTY_PRIKAZ_SHORT_EMISELIST: 'ke zrušení emise - přeměna na cenný papír (listinný)',
    DOKUMENTY_PRIKAZ_SHORT_ZMENJINA: 'k jiné změně',
    DOKUMENTY_PRIKAZ_SHORT_VYPIS: 'žádost o výpis z emise',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZMENREGI: 'místa registrace evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZRUSPPN: 'zápisu PPN (např. na zaměstnaneckých akciích)',
    DOKUMENTY_PRIKAZ_EXTRASHORT_PRODLUZ: 'k prodloužení splatnosti dluhopisu',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZMENEMISI: 'vybraných údajů emise',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZAPISBLOK: 'blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZMENY: 'údajů o emitentovi',
    DOKUMENTY_PRIKAZ_EXTRASHORT_SPLYNUTI: 'ke splynutí emisí — hromadná výměna zaknihovaných akcií',
    DOKUMENTY_PRIKAZ_EXTRASHORT_SNIZENI: 'ke snížení počtu zaknihovaných cenných papírů v emisi',
    DOKUMENTY_PRIKAZ_EXTRASHORT_PREVODITELNOST: 'zápisu omezené převoditelnosti akcií',
    DOKUMENTY_PRIKAZ_EXTRASHORT_PREVODITELNOST_ALT: 'omezené převoditelnosti akcií',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZRUSENI: 'evidence emise zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_FORMA: 'zápisu formy nebo druhu zaknihovaných akcií (§342 ZOK)',
    DOKUMENTY_PRIKAZ_EXTRASHORT_VYTESNENI: 'přechodu vlastnictví v důsledku vytěsnění (§ 386 ZOK)',
    DOKUMENTY_PRIKAZ_EXTRASHORT_JMENOVITA: 'jmenovité hodnoty zaknihovaných cenných papírů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_STEPENI: 'k provedení štěpení',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ADMINZMENY: 'zápisu o administrátorovi emise',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ADMINZRUS: 'administrátora emise bez náhrady',
    DOKUMENTY_PRIKAZ_EXTRASHORT_SEZUPIS: 'zaknihovaných cenných papírů na účty nabyvatelů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_BLOKACE: 'blokace před splatností emise dluhopisů',
    DOKUMENTY_PRIKAZ_EXTRASHORT_PREVODNASL: 'PPN k zaměstnaneckým akciím při následných převodech',
    DOKUMENTY_PRIKAZ_EXTRASHORT_OMEZPREVOD:
        'Souhlas emitenta s převodem zaknihovaných cenných papírů s omezenou převoditelností.',
    DOKUMENTY_PRIKAZ_EXTRASHORT_PREVODZPET: 'zápisu PPN a zpětný převod na zaměstnaneckých akciích',
    DOKUMENTY_PRIKAZ_EXTRASHORT_EMISELIKV: 'emise - likvidace',
    DOKUMENTY_PRIKAZ_EXTRASHORT_EMISEFUZE: 'emise - fúze',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZMENFUZE: 'emitenta (převzetí závazků) - fúze',
    DOKUMENTY_PRIKAZ_EXTRASHORT_EMISELIST: 'emise - přeměna na cenný papír (listinný)',
    DOKUMENTY_PRIKAZ_EXTRASHORT_ZMENJINA: 'k jiné změně',
    DOKUMENTY_PRIKAZ_EXTRASHORT_VYPIS: 'žádost o výpis z emise',
    DOKUMENTY_PRIKAZ: 'Typ příkazu',
    DOKUMENTY_PRIKAZ_ZAPIS: 'Příkazy k zápisu',
    DOKUMENTY_PRIKAZ_ZMENA: 'Příkazy ke změně',
    DOKUMENTY_PRIKAZ_ZRUSE: 'Příkazy ke zrušení',
    DOKUMENTY_PRIKAZ_ERR: 'Vyberte jeden z příkazů',
    ISIN_UPLOAD_TEXT: 'Vložte všechny dokumenty, na základě kterých jste vyplňovali žádost o ISIN.',
    BANK_UCET_EMITENT: 'Bankovní účet emitenta',
    DOKUMENT_DODATEK_ZPUSOBPREDANI_CDCP:
        'Příkaz emitenta k vydání zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři',
    DOKUMENT_DODATEK_ZPUSOBPREDANI_MD: 'Příkaz podaný emitentem prostřednictvím webového portálu Můj depozitář',
    DOKUMENT_DODATEK_ZPUSOBPREDANI_PARSYST:
        'Příkaz účastníka vypořádacího systému vložením příkazu do párovacího systému',
    ISIN_PARAMS: 'Parametry přiděleného ISIN',
    DOKUMNET_DODATEK_ISINDETAIL_TITLE: 'Specifikace cenného papíru dle přiděleného ISIN',
    ISIN_OK_CHECKBOX: 'Potvrzuji správnost údajů dle přiděleného ISIN',
    ISIN_OK_TEXT_CHANGE: 'Pokud požadujete změnu údajů, použijte žádost o změnu ISIN.',
    DOKUMENT_DODATEK_DETAIL_BLOKACE: 'Emitent požaduje blokaci emise před splatností',
    DOKUMENT_DODATEK_DETAIL_BLOKACE_TEXT:
        'Pokud zvolíte Ne, je možné následně nejpozději 5 dní před rozhodným datem pro výplatu jistiny vyplnit formulář Příkaz emitenta k zápisu blokace před splatností emise dluhopisů.',
    DOKUMENT_DODATEK_DETAIL_VYBRANECP: 'Akcie jsou vydávané s požadavkem na zápis PPN (např. pro zaměstnanecké akcie)',
    DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO: 'Rozsah zápisu PPN',
    DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO_VSECHNY: 'Zápis PPN je požadován na všechny majetkové účty',
    DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO_VYBRANE: 'Zápis PPN je požadován pouze na vybrané majetkové účty',
    DOKUMENT_DODATEK_DETAIL_DATUM_REHGISTRACE_ERR: 'Datum registrace emise v evidenci není validní',
    DOKUMENT_DODATEK_DETAIL_DATUM_REHGISTRACE: 'DATUM REGISTRACE EMISE V EVIDENCI',
    DOKUMENT_DODATEK_DETAIL_DATUM_REHGISTRACE_TEXT:
        'Datum registrace emise označuje pracovní den stanovený dohodou emitenta s centrálním depozitářem nebo den, který nastane nejdříve 5 pracovních dní po doručení řádně podaného návrhu tohoto dodatku centrálnímu depozitáři. Datum registrace emise musí předcházet datu vydání zaknihovaných cenných papírů na účty nabyvatelů minimálně o 2 pracovní dny.',
    DOKUMENT_DODATEK_DETAIL_POZADOVANE_DATUM_ERR:
        'Datum uvedený v poli požadované datum vydání zaknihovaných cenných papírů nesmí předcházet datum emise v emisních podmínkách',
    DOKUMENT_DODATEK_DETAIL_POZADOVANE_DATUM:
        'POŽADOVANÉ DATUM VYDÁNÍ ZAKNIHOVANÝCH CENNÝCH PAPÍRŮ NA ÚČTY NABYVATELŮ (DATUM VYPOŘÁDÁNÍ PRIMÁRNÍ EMISE)',
    DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE: 'Vydání zaknihovaných cenných papírů na účty nabyvatelů',
    DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_TEXT_NAVYSENI:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise, dodatkem k této Smlouvě, Provozním řádem centrálního depozitáře a Pravidly vypořádacího systému centrálního depozitáře podává emitent nebo určený zástupce příkaz centrálnímu depozitáři cenných papírů, aby provedl vydání výše specifikovaných zaknihovaných cenných papírů na účty nabyvatelů a dle zvolené formy vypořádání též případně i zabezpečení převodu peněžní částky za upsané zaknihované cenné papíry z účtů nabyvatelů na stanovený účet. Požadované datum vydání zaknihovaných cenných papírů na účty nabyvatelů (tj. datum vypořádání emise) musí následovat minimálně 5 pracovních dnů po doručení řádně podaného návrhu tohoto dodatku centrálnímu depozitáři.',
    DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_TEXT_DLT:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci, dodatkem k této Smlouvě a Pravidly DLT evidence centrálního depozitáře podává emitent nebo určený zástupce příkaz centrálnímu depozitáři cenných papírů, aby provedl vydání výše specifikovaných zaknihovaných cenných papírů na účty nabyvatelů a dle zvolené formy vypořádání též případně i zabezpečení převodu peněžní částky za upsané zaknihované cenné papíry z účtů nabyvatelů na stanovený účet. Požadované datum vydání zaknihovaných cenných papírů na účty nabyvatelů (tj. datum vypořádání primární emise) musí následovat minimálně dva 2 pracovní dny po datu registrace emise.',
    DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_TEXT:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise, dodatkem k této Smlouvě, Provozním řádem centrálního depozitáře a Pravidly vypořádacího systému centrálního depozitáře podává emitent nebo určený zástupce příkaz centrálnímu depozitáři cenných papírů, aby provedl vydání výše specifikovaných zaknihovaných cenných papírů na účty nabyvatelů a dle zvolené formy vypořádání též případně i zabezpečení převodu peněžní částky za upsané zaknihované cenné papíry z účtů nabyvatelů na stanovený účet. Požadované datum vydání zaknihovaných cenných papírů na účty nabyvatelů (tj. datum vypořádání primární emise) musí následovat minimálně dva 2 pracovní dny po datu registrace emise.',
    DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_DLT_TEXT:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci, dodatkem k této Smlouvě a Pravidly DLT evidence centrálního depozitáře podává emitent nebo určený zástupce příkaz centrálnímu depozitáři cenných papírů, aby provedl vydání výše specifikovaných zaknihovaných cenných papírů na účty nabyvatelů a dle zvolené formy vypořádání též případně i zabezpečení převodu peněžní částky za upsané zaknihované cenné papíry z účtů nabyvatelů na stanovený účet. Datum vydání zaknihovaných cenných papírů musí následovat minimálně 5 pracovní dnů po doručení řádně podaného návrhu tohoto dodatku centrálnímu depozitáři.',
    DOKUMENT_DODATEK_DETAIL_ZAKN_VYDANI:
        'Dochází k vydání zaknihovaných cenných papírů v návaznosti na přeměnu podoby listinných cenných papírů?',
    DOKUMENT_DODATEK_DETAIL_LHUTA: 'Den uplynutí lhůty pro odevzdání cenných papírů z důvodu přeměny (§ 529 NOZ)',
    DOKUMENT_DODATEK_DETAIL_LHUTA2:
        'Den uplynutí dodatečné lhůty pro odevzdání cenných papírů z důvodu přeměny (§ 531 NOZ)',
    DOKUMENT_DODATEK_DETAIL_LHUTA3:
        'Den uplynutí nejzazší lhůty pro sdělení čísla majetkového účtu akcionářem, který odevzdal cenný papír, ale číslo majetkového účtu nesdělil (§ 530 NOZ)',
    DOKUMENT_DODATEK_DETAIL_PRILOHY: 'Přílohy',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_TABLE: 'Typ přílohy',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_BTN: 'Vložit přílohu',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISOR: 'Výpis z obchodního rejstříku',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZMEN:
        'Výpis z obchodního rejstříku v případě změn které jsou zapisovány do OR',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPVYS: 'Výpis z obchodního rejstříku prokazující zápis výše ZK',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISOREMISAKC: 'Výpis z obchodního rejstříku v případě emise akcií',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORLIKVID:
        'Výpis z obchodního rejstříku prokazující vstup společnosti do likvidace',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORJMENLIKVID: 'Výpis z obchodního rejstříku prokazující jmenování likvidátora',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORNOVAFORMA:
        'Výpis z obchodního rejstříku prokazující zápis nové formy nebo druhu zaknihovaných akcií',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZRUS:
        'Zápis v obchodním rejstříku nebo jiný dokument prokazující oprávněnost ke zrušení',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPZMENVH:
        'Výpis z obchodního rejstříku prokazující zápis požadované změny (případně zápis z valné hromady)',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPZMEN: 'Výpis z obchodního rejstříku kde je zapsána požadovaná změna',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_ZAPISSCHUZVL: 'Zápis ze schůze vlastníků',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_PROSPEKT: 'Prospekt cenného papíru, je-li vydán, nebo emisní podmínky',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_DLUHPROG: 'Dluhopisový program, je-li vydáván',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_STATUTCNB: 'Statut podílového fondu schválený ČNB',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_ROZHODNUTICNB:
        'Rozhodnutí ČNB o povolení k vydávání podílových listů s doložkou právní moci',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_EMISNIPODMINKY: 'Emisní podmínky',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_EMISNIPODJINY:
        'Emisní podmínky nebo jiný dokument prokazující oprávněnost ke zrušení emise',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_JINY: 'Jiný typ přílohy',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_KUPONY: 'Specifikace kupónů (Seznam oddělených kupónů)',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_PROJEKTPREMENY: 'Projekt přeměny (např. fúze)',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_PROJEKTFUZE: 'Projekt fúze',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_OPRAVNENIPODANIPOZ: 'Dokument opravňující k podání požadavku',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_JINYOPRAVNENIZMENY: 'Jiný dokument opravňující k provedení změny',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_JINYJMENUJLIKVID: 'Jiný dokument o jmenování likvidátora',
    DOKUMENT_DODATEK_DETAIL_PRILOHY_STANOVY: 'Stanovy společnosti',
    NOVA_PRILOHA: 'Nová příloha',
    DOKUMENT_DODATEK_CP_TITLE: 'Forma vydání cenných papírů',
    DOKUMENT_DODATEK_CP_TEXT: 'v rámci které bude emitent poskytovat i příkaz k vydání se seznamem upisovatelů',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_DVP: 'Způsob předání příkazu DVP',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_DFP: 'Způsob předání příkazu DFP',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ: 'Způsob předání příkazu',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_BEZZAPLACENI: 'Formou vydání cenných papírů bez zaplacení (DFP)',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIZAPLACENI: 'Formou vydání cenných papírů proti zaplacení (DVP)',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_BEZZAPLACENI_SHORT: 'Vydání cenných papírů bez zaplacení (DFP)',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIZAPLACENI_SHORT: 'Vydání cenných papírů proti zaplacení (DVP)',
    DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIABEZZAPL:
        'Kombinovanou formou vydání cenných papírů proti zaplacení  (DVP) a bez zaplacení (DFP)',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_CDCP:
        'Příkaz emitenta k vydání zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MDADMIN:
        'Příkaz podaný administrátorem emise prostřednictvím webového portálu Můj depozitář',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA: 'Příkaz podaný prostřednictvím PX Veřejná nabídka',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA_OBJEM: 'Maximální objem emise pro veřejnou nabídku',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA_OBJEM_TOOLTIP: 'Uvedete v případě, že je uvedeno v prospektu.',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MD:
        'Příkaz podaný emitentem prostřednictvím webového portálu Můj depozitář',
    DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_PARSYST:
        'Příkaz účastníka vypořádacího systému vložením příkazu do párovacího systému',
    DOKUMENT_PODPIS_ERR_ERR001: 'Osoba neexistuje',
    DOKUMENT_PODPIS_ERR_ERR002: 'Osoba nemá oprávnění dokuement podepsat',
    DOKUMENT_PODPIS_ERR_ERR003: 'Předchozí osoba ještě dokument nepodepsala',
    DOKUMENT_PODPIS_ERR_ERR004: 'Dokument předchozí osoby ještě není ve stav hotovo',
    DOKUMENT_PODPIS_ERR_ERR005: 'Nepodařilo se vygenerovat soubor dokumentu',
    DOKUMENT_NOVY_ERR_ERR001: 'Smlouva o vedení evidence emise je již zaevidována. Další smlouvu nelze zaevidovat.',
    DOKUMENT_NOVY_ERR_ERR002:
        'Smlouva o vedení evidence emise v DLT evidenci je již zaevidována. Další smlouvu nelze zaevidovat.',
    DOKUMENT_NOVY_ERR_ERR003: 'Dokument lze zaevidovat pouze pokud je pro emitenta zaevidována smlouva.',
    DOKUMENT_NOVY_ERR_ERR004: 'Nepodařilo se dohledat údaje CDCP.',
    CISLO_MAJETKOVEHO_UCTU: 'Číslo majetkového účtu',
    POCET_ZRUSENICH_CP: 'Počet zrušených CP',
    PPN: 'PPN',
    PRIJMENI_OBCHODNI_FIRMA: 'Příjmení / Obchodní firma',
    DOKUMENT_DODATEK_DFP_TITLE: 'Vypořádání bez zaplacení (DFP)',
    DOKUMENT_DODATEK_DFP_TEXT:
        'Příkaz emitenta k vydání počtu zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_MUCET1:
        'Pro účet vedený v centrální evidenci (typ účtu 21, 11, 25) vyplňte číslo majetkového účtu vlastníka (dvanáctimístné číslo začíná trojčíslím 808, 100 nebo 909). Pro účet vedený v navazující evidenci (typ účtu 31) vyplňte číslo účtu navazující evidence.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_NABYVATEL:
        'Vyplňte RČ/IČ/NID majitele účtu. Pro účet vedený v navazující evidenci vyplňte identifikaci navazující evidence (IČ).',
    DOKUMENT_DODATEK_DFP_TOOLTIP_CP_ZRUSENI: 'Počet cenných papírů, které by měly být zrušeny.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_CP: 'Počet zaknihovaných cenných papírů, které mají být připsány.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_ZAST_SMLOUVA:
        'Číslo zástavní smlouvy obdrží zástavní věřitel nebo majitel účtu u účastníka centrálního depozitáře, u kterého má otevřen majetkový účet, resp., kde byl založen jako zástavní věřitel k zástavní Smlouvě.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_MAJITEL_ZRUSENI: 'Vyplňte RČ/IČ/NID osoby, které budou cenné papíry zrušeny.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_MAJITEL:
        'Vyplňte RČ/IČ/NID majitele účtu na/z jehož majetkový účet budou cenné papíry připsány/odepsány. Pole se vyplňuje pouze v případě, že se jedná o navazující evidenci.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_JMENO: 'Pole se vyplňuje pouze v případě, že se jedná o navazující evidenci.',
    DOKUMENT_DODATEK_DFP_TOOLTIP_PRIJMENI: 'Pole se vyplňuje pouze v případě, že se jedná o navazující evidenci.',
    DOKUMENT_DODATEK_DFP_POCETCP: 'Celkový počet zaknihovaných cenných papírů, které mají být připsány',
    DOKUMENT_DODATEK_POCETCP: 'Celkový počet zaknihovaných cenných papírů',
    DOKUMENT_DODATEK_DFP_DEL_CONFIRM: 'Opravdu si přejete smazat účet?',
    DOKUMENT_DODATEK_DFP_DEL_CONFIRM_ALL: 'Opravdu si přejete smazat všechny majetkové účty?',
    DOKUMENT_DODATEK_DVP_TITLE: 'Vypořádání proti zaplacení (DVP)',
    DOKUMENT_DODATEK_DVP_TEXT_DLT: 'Příkaz podaný emitentem prostřednictvím  webového portálu Můj depozitář',
    DOKUMENT_DODATEK_DVP_TEXT:
        'Příkaz emitenta k vydání zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři',
    DOKUMENT_DODATEK_DVP_SEZNAM: 'Seznam upisovatelů předá centrálnímu depozitáři',
    DOKUMENT_DODATEK_DVP_SEZNAM_ZASTUPCE: 'Zástupce emitenta (účastník CDCP administrátor emise atp.)',
    DOKUMENT_DODATEK_DVP_CASTKA_CP: 'Celková částka za vydané zaknihované cenné papíry',
    DOKUMENT_DODATEK_DVP_CASTKA_TITLE: 'Bankovní účet',
    DOKUMENT_DODATEK_DVP_ADRESA_BIC_ERR:
        'Zadejte buď Konečný příjemce BIC, nebo vyplňte jak Název příjemce, tak i Adresu příjemce.',
    TYP_PLATBY: 'Typ platby',
    CASTKA: 'Částka',
    CASTKA_MENA: 'Částka v měně',
    NAZEV_PRIJEMCE: 'Název příjemce',
    ADRESA_PRIJEMCE: 'Adresa příjemce',
    PRIJEMCE_BIC: 'Konečný příjemce BIC (pouze pokud je konečným příjemcem banka)',
    IBAN_PRIJEMCE: 'Účet příjemce / IBAN ',
    BIC_BANKY: 'BIC banky příjemce',
    BIC_BANKY_INVALID: 'Nevalidní BIC banky',

    DOKUMENT_DODATEK_DVP_BANKUCET_NYNI: 'Vyplním nyní',
    DOKUMENT_DODATEK_DVP_BANKUCET_PRIKAZ: 'Vyplním později samostatným příkazem',
    DOKUMENT_DODATEK_DVP_BANKUCET: 'Vyplňte údaje o bankovním účtu a částce za zaknihované cenné papíry',
    DOKUMENT_DODATEK_DVP_POCET_UPISOVATELU: 'Celkový počet upisovatelů',
    DOKUMENT_DODATEK_DVP_POCET_UPISOVATELU_DOWNLOAD: 'Stáhnout seznam upisovatelů',
    DOKUMENT_DODATEK_DVP_POCET_UPISOVATELU_TEXT:
        'Seznam upisovatelů je nutné předat nejpozději tři pracovní dny před datem vypořádání nejpozději do 10 hod.',
    VYBERTE_SPUSOB_PODEPISOVANI: 'Vyberte prosím způsob podepisování',
    DOKUMENTY_NOVY_ODESLAT_KPODPISU_CONFIRM: 'Opravdu si přejete odeslat dokument k podpisu?',
    PLATBA_TUP: 'Tuzemská platba',
    PLATBA_ZAP: 'Zahraniční platba',
    PPN_SELECT: 'Zápis PPN?',
    DODATEK_OSOBY_TEXT:
        'Administrátorem emise je právnická osoba, kterou emitent pověřil administrací emise ( např. výplaty dividend, zajištění výpisů, aj.) a je oprávněná zastupovat emitenta ve vztahu k centrálnímu depozitáři v rozsahu oprávnění stanovené emitentem. Emitent je povinen zajistit, aby osoby zmocněné k jednání s centrálním depozitářem postupovaly v souladu se Smlouvou o vedení evidence emise, tímto dodatkem ke Smlouvě, příkazy emitenta, Provozním řádem a dalšími relevantními pravidly CDCP.',
    DODATEK_OSOBY_SUBTITLE: 'Administrátora zastupuje tato pověřená osoba',
    DODATEK_OSOBY_SUBTITLE_IDENTIFIKACE: 'Identifikace administrátora emise',
    ICO_NID_ZASTUPCE: 'IČO/NID zástupce',
    NAZEV_ZASTUPCE: 'Obchodní firma nebo jiný název zástupce',
    ADRESA_ZASTUPCE: 'Adresa sídla zástupce',
    IDENTIFIKACE_ZASTUPCE: 'Identifikace zástupce administrátora emise',
    IDENTIFIKACE_ZASTUPCE_CERT: 'Sériové číslo certifikátu',
    IDENTIFIKACE_ZASTUPCE_CERTISS: 'Vydavatel certifikátu',
    AUTENTIZACE_ZASTUPCE: 'Způsob autentizace (zvolte jednu z možností)',
    AUTENTIZACE_ZASTUPCE_TEXT:
        'Vyplňte v souladu se zápisem způsobu zastupování v obchodním rejstříku nebo s přiloženou plnou mocí.',
    AUTENTIZACE_ZASTUPCE_TEXT1:
        '1) Aplikaci PX Klíč si uživatel nainstaluje na své mobilní zařízení s operačním systémem iOS nebo Android. Na mobilní telefon uživatele bude doručen autorizační kód pro spárování aplikace PX klíč s uživatelským účtem v portálu Můj depozitář.',
    AUTENTIZACE_ZASTUPCE_TEXT2:
        '2) Pro přístup lze užít pouze komerční certifikát (veřejná část klíče musí být dostupná ke stažení na stránce certifikační autority) vystavený na osobu uživatele jednou z následujících certifikačních autorit: I.CA, Česká pošta, Národní certifikační autorita nebo e-Identity.',
    ADMIN_ZMENA_DLT_TEXT1:
        'V souladu se Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k zápisu výše uvedených změn v DLT evidenci. Pokud dává emitent příkaz ke změně administrátora emise, tak potvrzuje, že administrátorem emise je právnická osoba, kterou emitent pověřil administrací emise (např. výplaty dividend, zajištění výpisů, aj.) a je oprávněná zastupovat emitenta ve vztahu k centrálnímu depozitáři v rozsahu oprávnění stanoveným emitentem. Emitent je povinen zajistit, aby osoby zmocněné k jednání s centrálním depozitářem postupovaly v souladu se Smlouvou o vedení evidence emise v DLT evidenci, Pravidly DLT evidence a dalšími relevantními pravidly CDCP.',
    ADMIN_ZMENA_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    ADMIN_ZMENA_TEXT1:
        'V souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k zápisu výše uvedených změn v evidenci. Pokud dává emitent příkaz ke změně administrátora emise, tak potvrzuje, že administrátorem emise je právnická osoba, kterou emitent pověřil administrací emise (např. výplaty dividend, zajištění výpisů, aj.) a je oprávněná zastupovat emitenta ve vztahu k centrálnímu depozitáři v rozsahu oprávnění stanoveným emitentem. Emitent je povinen zajistit, aby osoby zmocněné k jednání s centrálním depozitářem postupovaly v souladu se Smlouvou o vedení evidence emise, Provozním řádem a dalšími relevantními pravidly CDCP.',
    ADMIN_ZMENA_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    DOKUMENT_DODATEK_SHRNUTI_TITLE: 'Shrnutí podmínek',
    DOKUMENT_DODATEK_SHRNUTI_DLT_1_UPIS: '1.1 Rekapitulace podmínek vydání zaknihovaných cenných papírů',
    DOKUMENT_DODATEK_SHRNUTI_DLT_1: '1.1 Shrnutí podmínek vydání zaknihovaných cenných papírů',
    DOKUMENT_DODATEK_SHRNUTI_DLT_11:
        '1.1.1 V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci, dodatkem k této Smlouvě a Pravidly DLT evidence centrálního depozitáře podává emitent nebo určený zástupce příkaz centrálnímu depozitáři cenných papírů, aby provedl vydání výše specifikovaných zaknihovaných cenných papírů na účty nabyvatelů a dle zvolené formy vypořádání též případně i zabezpečení převodu peněžní částky za upsané zaknihované cenné papíry z účtů nabyvatelů na stanovený účet. Zápis na účty nabyvatelů provede centrální depozitář na základě seznamu upisovatelů předaného prostřednictvím webové aplikace Můj depozitář.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_12:
        '1.1.2	Emitent a centrální depozitář se tímto dodatkem dohodli, že centrální depozitář pro emitenta založí evidenci nové emise zaknihovaných investičních nástrojů specifikovaných níže („zaknihované cenné papíry“), provede vypořádání primární emise zaknihovaných cenných papírů a povede jejich evidenci v rámci DLT evidence. Podmínky vydání zaknihovaných cenných papírů, vedení evidence emise a práva a povinnosti smluvních stran jsou uvedeny ve Smlouvě o vedení evidence emise v DLT evidenci uzavřené mezi emitentem a centrálním depozitářem a v Pravidlech DLT evidence.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_13:
        '1.1.3 Emitent bere na vědomí, že centrální depozitář zajistí vydání zaknihovaných cenných papírů na účty nabyvatelů a, bylo-li to dohodnuto, též převod peněžní částky za upsané cenné papíry na stanovený účet, pouze pokud tento dodatek bude uzavřen nejpozději 7, pracovních dní před požadovaným datem vydání zaknihovaných cenných papírů, není-li dohodnuto s centrálním depozitářem jinak, a pokud budou emitentem (účastníkem centrálního depozitáře) splněny dále uvedené podmínky.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_13_NAVYSENI:
        '1.1.3 Emitent bere na vědomí, že centrální depozitář zajistí vydání zaknihovaných cenných papírů na účty nabyvatelů a, bylo-li to dohodnuto, též převod peněžní částky za upsané cenné papíry na stanovený účet, pouze pokud tento dodatek bude uzavřen nejpozději 5, pracovních dní před požadovaným datem vydání zaknihovaných cenných papírů, není-li dohodnuto s centrálním depozitářem jinak, a pokud budou emitentem (účastníkem centrálního depozitáře) splněny dále uvedené podmínky.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_14:
        '1.1.4	Emitent se zavazuje sám nebo prostřednictvím zástupce emitenta zajistit  splnění podmínek pro včasný zápis zaknihovaných cenných papírů na majetkové účty nabyvatelů,',
    DOKUMENT_DODATEK_SHRNUTI_DLT_142:
        '1.1.5. Emitent se dále zavazuje sám nebo prostřednictvím zástupce emitenta zajistit v případě DVP: řádně vyplnit seznamu upisovatelů v aplikaci Můj depozitář nejpozději do 11:00 hod. pracovního dne předcházejícího požadovanému datu vydání zaknihovaných cenných papírů, půjde-li o vydání zaknihovaných cenných papírů na majetkové účty nabyvatelů proti zaplacení.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_115:
        '1.1.6. Emitent v případě vydání zaměstnaneckých akcií prohlašuje, že v případě požadavku na zápis PPN (pozastavení práva vlastníka nakládat) těchto cenných papírů odpovídá tento požadavek smluvnímu ujednání se zaměstnance a je připraven souhlas doložit.',
    DOKUMENT_DODATEK_SHRNUTI_DLT_2_TITLE: '2. RUŠENÍ EMISE',
    DOKUMENT_DODATEK_SHRNUTI_DLT_2:
        'Emitent zaknihovaných cenných papírů se stanovenou dobou splatnosti současně tímto podává příkaz ke zrušení emise zaknihovaných cenných papírů v den následující po dni splatnosti emise stanoveném emisními podmínkami.',
    DOKUMENT_DODATEK_SHRNUTI_11:
        '1.1.1 Emitent bere na vědomí, že centrální depozitář zajistí vydání zaknihovaných cenných papírů na účty nabyvatelů a, bylo-li to dohodnuto, též převod peněžní částky za upsané cenné papíry na stanovený účet, pouze pokud tento dodatek bude uzavřen nejpozději 7 pracovních dní před požadovaným datem vydání zaknihovaných cenných papírů, není-li dohodnuto s centrálním depozitářem jinak, a pokud budou emitentem (účastníkem centrálního depozitáře) splněny dále uvedené podmínky.',
    DOKUMENT_DODATEK_SHRNUTI_11_NAVYSENI:
        '1.1.1 Emitent bere na vědomí, že centrální depozitář zajistí vydání zaknihovaných cenných papírů na účty nabyvatelů a, bylo-li to dohodnuto, též převod peněžní částky za upsané cenné papíry na stanovený účet, pouze pokud tento dodatek bude uzavřen nejpozději 5 pracovních dní před požadovaným datem vydání zaknihovaných cenných papírů, není-li dohodnuto s centrálním depozitářem jinak, a pokud budou emitentem (účastníkem centrálního depozitáře) splněny dále uvedené podmínky.',
    DOKUMENT_DODATEK_SHRNUTI_12: '1.1.2	Emitent se zavazuje sám nebo prostřednictvím účastníka zajistit:',
    DOKUMENT_DODATEK_SHRNUTI_12A:
        'a) splnění podmínek pro včasný zápis zaknihovaných cenných papírů na majetkové účty nabyvatelů,',
    DOKUMENT_DODATEK_SHRNUTI_12B:
        'b)	zajistit předávání informací souvisejících s vydáním zaknihovaných cenných papírů na účty nabyvatelů všem účastníkům, kterých se tyto informace týkají.',
    DOKUMENT_DODATEK_SHRNUTI_13: '1.1.3	Emitent se dále zavazuje sám nebo prostřednictvím účastníka zajistit: ',
    DOKUMENT_DODATEK_SHRNUTI_13A:
        'a)	v případě DVP: dodání řádně vyplněného Seznamu upisovatelů (dále jen „seznam“) CDCP nejpozději do 11:00 hod. pracovního dne předcházejícího požadovanému datu vydání zaknihovaných cenných papírů, půjde-li o vydání zaknihovaných cenných papírů na majetkové účty nabyvatelů proti zaplacení.  Půjde-li o vydání zaknihovaných cenných papírů na majetkové účty nabyvatelů proti zaplacení, použije emitent (účastník)  Seznam upisovatelů - Vypořádání proti zaplacení. Při vydání zaknihovaných cenných papírů proti zaplacení je emitent (účastník) povinen obstarat podpis seznamu všemi účastníky vypořádacího systému CDCP, kteří jsou upisovateli emise nebo upisovatele zastupují ; 	vložení příslušných příkazů k vypořádání účastníkem zastupujícím emitenta a účastníky zastupující nabyvatele nejpozději do 11:00 hod dne vypořádání. Vložení a spárování příkazů k vypořádání plně nahrazuje seznam ',
    DOKUMENT_DODATEK_SHRNUTI_13B:
        'b)	v případě vypořádání primární emise v cizí měně převod peněžních prostředků na stanovený účet centrálního depozitáře u vybrané banky prostřednictvím účastníků zastupujících nabyvatele.',
    DOKUMENT_DODATEK_SHRNUTI_14:
        '1.1.4. Emitent v případě vydání zaměstnaneckých akcií prohlašuje, že v případě požadavku na zápis PPN (pozastavení práva vlastníka nakládat) těchto cenných papírů odpovídá tento požadavek smluvnímu ujednání se zaměstnancem a je připraven souhlas doložit.',
    DOKUMENT_DODATEK_PREDBEZNE_ODESLAT: 'Odeslat do CDCP k předběžné kontrole',
    DOKUMENT_DODATEK_ZMENREGI: 'Nová osoba vedoucí evidenci zaknihovaného CP',
    DATUM_SPALTNOSTI_DLOUHOPISU: 'Datum splatnosti dluhopisu',
    DATUM_EMISE: 'Datum emise v emisních podmínkách',
    DATUM_VYPLATA_KOUPONU: 'Rozhodné datum pro výplatu kupónu předchází datu výplaty o počet dní',
    POCET_DNI: 'Počet dní',
    ROZHODNE_DATUM_VYPLATY: 'Datum výplaty kupónu',
    ROZHODNE_DATUM_VYPLATY_PREDCHAZI: 'Rozhodné datum pro výplatu jistiny předchází o počet dní',
    DATUM_EX_KUPONU: 'Datum ex-kupónu',
    ROZHODNE_DATUM_JISTANA: 'Datum výplaty jistiny',
    ISIN_ODDELENE_JISTINY: 'ISIN oddělené jistiny',
    DATUM_EX_JISTANA: 'Datum ex-jistina',
    DODATEK_DLUHOPIS_DATUM_ERR: 'Rozhodné datum nespadá do intervalu',
    DODATEK_DLUHOPIS_DATUM_ERR2: 'Všechny datumy v tabulce musí být vyplněny',
    ROZHODNE_DATUM_VYPLATA_PREDCHAZIO: 'Rozhodné datum pro výplatu jistiny předchází o počet dní',
    DODATEK_DLUH_VYPLATA_TYP_KUPON: 'Stejně jako pro kupón',
    DODATEK_DLUH_VYPLATA_TYP_JINE: 'Jiné',
    DODATEK_DLUH_CP_ERR:
        'Počet zaknihovaných cenných papírů pro primární úpis musí být menší nebo roven počtu CP v emisi',
    DODATEK_INVCERT_POCET_EMISI: 'Počet zaknihovaných cenných papírů v emisi',
    DODATEK_PODILLIST_NAV: 'NAV na 1 podílový list',
    DODATEK_INVCERT_NAV: 'NAV na 1 akcii',
    DODATEK_INVCERT_NAV_MENA: 'Měna NAV',
    DODATEK_INVCERT_NAV_DATUM: 'Datum kurzu NAV pro přepočet',
    DODATEK_INVCERT_POCET_ZAKN: 'Počet zaknihovaných cenných papírů pro primární úpis',
    DODATEK_INVCERT_MAX_EMISE: 'Maximální objem emise',
    DODATEK_INVCERT_DRUH_AKCII: 'Vyplňte druh investičních akcií dle statutu fondu',
    DODATEK_INVCERT_DRUH_AKCII_TOOLTIP: 'Např: Prioritní, výkonnostní, prémiové, manažerské apod.',
    PRIKAZ_DRUH_ZMENY: 'Druh změny o kterou emitent žádá',
    PRIKAZ_DRUH_ZMENY_ZNAZEV: 'Změna obchodní firmy, názvu emitenta',
    PRIKAZ_DRUH_ZMENY_ZADRESA: 'Změna adresy sídla emitenta',
    PRIKAZ_DRUH_ZMENY_ZEMAILFAKT: 'Změna kontaktní e-mailové adresy',
    PRIKAZ_DRUH_ZMENY_ZEMAILPOPL: 'Změna e-mailové adresy pro fakturaci poplatků',
    PRIKAZ_DRUH_ZMENY_ZADMIN: 'Změna administrátora emise',
    PRIKAZ_DRUH_ZMENY_ZJINA: 'Jiná změna',
    PUVODNI_UDAJ: 'Původní údaj',
    NOVY_UDAJ: 'Nový údaj',
    PUVODNI_UDAJE: 'Původní údaje',
    NOVY_UDAJE: 'Nové údaje',
    ZMENA_JINA_POPIS: 'Popište druh změny',
    PRIKAZ_ZMENA_DLT_TEXT1:
        'V souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře (případně evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře) podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k zápisu výše uvedených změn v evidenci.',
    PRIKAZ_ZMENA_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    NOVY_ADMIN: 'Nový administrátor emise',
    NEVALIDNI_POCET_HLASU: 'Překročen maximální počet hlasu',
    PRIKAZ_PODAL: 'Příkaz podal',
    PRIKAZ_SPLYNUTI_HODNOTA: 'Jmenovitá hodnota 1 akcie nástupnické emise',
    PRIKAZ_SPLYNUTI_POCET: 'Stávající počet akcií nástupnické emise',
    PRIKAZ_SPLYNUTI_POCET_PO: 'Nový počet akcií nástupnické emise po splynutí',
    PRIKAZ_SPLYNUTI_HODNOTA_PO: 'Celková jmenovitá hodnota emise po splynutí',
    PRIKAZ_SPLYNUTI_AKCIONAR_SEZNAM: 'Seznam akcionářů je nahrazen evidencí zaknihovaných cenných papírů (§ 264 ZOK)',
    PRIKAZ_SPLYNUTI_PODMINKY_TITLE: 'Podmínky podání Příkazu',
    PRIKAZ_SPLYNUTI_PODMINKY_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta a v souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz:',
    PRIKAZ_SPLYNUTI_PODMINKY_TEXT1_1: '- ke splynutí výše specifikovaných emisí zaknihovaných akcií,',
    PRIKAZ_SPLYNUTI_PODMINKY_TEXT1_2:
        '- nahrazení zanikající emise nástupnickou emisí na účtech majitelů zanikající emise a',
    PRIKAZ_SPLYNUTI_PODMINKY_TEXT1_3: '- ke zrušení vedení evidence zanikající emise.',
    PRIKAZ_SPLYNUTI_PODMINKY_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_SPLYNUTI_PODMINKY_DLT_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta a v souladu se Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz:',
    PRIKAZ_SPLYNUTI_PODMINKY_DLT_TEXT1_1: '- ke splynutí výše specifikovaných emisí zaknihovaných akcií,',
    PRIKAZ_SPLYNUTI_PODMINKY_DLT_TEXT1_2:
        '- nahrazení zanikající emise nástupnickou emisí na účtech majitelů zanikající emise a',
    PRIKAZ_SPLYNUTI_PODMINKY_DLT_TEXT1_3: '- ke zrušení vedení evidence zanikající emise.',
    PRIKAZ_SPLYNUTI_PODMINKY_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_SPLYNUTI_ZANIKAJICI_ISIN: 'ISIN zanikající emise zaknihovaných akcií',
    PRIKAZ_SPLYNUTI_NOVY_ISIN: 'ISIN nástupnické emise zaknihovaných akcií',
    PRIKAZ_ZNIZENI_ISIN: 'Zvolte ISIN pro danou operaci',
    PRIKAZ_ZNIZENI_UDAJECP: 'Vyplňte údaje o cenném papíru před změnou',
    PRIKAZ_ZNIZENI_DUVOD: 'Důvod snížení počtu zaknihovaných cenných papírů',
    PRIKAZ_ZNIZENI_ZRUSAKCZK: 'Zrušení akcií v důsledku snížení základního kapitálu',
    PRIKAZ_ZNIZENI_ZRUSAKINV: 'Zrušení akcií investičních fondů',
    PRIKAZ_ZNIZENI_SNIZDLUH: 'Snížení počtu zaknihovaných dluhopisů zrušením',
    PRIKAZ_ZNIZENI_SNIZINV: 'Snížení počtu zaknihovaných investičních certifikátů',
    PRIKAZ_ZNIZENI_SNIZWAR: 'Snížení počtu zaknihovaných warrantů',
    PRIKAZ_ZNIZENI_SNIZJINY: 'Snížení počtu jiných zaknihovaných cenných papírů',
    PRIKAZ_ZNIZENI_NAV: 'Měna jmenovité hodnoty',
    PRIKAZ_ZNIZENI_1CP_HODNOTA: 'Jmenovitá hodnota 1 ks cenného papíru',
    PRIKAZ_ZNIZENI_POCET_PRED: 'Počet kusů zaknihovaných cenných papírů před snížením',
    PRIKAZ_ZNIZENI_ZMENA_TITLE: 'Vyplňte údaje o požadovaných změnách',
    PRIKAZ_ZNIZENI_NOVY_POCET: 'Nový počet kusů zaknihovaných cenných papírů po snížení',
    PRIKAZ_ZNIZENI_NOVY_SNIZENI: 'Emise bude snížena o počet kusů',
    PRIKAZ_ZNIZENI_NOVY_HODNOTA: 'Nová celková jmenovitá hodnota emise',
    PRIKAZ_ZNIZENI_DFP_POCETCP: 'Celkový počet zaknihovaných cenných papírů, které mají být zrušeny',
    PRIKAZ_ZNIZENI_SPUSOB_PREDANI:
        'Způsob předání Seznamu majitelů účtů na kterých dojde ke zrušení zaknihovaných cenných papírů',
    PRIKAZ_ZNIZENI_SPUSOB_PREDANI_CDCP:
        'Seznam ke snížení zaknihovaných cenných papírů doručený ke zpracování centrálnímu depozitáři',
    PRIKAZ_ZNIZENI_SPUSOB_PREDANI_MD: 'Seznam podaný emitentem prostřednictvím  webového portálu Můj depozitář',
    PRIKAZ_ZNIZENI_SPUSOB_PREDANI_MDADMIN:
        'Seznam předaný administrátorem emise prostřednictvím webového portálu Můj depozitář',
    PRIKAZ_ZNIZENI_PODMINKY_TITLE: 'Podmínky podání Příkazu',
    PRIKAZ_ZNIZENI_DFP_TEXT: 'Specifikace majitelů účtů, na kterých má dojít ke zrušení cenných papírů',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke snížení výše specifikovaných zaknihovaných cenných papírů v evidenci emise a na majetkových účtech vlastníků.',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT1: 'Emitent v případě emise akcií prohlašuje, že:',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT11:
        '- splnil veškeré požadavky kladené zákonem č. 90/2012 Sb., o obchodních korporacích, pro snižování základního kapitálu a přikládá originály nebo pravé kopie písemností dokládající tuto skutečnost;',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT12:
        '- doklad(y) o přijetí veřejného návrhu koupě akcií společností ve smyslu § 534 ZOK jsou originály nebo pravé kopie;',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT13:
        '- zrušení akcií je provedeno po projednání a odsouhlasení s majiteli účtů uvedených v příloze tohoto příkazu, jsou-li ke snížení základního kapitálu použity akcie, které nejsou v majetku emitenta.',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT2: 'Emitent prohlašuje, že:',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT21:
        '- zajistí vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv);',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT22:
        '- seznámil účastníky centrálního depozitáře vedoucí majetkové účty, na kterých má dojít ke zrušení akcií, s touto skutečností.',
    PRIKAZ_ZNIZENI_PODMINKY_TEXT3:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke snížení výše specifikovaných zaknihovaných cenných papírů v evidenci emise a na majetkových účtech vlastníků.',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT1: 'Emitent v případě emise akcií prohlašuje, že:',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT11:
        '- splnil veškeré požadavky kladené zákonem č. 90/2012 Sb., o obchodních korporacích, pro snižování základního kapitálu a přikládá originály nebo pravé kopie písemností dokládající tuto skutečnost;',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT12:
        '- doklad(y) o přijetí veřejného návrhu koupě akcií společností ve smyslu § 534 ZOK jsou originály nebo pravé kopie;',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT13:
        '- zrušení akcií je provedeno po projednání a odsouhlasení s majiteli účtů uvedených v příloze tohoto příkazu, jsou-li ke snížení základního kapitálu použity akcie, které nejsou v majetku emitenta.',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT2: 'Emitent prohlašuje, že:',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT21:
        '- zajistí vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv);',
    PRIKAZ_ZNIZENI_PODMINKY_DLT_TEXT3:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_ZRUSENI_DATE_TOOLTIP:
        'V případě, že zvolíte jiný než pracovní den, bude operace provedena následující pracovní den.',
    PRIKAZ_ZRUSENI_DUVOD: 'Důvod zrušení evidence emise',
    PRIKAZ_ZRUSENI_DUVOD_SPLATNOST: 'splatnost dluhopisu',
    PRIKAZ_ZRUSENI_DUVOD_PREDSPL: 'předčasná splatnost dluhopisu',
    PRIKAZ_ZRUSENI_DUVOD_LIKVIDACE: 'likvidace akciové společnosti',
    PRIKAZ_ZRUSENI_DUVOD_PREMENACP: 'přeměna na cenný papír (listinný)',
    PRIKAZ_ZRUSENI_DUVOD_PREMENASP: 'přeměna společnosti na s.r.o.',
    PRIKAZ_ZRUSENI_DUVOD_FUZE: 'fúze společnosti',
    PRIKAZ_ZRUSENI_DUVOD_ZMENOSOBA: 'změna osoby vedoucí evidenci',
    PRIKAZ_ZRUSENI_DUVOD_JINY: 'jiný důvod',
    PRIKAZ_ZPUSOB_PODANI: 'Způsob podání žádosti emitenta o výpis z emise',
    PRIKAZ_ZPUSOB_PODANI_CDCP: 'Prostřednictvím žádosti doručené centrálnímu depozitáři',
    PRIKAZ_ZPUSOB_PODANI_MD: 'Prostřednictvím aplikace Můj depozitář',
    PRIKAZ_ZPUSOB_PODANI_NEPOZADUJE: 'Emitent nepožaduje výpis z emise',
    PRIKAZ_ZRUSENI_CHECKBOX: 'Emitent podá žádost o výpis z emise prostřednictvím samostatného formuláře',
    PRIKAZ_ZRUSENI_POTVRZENI: 'Likvidátor požaduje potvrzení o zrušení emise',
    PRIKAZ_ZRUSENI_CLANEKDOK:
        'Uveďte článek emisních podmínek nebo jiný dokument, na základě kterého emitent rozhodl o předčasné splatnosti',
    PRIKAZ_ZRUSENI_OSOBA_STARA: 'Původní osoba vedoucí evidenci',
    PRIKAZ_ZRUSENI_OSOBA_NOVA: 'Nová osoba vedoucí evidenci',
    PRIKAZ_ZRUSENI_DUVOD_INPUT: 'Důvod zrušení evidence emise',
    PRIKAZ_ZRUSENI_VYPIS_DATUM: 'Emitent požádá o výpis z evidence emise ke dni',
    PRIKAZ_ZRUSENI_VYPIS_DATUM_PRED: 'ke dni předcházejícímu datu zrušení emise',
    PRIKAZ_ZRUSENI_VYPIS_DATUM_JINY: 'k jinému datu',
    PRIKAZ_ZRUSENI_ZADA_O_VYPIS:
        'Emitent požaduje blokaci emise, která bude provedena následující den po datu, ke kterému žádá o výpis',
    PRIKAZ_ZRUSENI_INFO_TITLE: 'Podmínky podání Příkazu',
    PRIKAZ_ZRUSENI_INFO_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke zrušení výše specifikovaných zaknihovaných cenných papírů v evidenci emise a na majetkových účtech vlastníků.',
    PRIKAZ_ZRUSENI_INFO_TEXT3:
        'Emitent se zavazuje zajistit vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv).',
    PRIKAZ_ZRUSENI_INFO_TEXT4:
        'Emitent bere na vědomí, že žádost o výpis emise doručená centrálnímu depozitáři musí být podána prostřednictvím samostatného formuláře.',
    PRIKAZ_ZRUSENI_INFO_TEXT5:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_ZRUSENI_INFO_DLT_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke zrušení výše specifikovaných zaknihovaných cenných papírů v evidenci emise a na majetkových účtech vlastníků.',
    PRIKAZ_ZRUSENI_INFO_DLT_TEXT3:
        'Emitent se zavazuje zajistit vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv).',
    PRIKAZ_ZRUSENI_INFO_DLT_TEXT4:
        'Emitent bere na vědomí, že žádost o výpis emise doručená centrálnímu depozitáři musí být podána prostřednictvím samostatného formuláře.',
    PRIKAZ_ZRUSENI_INFO_DLT_TEXT5:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_FORMA_TITLE_CHECKBOX: 'Změna formy akcií',
    PRIKAZ_FORMA_TITLE: 'Forma akcií',
    PRIKAZ_FORMA_DRUH_AKCII_CHECKBOX: 'Změna druhu akcií',
    PRIKAZ_FORMA_DRUH_AKCII: 'Druh akcií',
    PRIKAZ_FORMA_CHCKBX_ERR: 'Vyberte alespoň jednu změnu',
    PRIKAZ_FORMA_FORMA_AKCII_NADORUCITELE: 'na doručitele',
    PRIKAZ_FORMA_FORMA_AKCII_NARAD: 'na řad',
    PRIKAZ_FORMA_DRUH_AKCII_KMENOVE: 'kmenové',
    PRIKAZ_FORMA_DRUH_AKCII_KMENOVEKS: 'kmenové kusové',
    PRIKAZ_FORMA_DRUH_AKCII_PRIORIT: 'prioritní',
    PRIKAZ_FORMA_DRUH_AKCII_PRIORITKS: 'prioritní kusové',
    PRIKAZ_FORMA_DRUH_AKCII_ZVLPRAVO: 'se zvláštními právy',
    PRIKAZ_FORMA_DRUH_AKCII_ZVLPRAVO_POPIS: 'Zde popište o jaké zvláštní právo se jedná',
    PRIKAZ_FORMA_PODMINKY_TITLE: 'Podmínky podání Příkazu',
    PRIKAZ_FORMA_PODMINKY_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta o změně formy nebo druhu akcií, platnými právními předpisy, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke změně zápisu formy nebo druhu výše uvedených zaknihovaných akcií vedených v evidenci centrálního depozitáře, a to z původní formy a druhu na novou formu a druh dle výše uvedených parametrů.',
    PRIKAZ_FORMA_PODMINKY_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_FORMA_PODMINKY_DLT_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta o změně formy nebo druhu akcií, platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke změně zápisu formy nebo druhu výše uvedených zaknihovaných akcií vedených v DLT evidenci, a to z původní formy a druhu na novou formu a druh dle výše uvedených parametrů.',
    PRIKAZ_FORMA_PODMINKY_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_VYTESNENI_ISIN: 'Vyberte ISIN',
    PRIKAZ_VYTESNENI_TABLE_TITLE: 'Identifikace hlavního akcionáře',
    PRIKAZ_VYTESNENI_ZPUSOB: 'Způsob podání žádosti emitenta o výpis z emise',
    PRIKAZ_VYTESNENI_ZPUSOB_CDCP: 'Prostřednictvím žádosti doručené centrálnímu depozitáři',
    PRIKAZ_VYTESNENI_ZPUSOB_MD: 'Prostřednictvím aplikace Můj depozitář',
    PRIKAZ_VYTESNENI_ZPUSOB_NEPOZADUJE: 'Emitent nepožaduje výpis z emise',
    PRIKAZ_VYTESNENI_KEDNI: 'Emitent požádá o výpis z evidence emise ke dni',
    PRIKAZ_VYTESNENI_DATUM_ZAPIS: 'Datum zápisu změny vlastnictví v evidenci',
    PRIKAZ_VYTESNENI_PRTIPLATENI: 'Uveďte výši protiplnění na 1 akcii',
    PRIKAZ_VYTESNENI_POCET_AKCII: 'Počet akcií v emisi',
    PRIKAZ_VYTESNENI_POCET_AKCII_VLASTNI: 'Počet akcií, které vlastní hlavní akcionář',
    PRIKAZ_VYTESNENI_PODMINKY_TITLE: 'Podmínky podání Příkazu',
    PRIKAZ_VYTESNENI_PODMINKY_TEXT1:
        'V souladu s platnými právními předpisy, uděleným souhlasem ČNB, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k zápisu změny vlastníků všech výše specifikovaných zaknihovaných akcií (dále jen „akcie“) v evidenci centrálního depozitáře cenných papírů v důsledku přechodu vlastnického práva k akciím všech menšinových akcionářů na hlavního akcionáře. Emitent se zavazuje, že zajistí vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv).',
    PRIKAZ_VYTESNENI_PODMINKY_TEXT2:
        'Emitent bere na vědomí, že v důsledku provedení speciální operace budou veškeré akcie uvedených emisí neevidované na výše uvedeném účtu převedeny na tento výše uvedený účet.',
    PRIKAZ_VYTESNENI_PODMINKY_TEXT3:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_VYTESNENI_PODMINKY_DLT_TEXT1:
        'V souladu s platnými právními předpisy, uděleným souhlasem ČNB, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k zápisu změny vlastníků všech výše specifikovaných zaknihovaných akcií (dále jen „akcie“) v DLT evidenci v důsledku přechodu vlastnického práva k akciím všech menšinových akcionářů na hlavního akcionáře. Emitent se zavazuje, že zajistí vypořádání veškerých závazků, které vyplývají ze zaregistrovaných práv třetích osob (zástav, PPN, případně jiných práv).',
    PRIKAZ_VYTESNENI_PODMINKY_DLT_TEXT2:
        'Emitent bere na vědomí, že v důsledku provedení speciální operace budou veškeré akcie uvedených emisí neevidované na výše uvedeném účtu převedeny na tento výše uvedený účet.',
    PRIKAZ_VYTESNENI_PODMINKY_DLT_TEXT3:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PREVOD_TYP: 'Typ příkazu',
    PRIKAZ_PREVOD_TYP_ZAPIS:
        'Příkaz k zápisu údaje o omezené převoditelnosti výše uvedeného ISIN do evidence cenných papírů',
    PRIKAZ_PREVOD_TYP_ZRUSENI:
        'Příkaz ke zrušení zápisu údaje o omezené převoditelnosti výše uvedeného ISIN do evidence cenných papírů',
    PRIKAZ_PREVOD_TYP_POPIS: 'Popište podmínky omezující převoditelnost akcií dle stanov společnosti',
    PRIKAZ_PREVOD_DATUM: 'Příkaz bude proveden v evidenci ke dni',
    PRIKAZ_PREVOD_DATUM_VYTESNENI_TOOLTIP:
        'bold(Zvolte datum nejdříve 1. pracovní den po uplynutí měsíční lhůty od zveřejnění rozhodnutí valné hromady v Obchodním rejstříku.) Například: zveřejnění v OR je 13.4., uplynutí měsíční lhůty 13.5., datum provedení příkazu 14.5. (v případě, že datum 14.5. je pracovní den)',
    PRIKAZ_PREVOD_DATUM_VYTESNENI: 'Datum zveřejnění rozhodnutí valné hromady v Obchodním rejstříku',
    PRIKAZ_PREVOD_PODMINKY_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PREVOD_PODMINKY_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři k zápisu nebo zrušení zápisu omezené převoditelnosti akcií.',
    PRIKAZ_PREVOD_PODMINKY_DLT_TEXT1:
        'V souladu s rozhodnutím valné hromady emitenta, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři k zápisu nebo zrušení zápisu omezené převoditelnosti akcií.',
    PRIKAZ_JMENOVITA_DUVOD: 'Důvod změny jmenovité hodnoty',
    PRIKAZ_JMENOVITA_DUVOD_SNIZENI: 'Rozhodnutí valné hromady o snížení základního kapitálu',
    PRIKAZ_JMENOVITA_DUVOD_ZVYSENI: 'Rozhodnutí valné hromady o zvýšení základního kapitálu',
    PRIKAZ_JMENOVITA_DUVOD_SCHUZE: 'Rozhodnutí schůze vlastníků dluhopisů',
    PRIKAZ_JMENOVITA_DUVOD_JINE: 'Jiné rozhodnutí',
    PRIKAZ_JMENOVITA_DUVOD_JINE_POPIS: 'Upřesněte o jaké rozhodnutí se jedná',
    VYPLNTE_UDAJE: 'Vyplňte údaje',
    PRIKAZ_JMENOVITA_UDAJE_PRED: 'Vyplňte údaje o emisi před změnou',
    PRIKAZ_STEPENI_UDAJE_PRED: 'Vyplňte údaje o emisi před štěpením',
    PRIKAZ_JMENOVITA_UDAJE_PRED_HODNOTA: 'Původní jmenovitá hodnota zaknihovaného cenného papíru',
    PRIKAZ_JMENOVITA_UDAJE_PRED_MENA: 'Měna jmenovité hodnoty',
    PRIKAZ_JMENOVITA_UDAJE_PRED_POCET: 'Počet zaknihovaných cenných papírů před změnou',
    PRIKAZ_JMENOVITA_UDAJE_PO: 'Vyplňte údaje o emisi po změně',
    PRIKAZ_STEPENI_UDAJE_PO: 'Vyplňte údaje o emisi po štěpení',
    PRIKAZ_JMENOVITA_UDAJE_PO_HODNOTA: 'Nová jmenovitá hodnota zaknihovaného cenného papíru',
    PRIKAZ_JMENOVITA_UDAJE_PO_MENA: 'Měna jmenovité hodnoty',
    PRIKAZ_JMENOVITA_UDAJE_PO_POCET: 'Počet zaknihovaných cenných po změně',
    PRIKAZ_JMENOVITA_UDAJE_PO_CELKOVA_HODNOTA: 'Celková jmenovitá hodnota emise',
    PRIKAZ_JMENOVITA_UDAJE_PRED_CELKOVA_HODNOTA: 'Celková jmenovitá hodnota emise',
    PRIKAZ_JMENOVITA_STEPENI_PRED_POCET: 'Počet zaknihovaných cenných papírů před štěpením',
    PRIKAZ_JMENOVITA_STEPENI_PO_POCET: 'Počet zaknihovaných cenných papírů po štěpení',
    PRIKAZ_JMENOVITA_PODMINKY_DLT_TEXT1:
        'V souladu s příslušným rozhodnutím emitenta, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři příkaz ke změně jmenovité hodnoty uvedených zaknihovaných cenných papírů v DLT evidenci.',
    PRIKAZ_JMENOVITA_PODMINKY_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_JMENOVITA_PODMINKY_TEXT1:
        'V souladu s příslušným rozhodnutím emitenta, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři příkaz ke změně jmenovité hodnoty uvedených zaknihovaných cenných papírů v evidenci.',
    PRIKAZ_JMENOVITA_PODMINKY_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_STEPENI_PODMINKY_DLT_TEXT1:
        'V souladu s příslušným rozhodnutím valné hromady emitenta, příslušnými ustanoveními zákona o obchodních korporacích, v souladu se Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři cenných papírů ke změně zápisu jmenovité hodnoty výše uvedených zaknihovaných cenných papírů v DLT evidenci bez změny objemu emise.',
    PRIKAZ_STEPENI_PODMINKY_DLT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_STEPENI_PODMINKY_TEXT1:
        'V souladu s příslušným rozhodnutím valné hromady emitenta, příslušnými ustanoveními zákona o obchodních korporacích, v souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři cenných papírů ke změně zápisu jmenovité hodnoty výše uvedených zaknihovaných cenných papírů v evidenci cenných papírů bez změny objemu emise.',
    PRIKAZ_STEPENI_PODMINKY_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_STEPENI_POMER: 'Zadejte poměr štěpení  (kolik nových akcií vznikne štěpením jedné původní akcie)',
    DODATEK_NAVYSENI_DETAIL_DATUM:
        'POŽADOVANÉ DATUM VYDÁNÍ ZAKNIHOVANÝCH CENNÝCH PAPÍRŮ NA ÚČTY NABYVATELŮ (DATUM VYPOŘÁDÁNÍ EMISE)',
    DODATEK_NAVYSENI_DETAIL_AKCIE_STAVAJICI_CP: 'Stávající počet zaknihovaných cenných papírů v emisi',
    DODATEK_NAVYSENI_DETAIL_AKCIE_ZAKNIHOVANE_CP: 'Počet zaknihovaných cenných papírů v emisi se zvyšuje o',
    DODATEK_NAVYSENI_DETAIL_AKCIE_CELKOM_CP: 'Celkový počet zaknihovaných cenných papírů v emisi po zvýšení',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_JISTINY: 'ISIN jistiny',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_KUPONU: 'ISIN kupónů',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_TITLE: 'ISIN samostatně oddělené jistiny a kupónů',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_POCET_TITLE: 'Zvýšení počtu zaknihovaných cenných papírů v emisi',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_CISLO_TRANSE: 'Číslo tranše',
    DODATEK_NAVYSENI_DETAIL_DLUHOPIS_TEXT:
        'Pokud má emise dluhopisů odtržené kupóny a jistiny. Navýšení emise platí pro všechny oddělené kupóny a jistinu',
    DOPLNIT_ADMINA: 'Chcete doplnit administrátora emise?',
    ADMIN_PONEHCAT: 'Ponechat stávajícího administrátora',
    ADMIN_ZMENIT: 'Změnit administrátora',
    ADMIN_ODSTRANIT: 'Odstranit administrátora',
    POCET_DNI_ERR: 'Počet dní musí být >= 0',
    VYPLNTE_DATUMY: 'Vyplňte datum(y) pro výplatu kupónu za první rok.',
    ADMIN_NE: 'Emitent nemá administrátora emise',
    ADMIN_ANO: 'Emitent má administrátora emise',
    ISIN_ZRUSENI_DUVOD: 'Důvod zrušení',
    ISIN_ZMENA_DUVOD: 'Popis požadovaných změn',
    DODATEK_PREJIST_PRIKAZ: 'Chcete pokračovat vyplnění příkazu k vydání?',
    PRIKAZ_CP_PPN: 'Počet CP s PPN',
    PRIKAZ_PPN_ZRUSIT: 'Zrušit PPN',
    PRIKAZ_PPN_ZRUSIT_NAVSECHUCT: 'Na všech majetkových účtech',
    PRIKAZ_PPN_ZRUSIT_NAUCTMAJIT: 'Na účtu majitele',
    PRIKAZ_PPN_ZRUSIT_TEXT1:
        'V souladu s příslušným rozhodnutím emitenta, příslušnými ustanoveními zákona o obchodních korporacích, v souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři cenných papírů ke zrušení zápisu pozastavení práva vlastníka nakládat s cennými papíry ve smyslu § 97 ZPKT v evidenci cenných papírů.',
    PRIKAZ_PPN_ZRUSIT_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PPN_ZRUSIT_TEXT2_DLT:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PPN_ZRUSIT_TEXT1_DLT:
        'Emitent podává centrálnímu depozitáři cenných papírů příkaz ke zrušení zápisu pozastavení práva vlastníka nakládat s cennými papíry (PPN), ke kterému dal příkaz ve vztahu k zaměstnaneckým akciím, a prohlašuje, že tak činí v souladu s platnými právními předpisy a smluvními ujednáními.',
    DODATEK_DLUHOPIS_DATUM_TOOLTIP_1: 'Pokud emisní podmínky:',
    DODATEK_DLUHOPIS_DATUM_TOOLTIP_2:
        'a) obsahují ustanovení o tom, že výplata, pokud vyjde na víkend nebo státní svátek, pak bude provedena v následující pracovní den, ',
    DODATEK_DLUHOPIS_DATUM_TOOLTIP_3:
        'b) nebo pokud je v emisních podmínkách uvedeno, že výplata bude provedena např. do 5 dní po stanoveném datu výplaty,',
    DODATEK_DLUHOPIS_DATUM_TOOLTIP_4:
        'pak v obou těchto případech uvádějte datum výplaty z emisních podmínek a neposunujte toto datum na pracovní den nebo na den skutečné platby na účet majitelů dluhopisů.',
    PRIKAZ_PRODLOUZENI_DUVOD: 'Důvod prodloužení splatnosti',
    PRIKAZ_PRODLOUZENI_DUVOD_ROZHODNUTI: 'Rozhodnutí schůze vlastníků',
    PRIKAZ_PRODLOUZENI_DUVOD_JINY: 'Jiný',
    PRIKAZ_PRODLOUZENI_DUVOD_JINY_DUVOD: 'Upřesněte jiný důvod prodloužení splatnosti',
    PRIKAZ_PRODLOUZENI_DATUM: 'Změnu splatnosti emise proveďte ke dni',
    PRIKAZ_PRODLOUZENI_DATUM_ERR: 'Datum musí být nižší než nové datum splatnosti',
    PRIKAZ_PRODLOUZENI_DATUM_SPLATNOST_PUVODNI: 'Původní datum splatnosti',
    PRIKAZ_PRODLOUZENI_DATUM_SPLATNOST_NOVY: 'Nové datum splatnosti',
    PRIKAZ_PRODLOUZENI_DATUM_SPLATNOST_NOVY_ERR:
        'Datum musí být vyšší než aktuální datum a původní datum splatnosti dluhopisu',
    PRIKAZ_PRODLOUZENI_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k prodloužení splatnosti výše specifikovaných zaknihovaných cenných papírů v evidenci emise.',
    PRIKAZ_PRODLOUZENI_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PRODLOUZENI_TEXT3:
        'Emitent bere na vědomí, že změna splatnosti dluhopisů podléhá zpoplatnění dle platného ceníku centrálního depozitáře za prodloužené období.',
    PRIKAZ_PRODLOUZENI_TEXT4:
        'Emitent bere na vědomí, že pokud požaduje blokaci emise před novým datem splatnosti emise, musí podat požadavek prostřednictvím formuláře Příkaz emitenta k zápisu blokace před splatností.',
    PRIKAZ_PRODLOUZENI_DLT_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k prodloužení splatnosti výše specifikovaných zaknihovaných cenných papírů v evidenci emise.',
    PRIKAZ_PRODLOUZENI_DLT_TEXT3:
        'Zápis změny v DLT evidenci bude proveden nejdříve 5 (pátý) pracovní den po dni doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PRODLOUZENI_DLT_TEXT4:
        'Emitent bere na vědomí, že změna splatnosti dluhopisů podléhá zpoplatnění dle platného ceníku DLT evidence za prodloužené období.',
    PRIKAZ_PRODLOUZENI_DLT_TEXT5:
        'Emitent bere na vědomí, že pokud požaduje blokaci emise před novým datem splatnosti emise, musí podat požadavek prostřednictvím formuláře Příkaz emitenta k zápisu blokace před splatností.',
    PRIKAZ_ZMENA_UDAJU_DATUM: 'Změnu údajů proveďte ke dni',

    PRIKAZ_ZMENA_UDAJU_TYP: 'Zvolte druh požadované změny',
    PRIKAZ_ZMENA_UDAJU_TYP_NAV: 'NAV',
    PRIKAZ_ZMENA_UDAJU_TYP_UROKSAZBATYP: 'Úroková sazba',
    PRIKAZ_ZMENA_UDAJU_TYP_JINY: 'Jiný údaj',
    PRIKAZ_ZMENA_UDAJU_TYP_UROKOVASAZBAVYSE: 'Výše úrokové sazby',
    PRIKAZ_ZMENA_UDAJU_TYP_UROKOVASAZBA: 'Úroková sazba',
    PRIKAZ_ZMENA_UDAJU_TYP_AUV: 'Standard AÚV',
    PRIKAZ_ZMENA_UDAJU_TYP_FREKVENCE: 'Frekvence výplaty',
    PRIKAZ_ZMENA_UDAJU_TYP_ZARUCENI_EMISE: 'Informace o zaručení emise',
    PRIKAZ_ZMENA_UDAJU_TYP_JINY_POPIS: 'Uveďte jiný údaj',
    PRIKAZ_ZMENA_UDAJU_UROK_SAZBA_P: 'Původní úroková sazba',
    PRIKAZ_ZMENA_UDAJU_UROK_SAZBA_N: 'Nová úroková sazba',
    PRIKAZ_ZMENA_UDAJU_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz k provedení změny údajů výše specifikovaných zaknihovaných cenných papírů v evidenci emise.',
    PRIKAZ_ZMENA_UDAJU_TEXT3:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_ZMENA_UDAJU_DLT_TEXT1:
        'V souladu s platnými právními předpisy, Smlouvou o vedení evidence emise v DLT evidenci a Pravidly DLT evidence centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke změně údajů výše specifikovaných zaknihovaných cenných papírů v DLT evidenci.',
    PRIKAZ_ZMENA_UDAJU_DLT_TEXT2:
        'Emitent bere na vědomí, že změna údajů emise bude provedena v evidenci s účinností od začátku prvního pracovního dne, který bezprostředně následuje po uvedeném datu. ',
    PRIKAZ_ZMENA_UDAJU_DLT_TEXT3:
        'Zápis změny v DLT evidenci bude proveden do 5 pracovních dní po dni schválení tohoto příkazu centrálním depozitářem, není-li emitentem požadováno pozdější datum zápisu.',
    PRIKAZ_BLOKACE_TEXT:
        'V souladu s příslušným rozhodnutím emitenta, příslušnými ustanoveními zákona o dluhopisech, v souladu se Smlouvou o vedení evidence emise a Provozním řádem centrálního depozitáře podává výše uvedený emitent příkaz centrálnímu depozitáři cenných papírů k zápisu pozastavení práva vlastníka nakládat s cennými papíry ve smyslu § 97 ZPKT v evidenci cenných papírů.',
    PRIKAZ_BLOKACE_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    ZRUSIT_ZVEREJNENI: 'Zrušit zveřejnění',
    ZRUSIT_VH_CONFIRM: 'Opravdu si přejete zrušit',
    PRIKAZ_ZMENIT_PLATNOST_UROK_SAZBY: 'Platnost úrokové sazby od',
    PRIKAZ_ZMENA_UDAJU_UROKTYP_PUV: 'Původní typ úrokové sazby',
    PRIKAZ_ZMENA_UDAJU_UROKTYP_NOVY: 'Nový typ úrokové sazby',
    PRIKAZ_ZMENA_UDAJU_TYP_STANDARD_PUV: 'Původní typ standardu',
    PRIKAZ_ZMENA_UDAJU_TYPSTANDARD_NOVY: 'Nový typ standardu',
    PRIKAZ_ZMENA_UDAJU_ZARUCENI_EMISE_P: 'Původní informace o zaručení emise',
    PRIKAZ_ZMENA_UDAJU_ZARUCENI_EMISE_N: 'Nová informace o zaručení emise',
    PRIKAZ_ZMENA_UDAJU_VYSE_SAZBY_P: 'Původní výše úrokové sazby',
    PRIKAZ_ZMENA_UDAJU_VYSE_SAZBY_N: 'Nová výše úrokové sazby',
    DOKUMENT_DODATEK_CP_SPUSOB_VICUPISOVATELU: 'Předpokládaný počet upisovatelů je větší než 10 osob',
    PRIKAZ_EMITENT_TITLE: 'Vyplňte údaje emitenta',
    PRIKAZ_LIKVIDACE_TITLE: 'Vyplňte údaje zanikajícího emitenta',
    PRIKAZ_LIKVIDACE_NAZEV: 'Obchodní firma nebo jiný název osoby',
    PRIKAZ_LIKVIDACE_JINA_SIDLO: 'Adresa sídla jiné osoby podávající příkaz',
    PRIKAZ_LIKVIDACE_DATUM: 'Zrušení evidence emise proveďte ke dni',
    PRIKAZ_LIKVIDACE_DATUM_TOOLTIP:
        'V případě, že zvolíte jiný než pracovní den bude operace provedena následující pracovní den.',
    PRIKAZ_LIKVIDACE_ZRUSENI_SELECT: 'Způsob podání žádosti jiné osoby o výpis z emise',
    PRIKAZ_LIKVIDACE_ZRUSENI_CDCP:
        'Prostřednictvím žádosti doručené centrálnímu depozitáři přes aplikaci Můj depozitář',
    PRIKAZ_LIKVIDACE_ZRUSENI_NEPOZADUJE: 'Nepožaduje výpis z emise',
    PRIKAZ_LIKVIDACE_ZRUSENI_VYPIS: 'Jiná osoba podá žádost o výpis z emise prostřednictvím samostatného formuláře',
    PRIKAZ_LIKVIDACE_ZRUSENI_JINAOSOBA_TEXT:
        'Jiná soba uvedená výše, podává centrálnímu depozitáři příkaz k zápisu do evidence v rozsahu, který ji k tomu opravňuje.',
    PRIKAZ_LIKVIDACE_ZRUSENI_TEXT:
        'Výše uvedená osoba, podávající centrálnímu depozitáři příkaz k zápisu do evidence, podává příkaz v rozsahu, který ji k podání příkazu opravňuje.',
    PRIKAZ_LIKVIDACE_ZRUSENI_TEXT2_JINA:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 3 (třetí) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_LIKVIDACE_ZRUSENI_TEXT2:
        'Příkaz bude proveden v evidenci ke dni, který musí být stanoven nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_LIKVIDACE_POPIS: 'Popište svůj požadavek',
    PRIKAZ_JINAOSOBA_VYPIS_DRUH: 'Druh výpisu',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP: 'Způsob převzetí a druh výstupu',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_MD:
        'Elektronicky prostřednictvím aplikace Můj Depozitář (750 Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_OSOBUSB:
        'Osobní vyzvednutí v sídle CDCP - výstup na USB disk (5 000 Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_OSOBLIST:
        'Osobní vyzvednutí v sídle CDCP - výstup v listinné podobě (9 000 Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_POSTAUSB:
        'Doručení prostřednictvím pošty na dobírku - výstup USB disk (5 000 Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_DATOVKA: 'Datová schránka pro příjem odpovědi (5 000 Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_VYSTUP_POSTALIST:
        'Doručení prostřednictvím pošty na dobírku - výstup v listinné podobě (9 000Kč + 2 Kč za každý účet)',
    PRIKAZ_JINAOSOBA_VYPIS_KATEGORIE: 'Kategorie výpisu',
    PRIKAZ_JINAOSOBA_VYPIS_KATEGORIE_OBA:
        'Majitelé a správci (výpis obsahuje informaci o všech majitelích a správcích)',
    PRIKAZ_JINAOSOBA_VYPIS_KATEGORIE_JEDEN:
        'Majitel / Správce (pokud je u účtu veden správce, informace o majiteli není uvedena)',
    PRIKAZ_JINAOSOBA_VYPIS_DORUCENI_OSOB: 'Jiná osoba tímto zmocňuje k vyzvednutí výpisu z emise níže uvedenou osobu',
    PRIKAZ_JINAOSOBA_VYPIS_DORUCENI_POST: 'Doručení prostřednictvím pošty na dobírku',
    PRIKAZ_JINAOSOBA_VYPIS_DORUCENI_EMAIL: 'E-mail pro zaslání dešifrovacího hesla',
    PRIKAZ_PREVODNASL_MAJETKOV_UCET: 'Číslo majetkového účtu určeného pro distribuci zaměstnaneckých akcií',
    PRIKAZ_PREVODNASL_MAJETKOV_PRILOHY_TOOLTIP:
        'Vložte dokument, ze kterého vyplývá souhlas vlastníka (nabyvatele) zaměstnanecké akcie se zápisem PPN k akciím ve smyslu § 97 odst. 1 písm. e) ZPKT',
    PRIKAZ_PREVODNASL_MAJETKOV_PODMINKY:
        'Emitent podává centrálnímu depozitáři cenných papírů příkaz k zápisu pozastavení práva vlastníka nakládat s cennými papíry (PPN) ve smyslu § 97 ZPKT do DLT evidence, a to okamžitě po provedení zápisu převodu zaměstnanecké akcie z účtu určeného výše pro distribuci na účet nabyvatele, a prohlašuje, že tak činí na základě doložitelného souhlasu nabyvatele zaměstnanecké akcie se zápisem PPN. Na základě příkazu emitenta bude možné založit údaje o PPN v DLT evidenci nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    PRIKAZ_PREVODZPET_UCET: 'Vyplňte číslo distribučního majetkového účtu ke zpětnému převodu zaměstnaneckých akcií',
    PRIKAZ_PREVODZPET_FORMA: 'Forma zpětného převodu',
    PRIKAZ_PREVODZPET_FORMA_BEZZAPLACENI: 'bez zajištění zaplacení (DFP)',
    PRIKAZ_PREVODZPET_FORMA_PROTIZAPLACENI: 'proti zajištění zaplacení (DVP)',
    PRIKAZ_PREVODZPET_ZRUS_PPN: 'Zrušení PPN a zpětný převod',
    PRIKAZ_PREVODZPET_PODMINKY:
        'Emitent podává centrálnímu depozitáři cenných papírů příkaz ke zrušení zápisu pozastavení práva vlastníka nakládat s cennými papíry (PPN) a k provedení zápisu zpětného převodu zaměstnanecké akcie z účtů, na kterých jsou evidovány zaměstnanecké akcie, na výše určený distribuční účet, a prohlašuje, že tak činí v souladu s platnými právními předpisy a smluvními ujednáními. Na základě příkazu emitenta bude možné zrušit zápis PPN v evidenci nejdříve 5 (pátý) pracovní den po doručení tohoto příkazu centrálnímu depozitáři.',
    DOK_JINA_IDENTIFIKACE_OSOBA: 'Identifikace podávající osoby',
    DOK_JINA_IDENTIFIKACE_OSOBA_ZAS: 'Zastoupená',
    JINA_OSOBA: 'Jiná osoba',
    JINA_OSOBA_TEXT:
        'Jiné než výše výslovně uvedené osoby, které jsou oprávněny požádat o zápis do evidence ve zvláštních případech, jako jsou likvidátor nebo nástupce emitenta v případě fúze, za předpokladu doložení oprávněnosti požadavku.',
    JINA_OSOBA_MENU: 'Dokumenty jiné osoby',
    JINA_OSOBA_404: 'Zatím nebyla vytvořena žádná žádost',
    JINA_OSOBA_NAZEV_SPOLECNOSTI: 'Název společnosti emitenta',
    JINA_OSOBA_ICO: 'IČO emitenta',
    JINA_OSOBA_IDMB_LABEL: 'Identifikační číslo (IČ)/NID/RČ',
    BANKID_OVERENI_LOGIN_TITLE: 'Nové ověření pomocí Bank iD',
    BANKID_OVERENI_LOGIN_TEXT1: 'Pro přístup k novému ověření Vám bude zaslána SMS s kódem',
    BANKID_OVERENI_LOGIN_TEXT2: 'Zadejte kód, který jste obdrželi v SMS zprávě',
    BANKID_OVERENI_LOGIN_TEXT3: 'Přihlaste se prosím pomocí Bank iD',
    BANKID_OVERENI_LOGIN_BTN: 'Přihlášení pomocí Bank iD',
    BANKID_OVERENI_LOGIN_SUCC: 'Nové ověření pomocí Bank iD bylo úspěšně dokončeno.',
    BANKID_OVERENI_LOGIN_SUCC_BTN: 'Pokračovat do Můj depozitář',
    BANKID_OVERENI_LOGIN_OK: 'Uživateli byl nastaven přístup přes novou Bankovní identitu',
    BANKID_OVERENI_LOGIN_IDEN: '',
    BANKID_OVERENI_LOGIN_CHYBNY: 'Byl jste přihlášený jinou osobou, než pro kterou je vedený přistup.',
    BANKID_OVERENI_LOGIN_EXISTUJE: 'Tuto Bankovní identitu již používá jiný uživatel. Nedá se použít.',
    PRIKAZ_SEZNAM_PODMINKY_1:
        '1.1.1 Emitent bere na vědomí, že centrální depozitář zajistí vydání zaknihovaných cenných papírů na účty nabyvatelů a, bylo-li to dohodnuto, též převod peněžní částky za upsané cenné papíry na stanovený účet, pouze pokud dodatek ke Smlouvě, na základě kterého se podává příkaz, byl uzavřen nejpozději 7 pracovních dní před požadovaným datem vydání zaknihovaných cenných papírů, není-li dohodnuto s centrálním depozitářem jinak, a pokud budou emitentem (účastníkem centrálního depozitáře) splněny dále uvedené podmínky.',
    PRIKAZ_SEZNAM_PODMINKY_2:
        '1.1.2 Emitent se zavazuje sám nebo prostřednictvím účastníka zajistit: a) splnění podmínek pro včasný zápis zaknihovaných cenných papírů na majetkové účty nabyvatelů, b) zajistit předávání informací souvisejících s vydáním zaknihovaných cenných papírů na účty nabyvatelů všem účastníkům, kterých se tyto informace týkají.',
    PRIKAZ_SEZNAM_PODMINKY_3: '1.1.3 Emitent se dále zavazuje zajistit:',
    PRIKAZ_SEZNAM_PODMINKY_3A:
        'a.	v případě DFP dodání řádně vyplněného seznamu upisovatelů CDCP nejpozději do 16:30 hod. druhého pracovního dne předcházejícího požadovanému datu vydání,',
    PRIKAZ_SEZNAM_PODMINKY_3B:
        'b.	v případě DVP v měně CZK dodání řádně vyplněného seznamu upisovatelů CDCP nejpozději do 11:00 hod. pracovního dne předcházejícího požadovanému datu vydání zaknihovaných cenných papírů, a nejpozději do 11:00 hod. druhého pracovního dne předcházejícího požadovanému datu vydání, půjde-li o jinou měnu V případě, že v den úpisu nebude některý z příkazů vypořádán, tento příkaz je zrušen a ',
    PRIKAZ_SEZNAM_PODMINKY_3C:
        'c.	V případě kombinovaného vydání DFP a DVP je emitent povinen dodat řádně vyplněný seznam upisovatelů ve lhůtách podle písmene b) pro DVP i DFP.',
    PRIKAZ_SEZNAM_PODMINKY_3X:
        'Při vydání zaknihovaných cenných papírů proti zaplacení je emitent povinen poskytnout identifikaci nabyvatelů sdělenou emitentovi nabyvatelem pro účely řádného spárování příkazů k vypořádání příslušného vydání zaknihovaných cenných papírů. Tato identifikace nabyvatelů slouží v rámci vypořádání účastníkovi nabyvatele ke správné identifikaci jeho klienta a korektnímu napárování. Předání správné identifikace klienta je odpovědnost nabyvatele a emitenta  a Centrální depozitář neodpovídá za případné chybné či nespárované instrukce.',
    POCET_UPIS_CP: 'Počet upisovaných CP',
    DVP_IDENTIFIKACE_KLIENTA: 'Identifikace klienta kterou obdržel emitent od účastníka pro tento úpis',
    DVP_CELKOVA_CASTKA: 'Celková částka za upisované cenné papíry',
    F45_PARAMS: 'Parametry výpisu',
    F45_ZAST: 'Včetně zástav a PPN',
    F45_ESM: 'Včetně údajů o ESM',
    F45_MAJUCET: 'Včetně čísel majetkových účtů',
    F45_BANKUCET: 'Včetně peněžních účtů',
    F45_PDCP: 'Včetně údajů o majiteli i správci (výpis obsahuje informace o všech majitelích a správcích)',
    F45_MOC_INFO: 'Emitent tímto zmocňuje k vyzvednutí výpisu z emise níže uvedenou osobu',
    POCET_UCASTNIKU: 'Počet účastníků',
    DVP_BANKUCET_NULL: 'Bankovní účet dosud nebyl zadán',
    DVP_TITLE_DETAIL: 'Detail vybraného požadavku na úpis DVP',
    PRIKAZ_JINA_VYPIS_TEXT:
        'Výše uvedená osoba, podává centrálnímu depozitáři žádost o výpis z emise v rozsahu, který ji k tomu opravňuje.',
    PRIKAZ_JINA_VYPIS_TEXT2:
        'Žadatel bere na vědomí, že jím uvedená osoba určená k převzetí výpisu z emise se pro převzetí prokáže platným průkazem totožnosti.',
    PRIKAZ_JINA_VYPIS_TEXT3:
        'Žadatel bere na vědomí, že výpis vyhotovený v listinné podobě, je zpoplatněn zvýšenou sazbou dle platného ceníku CDCP.',
    PRIKAZ_ZMENREGI_DODATEK_CHKBOX: 'Potvrzuji správnost změny místa registrace přiděleného ISIN',
    PRIKAZ_ZMENREGI_DATUM: 'Příkaz k současnému zrušení a vydání bude proveden v evidenci ke dni',
    PRIKAZ_ZMENREGI_MISTO_PUV: 'Původní místo registrace emise (uveďte stávající místo registrace emise)',
    PRIKAZ_ZMENREGI_MISTO_NOVE: 'Nové místo registrace emise (uveďte nové místo registrace emise)',
    PRIKAZ_ZMENREGI_CHECKBOX: 'Emitent podá samostatně Dodatek o evidovaní emise',
    PRIKAZ_ZMENREGI_DATUM_TEXT:
        'K uvedenému dni budou v původní evidenci zaknihované cenné papíry zrušeny na majetkových účtech a vydány na majetkové účty v nové evidenci. Podmínkou vydání v nové evidenci je uzavření dodatku o vedení evidence emise a uvedení majetkových účtů, na které budou cenné papíry vydány.',
    PRIKAZ_ZMENREGI_CHKBOX_TEXT1:
        'Emitent bere na vědomí potřebu uzavření samostatného Dodatku o vedení evidence emise pro nové místo registrace nejpozději 5 pracovních dní před požadovanou změnou, pokud není dohodnuto jinak.',
    PRIKAZ_ZMENREGI_CHKBOX_TEXT2:
        'Emitent tímto dává příkaz k zápisu pozastavení práva nakládat s cennými papíry na emisi zaknihovaných cenných papírů k datu, které předchází 7 pracovních dní datum ukončení emise v evidenci.',
    PRIKAZ_ZMENREGI_CHKBOX_TEXT3:
        'Emitent bere na vědomí, že je povinen samostatnou žádostí vyhotovit výpis z evidence emise k datu zápisu pozastavení práva nakládat. Tento výpis je podkladem k zápisu práv spojených s cennými papíry (PPN, Zástavní právo) při vydání těchto cenných papírů v novém místě registrace.',
    PRIKAZ_ZMENREGI_TEXT1:
        'V souladu s platnými právními předpisy a pravidly centrálního depozitáře podává výše uvedený emitent centrálnímu depozitáři cenných papírů příkaz ke změně místa registrace, tj. druhu centrální evidence vedené centrálním depozitářem.',
    PRIKAZ_ZMENREGI_TEXT2:
        'Emitent bere na vědomí, že vydání zaknihovaných cenných papírů v nové centrální evidenci bude provedeno po zrušení zaknihovaných cenných papírů ve stávající evidenci. br() Emitent se zavazuje uvést při vydání v nové evidenci údaje o zaregistrovaných právech třetích osob zapsaných ve stávající evidenci (zástavní práva, PPN, případně jiných práv). br() Emitent bere na vědomí, že žádost o výpis emise doručená centrálnímu depozitáři musí být podána samostatně, prostřednictvím portálu Můj depozitář.',
    PODMINKY_PODANI_ZADOSTI: 'Podmínky podání Žádosti',
    POVOLIT_EDITACI: 'Povolit editaci',
    UPIS_DVP_DELETE_SELECTED_CONFIRM: 'Opravdu si přejete smazat vybraný požadavek?',
    AMLZ_OSOBA_ZMENA_CONFIRM_TEXT:
        'Před změnou Vámi zadaných údajů bude odstraněn podepsaný soubor. Poté ho bude nutné znovu stáhnout, podepsat a nahrát.',
    LEI_PREVOD: 'Žádost o převod LEI',
    LEI_PREVOD_TITLE: 'Žádost o převod LEI do CDCP, a.s. (LEI 315700LK78Z7COWMIL03)',
    LEI_PREVOD_TITLE_HOTOVO: 'Odeslána žádost o převod LEI do CDCP, a.s. (LEI 315700LK78Z7COWMIL03)',
    LEI_PREVOD_LABEL: 'Převáděný kód LEI',
    LEI_PREVOD_OSOBA_TITLE: 'Informace o oprávněné/pověřené osobě',
    LEI_PREVOD_ZADAJTE_LEI: 'Zadejte kód LEI',
    LEI_PREVOD_ZKONTROLUJTE_UDAJE: 'Zkontrolujete údaje převáděného LEI',
    LEI_PREVOD_ZKONTROLUJTE_UDAJE_PREHLED: 'Údaje převáděného LEI',
    LEI_PREVOD_SUBMIT_APPROVAL1:
        'Jménem výše uvedené právnické osoby žádám o převedení správy LEI do Centrálního depozitáře cenných papírů, a.s. (dále CDCP). Tímto potvrzuji, že jsem oprávněn jednat jménem výše uvedené právnické osoby. Uděluji společnosti CDCP a.s. souhlas s postoupením formuláře a kontaktních údajů odesílajícímu LOU. Beru na vědomí, že odesílající LOU může, za účelem uskutečnění přesunu LEI, zaslat tento formulář osobám, které jsou v databázi odesílajícího LOU uvedeny jako kontaktní',
    LEI_PREVOD_SUBMIT_APPROVAL2:
        'Potvrzuji správnost zaslaných údajů a beru na vědomí, že potvrzením žádosti bude uzavřena smlouva mezi žadatelem a Centrálním depozitářem cenných papírů ve smyslu článku 3 Pravidel přidělování a vedení LEI.',
    LEI_PREVOD_SUBMIT_APPROVAL3:
        'Odesláním tohoto formuláře poskytuji dobrovolně souhlas společnosti Centrální depozitář cenných papírů, a.s., ke spravování a zpracování osobních údajů uvedených ve formuláři za účelem umožnění komunikace související s přesunem LEI do CDCP, a.s. a za účelem vedení jejich evidence. Potvrzuji, že jsem byl poučen, že způsob zpracování je automatizovaný a mám právo u společnosti kontrolovat poskytnuté osobní údaje, žádat jejich opravu a svůj souhlas mohu také kdykoliv písemnou formou odvolat. Jsem si vědom, že další práva týkající se sdělených údajů mi poskytuje zejména § 11 a násl. zákona č. 101/2000 Sb., o ochraně osobních údajů.Odesláním tohoto formuláře poskytuji dobrovolně souhlas společnosti Centrální depozitář cenných papírů, a.s., ke spravování a zpracování osobních údajů uvedených ve formuláři za účelem umožnění komunikace související s přesunem LEI do CDCP, a.s. a za účelem vedení jejich evidence. Potvrzuji, že jsem byl poučen, že způsob zpracování je automatizovaný a mám právo u společnosti kontrolovat poskytnuté osobní údaje, žádat jejich opravu a svůj souhlas mohu také kdykoliv písemnou formou odvolat. Jsem si vědom, že další práva týkající se sdělených údajů mi poskytuje zejména § 11 a násl. zákona č. 101/2000 Sb., o ochraně osobních údajů.',
    KOD_LEI: 'Kód LEI (Legal Entity Identifier)',
    STAV_LEI: 'Stav LEI',
    ICO_SPOLECNOSTI: 'Identifikační číslo společnosti (IČO)',
    DATUM_VYDANI: 'Datum vydání',
    DATUM_POSLEDNI_ZMENY: 'Datum poslední změny',
    DATUM_EXPIRACE: 'Datum expirace',
    STAV_PREVODU: 'Stav převodu',
    STAV_PRIKAZU: 'Stav příkazu',
    SPRAVCE_LOU: 'Současný správce LOU',
    LEI_REGISTRACE_BTN_OBNOVA: 'Žádost o obnovení kódu LEI',
    LEI_REGISTRACE_BTN_TRANSFER: 'Žádost o převod kódu LEI',
    LEI_REGISTRACE_PREVOD: 'Převod kódu LEI',
    LEI_REGISTRACE_REGISTRACE: 'Žádost o kód LEI',
    LEI_REGISTRACE_AKTUALIZACE: 'Obnovení/aktualizace kódu LEI',
    LEI_REGISTRACE_BTN: 'Žádost o kód LEI',
    LEI_PREVOD_BTN: 'Pokračovat s převodem LEI do CDCP',
    LEI_PREVOD_BTN_ISSUED: 'Převést LEI',
    LEI_PREVOD_BTN_ISSUED_DUE: 'Převést LEI s prodloužením platnosti',
    LEI_PREVOD_BTN_LAPSED: 'Převést LEI a prodloužit platnost',
    LEI_PREVOD_ISSUED:
        'LEI kód je platný. Můžete pokračovat s převodem LEI do CDCP. Za převod není účtován žádný poplatek. Před blížícím se koncem platnosti LEI obdržíte notifikaci s výzvou k prodloužení platnosti LEI.',
    LEI_PREVOD_ISSUED_DUE:
        'LEI kód lze převést do CDCP.  Za přenos LEI není účtován poplatek. Za prodloužení platnosti je účtován poplatek dle ceníku CDCP. ',
    LEI_PREVOD_LAPSED:
        'LEI lze převést do CDCP.  V rámci přenosu LEI bude provedena aktualizace údajů a současně dojde k prodloužení platnosti.  Za prodloužení platnosti je účtován poplatek dle Ceníku CDCP.',
    LEI_PREVOD_OSOBA_TEXT:
        'Oprávnění zastupovat společnost (oprávněná osoba) by zásadně mělo vyplývat z veřejných rejstříků, zejména z obchodního rejstříku. V případě pověřené osoby toto pověření musí být doloženo plnou mocí podepsanou oprávněnou osobou či osobami uvedenými v těchto rejstřících. V jiných případech si Centrální depozitář vyhrazuje právo vyzvat žadatele k prokázání oprávněnosti osoby zastupovat společnost, případně si vyhrazuje právo žádost odmítnout.',
    EMAIL_OVERIT: 'Ověřit e-mail',
    EMAIL_OVERIT_KOD: 'Opište kód z e-mailu',
    EMAIL_OVERIT_KOD_TEXT:
        'Na Váš e-mail byl zaslán odkaz pro nastavení hesla do portálu Můj depozitář. Heslo můžete nastavit po dokončení žádosti. Prostřednictvím portálu Můj depozitář můžete spravovat kód LEI.',
    EMAIL_TOOLTIP:
        'Kontaktní email je primární kontakt, na který budou zasílány informace. E-mail bude sloužit k vytvoření účtu a přihlášení do portálu Můj depozitář.',
    LEI_LOGINLESS_EMAIL_ERR_CHYBNYFORAMT: 'chybný formát e-mailu',
    LEI_LOGINLESS_EMAIL_ERR_CHYBNYSOUBOR: 'nepodařilo se dohledat soubor',
    LEI_LOGINLESS_EMAIL_ERR_CHYBAODESLANI: 'nepodařilo se odeslat e-mail',
    LEI_LOGINLESS_UZIV_ERR_CHYBNYKOD: 'Kód zadaný uživatelem je chybný.',
    LEI_LOGINLESS_UZIV_ERR_NEEXISTUJE: 'Uživatel neexistuje, je potřeba pro něj založit účet.',
    LEI_LOGINLESS_UZIV_ERR_EXISTUJE: 'Uživatel existuje, lze jej automaticky přihlásit do MD LEI.',
    LEI_LOGINLESS_UZIV_ERR_MUSI: 'Uživatel existuje, do MD LEI se musí přihlásit.',
    LEI_LOGINLESS_UZIV_ERR_MUZE: 'Uživatel existuje, do MD LEI se může přihlásit nebo může požadovat založení účtu.',
    LEI_LOGINLESS_LEI_ERR_UNAUTHJURISD: 'K této jurisdikci není CDCP akreditována.',
    LEI_LOGINLESS_LEI_ERR_LOUCDCP: 'Společnost má kód LEI registrován v CDCP.',
    LEI_LOGINLESS_LEI_ERR_JINELOU: 'Společnost má kód LEI registrován v GLEIFu (LOU není CDCP).',
    LEI_LOGINLESS_LEI_ERR_LEINEEXISTUJE: 'Zadané LEI neexistuje.',
    LEI_LOGINLESS_LEI_ERR_ICNEEXISTUJE: 'Zadané IČ pro jurisdikci neexistuje.',
    LEI_LOGINLESS_LEI_ERR_REGPOVINNY: 'Rejstřík je povinný pro německo',
    LEI_LOGINLESS_LEI_ICO_ERR: 'vyplňte prosím lei nebo jurisdikci a identifikační číslo',
    LEI_LOGINLESS_TRANSFER_INFO:
        'Upozornění: Před obnovením vašeho kódu LEI musí být váš LEI nejprve převeden z bold({{louname}}) do společnosti bold(Centrální depozitář cenných papírů, a.s.). Tento proces spustíte odesláním žádosti. Převod je rychlý a bezplatný. Další informace o převodech kódů LEI naleznete.',
    DATUM_PLATNOSTI_AML: 'Platnost AML do',
    LEI_STAV_GLEIF_UNAUTHJURISD:
        'Vámi zadané LEI  nelze převést do správy naší LOU. LEI spadá do jurisdikce, pro kterou nejsme oprávněni spravovat kódy LEI.',
    LEI_STAV_GLEIF_LOUCDCP:
        'Zadaný LEI kód je již spravován v CDCP. Pokud chcete LEI spravovat, použijte volbu bold(Přiřadit LEI  k mému účtu). Případné dotazy zodpovíme na emailové adrese lei@pse.cz.',
    ID_MAJITELE_SHORT: 'ID majitele',
    SANKCE: 'Sankce',
    KONTROLA_UCTU: 'Probíhá kontrola účtů',
    SMAZAT_POZADAVEK: 'Smazat požadavek',
    ZADOST_HOTOVO: 'Žádost byla dokončena.',
    SPAROVANO: 'spárováno',
    LEI_UPDATE_DIC_ERR: 'prosím vyplňte DIČ',
    // isbgeneral lei
    DETAILLEI_LEI: 'LEI',
    DETAILLEI_LEGALNAME: 'Název společnosti',
    DETAILLEI_TRANSLITOTHERENTITYNAME: 'Anglický název společnosti',
    DETAILLEI_ADDRESS: 'Adresa sídla společnosti',
    DETAILLEI_REGISTRATIONAUTHORITYID: 'Registrován u',
    DETAILLEI_OTHERREGISTAUTHORITYID: 'Jiný rejstřík',
    DETAILLEI_REGISTAUTHORITYENTITYID: 'Identifikační číslo (IČ)',
    DETAILLEI_LEGALJURISDICTION: 'Jurisdikce',
    DETAILLEI_ENTITYCATEGORY: 'Kategorie osoby',
    DETAILLEI_LEGALFORM: 'Právní forma',
    DETAILLEI_OTHERLEGALFORM: 'Jiná právní forma',
    DETAILLEI_ENTITYSTATUS: 'Status společnosti',
    DETAILLEI_ENTITYCREATIONDATE: 'Datum založení společnosti',
    DETAILLEI_INITIALREGISTRATIONDATE: 'Datum registrace',
    DETAILLEI_LASTUPDATEDATE: 'Datum poslední aktualizace',
    DETAILLEI_REGISTRATIONSTATUS: 'Status LEI',
    DETAILLEI_ENTITYLEGALFORMCODE: 'Právní forma',
    DETAILLEI_NEXTRENEWALDATE: 'Datum příští certifikace / Platnost do',
    DETAILLEI_MANAGINGLOU: 'Vydavatel LEI',
    DETAILLEI_ENDNODEID: 'LEI',
    DETAILLEI_RELATIONSHIPTYPE: 'Typ vztahu',
    DETAILLEI_RELATIONSHIPSTATUS: 'Status',
    DETAILLEI_EXCEPTIONCATEGORY: 'Kategorie',
    DETAILLEI_EXCEPTIONREASON: 'Důvod nezveřejnění',
    DIRECT_ACCOUNTING_CONSOLIDATION_PARENT: 'Přímá mateřská společnost',
    ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT: 'Ultimátní mateřská společnost',
    LEI_STATUS_ACTIVE: 'Active',
    LEI_STATUS_INACTIVE: 'Inactive',
    LEI_SEZNAM_VYBRANYCH: 'Seznam vybraných LEI',
    HISTORIE_VYDANNYCH_LEI: 'Historie vydaných seznamů LEI',
    UDAJE_DRZITEL_LEI: 'Údaje o držiteli LEI',
    REG_UDAJE_LEI: 'Registrační údaje LEI',
    LEI_MATKY_INFO: 'Informace o mateřských společnostech',
    INFO_LEI_FOND: 'Informace o fondech',
    INFO_LEI_BRANCH: 'Informace o branch',
    REF_DATA_LEI: 'Referenční data LEI',
    UDAJE_K_DATU: 'Údaje jsou aktuálni k',
    IS_DIRECTLY_CONSOLIDATED_BY: 'Přímá mateřská společnost',
    IS_ULTIMATELY_CONSOLIDATED_BY: 'Ultimátní mateřská společnost',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    LAPSED: 'Lapsed',
    MERGED: 'Merged',
    RETIRED: 'Retired',
    ANNULLED: 'Annulled',
    CANCELLED: 'Cancelled',
    TRANSFERRED: 'Transferred',
    PENDING_TRANSFER: 'Pending transfer',
    PENDING_ARCHIVAL: 'Pending archival',
    PENDING_VALIDATION: 'Nevedený',
    ISSUED: 'Issued',
    SLUZBA_ODKAZ: 'Odkaz na službu',
    IS_SUBFUND_OF: 'Zastřešující investiční fond (Umbrella structure)',
    IS_FEEDER_TO: 'Nadřazený investiční fond (Master-Feeder structure)',
    IS_FUND_MANAGED_BY: 'Investiční společnost (Obhospodařovatel fondu)',
    POPIS_SLUBY_TITLE: 'Vyhledávání v seznamu již přidělených LEI',
    POPIS_SLUBY_TEXT_NZ:
        'Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní či adresní údaje a zapsat nebo změnit číslo bankovního účtu pro účely výplat výnosů. Vyplněné adresní údaje budou zapsány i jako údaje o doručovací adrese.',
    POPIS_SLUBY_TEXT:
        'Stránka nabízí možnost vyhledávání v seznamu subjektů, jimž Centrální depozitář dosud přidělil LEI. Vyhledávat lze podle LEI, IČ a názvu společnosti.',
    POPIS_SLUZBY: 'Popis služby',
    POCET_CP_PPN: 'Počet  CP s PPN',
    DFP_UCET_ERR: 'Prosím vyplňte alespoň jeden účet',
    NO_LEI: 'žádné lei',
    PXKLIC_LOGIN_POPUPL: 'Přihlášení potvrďte prostřednictvím aplikace bold(PX Klíč).',
    LEI_PLATNOST_OMEZENA: 'Omezená platnost',
    LEI_PLATNOST_OMEZENA_ERR: 'Prosím doplňte chybějící údaje o souboru',
    PW_STRENGTH_TOO_WEAK: 'Příliš slabé',
    PW_STRENGTH_WEAK: 'Slabé',
    PW_STRENGTH_MODERATE: 'Střední',
    PW_STRENGTH_STRONG: 'Silné',
    PW_STRENGTH_VERY_STRONG: 'Velmi silné',
    PW_CHECKING: 'Kontrola hesla proti známým únikům...',
    PW_CHECK_FAIL: '⚠️ Toto heslo se objevilo v známých únicích dat. Zvolte si bezpečnější.',
    PW_CHECK_SUCCESS: '✅ Toto heslo nebylo nalezeno v žádných známých únicích.',
    POCETCP_ZNIZENI_ERR: 'Počet musí být nižší než počet kusů před snížením',
    CZK: 'Česká koruna',
    EUR: 'Euro',
    ISIN_JINA_JURISDIKCE: 'ISIN jiné jurisdikce',
    ISIN_REGISTRACE_SOUBOR_VYPISOR: 'Výpis z obchodního rejstříku',
    ISIN_REGISTRACE_SOUBOR_EMISNIPODMINKY: 'Emisní podmínky',
    ISIN_REGISTRACE_SOUBOR_POTVRZENIISIN: 'Potvrzení o přidělení ISIN',
    ISIN_REGISTRACE_SOUBOR_JINY: 'Jiny dokument',
    ISIN_SK_VALIDATION_ERR: 'Registrace vyžaduje isin začínající SK',
    LENGTH_VALIDATION_ERR: 'Délka pole musí být přesně {{x}} znaků',
    VALIDATION_LETTERS_ONLY_ERR: 'hodnota může obsahovat pouze písmena',
    JINA_OSOBA_ZASTUPUJE: 'Jinou osobu zastupuje',
    DATOVA_SCHRANKA: 'Datová schránka',
    DATOVA_SCHRANKA_ERR: 'Neplatná datová schránka',
    INVALID_ICO_NID: 'Nevalidní NID nebo IČO',
    CRS_OSOBA: 'Typ ovládající osoby',
    CRS_OSOBA_CRS801: 'Ovládající osoba právnické osoby - kontrola vlastnictvím',
    CRS_OSOBA_CRS802: 'Ovládající osoba právnické osoby - kontrola jiným způsobem',
    CRS_OSOBA_CRS803: 'Ovládající osoba právnické osoby - člen nejvyššího vedení',
    CRS_OSOBA_CRS804: 'Zakladatel trustu (Settlor)',
    CRS_OSOBA_CRS805: 'Svěřenecký správce trustu (Trustee)',
    CRS_OSOBA_CRS806: 'Ochránce trustu (Protector)',
    CRS_OSOBA_CRS807: 'Příjemce trustu (Beneficiary)',
    CRS_OSOBA_CRS808: 'Jiná ovládající osoba trustu',
    CRS_OSOBA_CRS809: 'Ekvivalent zakladatele',
    CRS_OSOBA_CRS810: 'Ekvivalent svěřeneckého správce',
    CRS_OSOBA_CRS811: 'Ekvivalent ochránce',
    CRS_OSOBA_CRS812: 'Ekvivalent příjemce',
    CRS_OSOBA_CRS813: 'Jiný ekvivalent ovládající osoby',
    CRS_DIC_TOOLTIP:
        'DIČ/TIN (Taxpayer Identification Number) = daňové identifikační číslo přidělené daňovou správou ve státě daňové rezidence, které slouží k identifikaci osoby/entity pro daňové účely; uvádí se pro každý stát daňové rezidence.',
    CRS_STAT_TAX: 'Stát daňové rezidence právnické osoby',
    CRS_STAT_TAX_OSOBY: 'Stát daňové rezidence ovládající osoby',
    CRS_OSOBY: 'Ovládající osoby',
    CRS_OSOBY_CR: 'Všechny ovládající osoby mají daňovou rezidenci v ČR',
    CRS_STATUS: 'Status entity dle CRS',
    CRS_STATUS_STS1A:
        '1a) Investiční subjekt nacházející se v neúčastnící se jurisdikci a spravovaný jinou finanční institucí',
    CRS_STATUS_STS1B: '1b) Jiný investiční subjekt',
    CRS_STATUS_STS2: '2) Finanční instituce - vkladová instituce, svěřenecká instituce nebo určená pojišťovna',
    CRS_STATUS_STS3A: '3a) Nefinanční entita, jejíž akcie jsou pravidelně obchodovány na zavedeném trhu cenných papírů',
    CRS_STATUS_STS3B:
        '3b) Nefinanční entita propojená s entitou, jejíž akce jsou pravidelně obchodovány na zavedeném trhu cenných papírů',
    CRS_STATUS_STS3C: '3c) Státní subjekt nebo centrální banka',
    CRS_STATUS_STS3D: '3d) Mezinárodní organizace',
    CRS_STATUS_STS3E: '3e) Jiný aktivní nefinanční subjekt - jiný, než bod 3 a) - d)',
    CRS_STATUS_STS4: '4) Pasivní nefinanční subjekt',

    CRS_STATUS_1_INFO: '1. Finanční instituce – investiční subjekt',
    CRS_STATUS_1A_INFO_TITLE: 'a) Investiční subjekt v neúčastnící se jurisdikci a spravovaný jinou finanční institucí',
    CRS_STATUS_1A_INFO:
        'Zvolte, pokud je subjekt investiční (tj. jeho činnost/příjmy jsou převážně z investování, reinvestování nebo obchodování s finančními aktivy, případně správy portfolia), země daňové rezidence je v bold(neúčastnící) se jurisdikci a bold(je spravovaný jinou finanční institucí).',
    CRS_STATUS_1B_INFO_TITLE: 'b) Jiný investiční subjekt',
    CRS_STATUS_1B_INFO:
        'Zvolte, pokud je subjekt investiční (tj. jeho činnost/příjmy jsou převážně z investování, reinvestování nebo obchodování s finančními aktivy, případně správy portfolia), země daňové rezidence je v bold(účastnící) se jurisdikci.',
    CRS_STATUS_2_INFO_TITLE: '2. Finanční instituce – vkladová instituce, svěřenecká instituce nebo určená pojišťovna',
    CRS_STATUS_2_INFO:
        'Zvolte, pokud přijímáte vklady, vedete vkladové účty, držíte cenné papíry klientů v úschově, děláte custody, jste banka, depozitář, pojišťovna',
    CRS_STATUS_3_INFO: '3. Aktivní nefinanční entita',
    CRS_STATUS_3B_INFO_TITLE:
        'b) Nefinanční entita propojená s entitou, jejíž akce jsou pravidelně obchodovány na zavedeném trhu cenných papírů',
    CRS_STATUS_3B_INFO: 'Zvolte, pokud je propojení více než 50%',
    CRS_STATUS_3E_TITLE: 'e) Jiný aktivní nefinanční subjekt – jiný, než bod 3 a) – d)',
    CRS_STATUS_3E_INFO:
        'Zvolte, pokud méně než 50 % hrubého příjmu nefinančního subjektu za předcházející kalendářní rok nebo jiné odpovídající vykazované období představuje pasivní příjem a méně než 50 % majetku drženého nefinančním subjektem během předcházejícího kalendářního roku nebo jiného vykazovaného období představuje majetek, který vytváří pasivní příjem nebo který je držen za účelem jeho vzniku.',
    CRS_STATUS_4_INFO_TITLE: '4. Pasivní nefinanční subjekt',
    CRS_STATUS_4_INFO:
        'Zvolte, pokud jste subjekt, který má převážně „pasivní“ příjmy a aktiva (typicky investiční výnosy, úroky, dividendy, výnosy z nájmů) a nesplňujete podmínky pro aktivní nefinanční subjekt.  Více než 50 % hrubého příjmu představuje pasivní příjem.',
    CRS_STATUS_INFO_BLIZSIE: 'Bližší informace: Příloha č. 1 bod D k zákonu č. 164/2013 Sb. v platném znění',
    CRS_OSOBA_BYDLISTE_DAN_INFO1: 'Vyplňte všechny země, kde je ovládající osoba daňovým rezidentem.',
    CRS_OSOBA_BYDLISTE_DAN_INFO2:
        'Pokud uvedete jinou zemi než Českou republiku, musíte uvést DIČ nebo důvod, proč je nemá.',
    CRS_NEVYPLNENI_DIC_DUVOD: 'Důvod nevyplnění DIČ',
    CRS_OSOBA_DIC_ERR: 'Vyplňte DIC nebo důvod nevyplnění DIC',
    CRS_DOTAZNIK_PROHLASENI: 'PROHLÁŠENÍ',
    CRS_DOTAZNIK_PROHLASENI_TEXT1:
        '1. Prohlašuji, že všechny údaje uvedené v tomto formuláři jsou podle mého nejlepšího vědomí a svědomí pravdivé a úplné.',
    CRS_DOTAZNIK_PROHLASENI_TEXT2:
        '2. Beru na vědomí, že poskytnuté údaje mohou být oznámeny finančnímu úřadu, který je může poskytovat daňovým úřadům země, v nichž je majitel účtu daňovým rezidentem.',
    CRS_DOTAZNIK_PROHLASENI_TEXT3:
        '3. Prohlašuji, že jsem oprávněn(a) jednat a podepsat tento formulář jménem vlastníka účtu, případně jménem ovládající osoby, pokud je to relevantní, a že ovládající osoby budu informovat o poskytnutí jejich údajů společnosti CDCP a o možnosti jejich předání Specializovanému finančnímu úřadu.',
    CRS_DOTAZNIK_PROHLASENI_TEXT4: '4. Zavazuji se oznámit CDCP změnu poskytnutých údajů do 30 dnů.',
    CRS_DOTAZNIK_PROHLASENI_SOUHLAS: 'Souhlasím s prohlášením',
    CRS_STAV_ROZP: 'Rozpracovaný',
    CRS_STAV_ZPRAC: 'Zpracováno',
    CRS_STAV_ZRUS: 'Zrušeno',
    CRS_DICDUVOD_A: 'Země, kde vlastník účtu platí daň z příjmu jako rezident, nevydává daňová identifikační čísla',
    CRS_DICDUVOD_B:
        'Vlastník účtu není z jiného důvodu schopen získat daňové identifikační číslo nebo odpovídající číslo',
    CRS_DICDUVOD_C: 'Daňové identifikační číslo není nutné',
    DOTAZNIK_CRS: 'Dotazník CRS',
    DOTAZNIK_CRS_404: 'Není vedeno žádné CRS',
    CRS_NOVE: 'Nové CRS',
    CRS_AKTUALIZACE: 'Aktualizovat CRS',
    CRS_HISTORIE: 'Historie CRS',
    POCET_CP_VYPORADANYCH: 'Počet CP vypořádaných',
    POCET_CP_NEVYPORADANYCH: 'Počet CP nevypořádaných',
    CRS_AML_ERR: 'Pro přístup k AML musíte nejprve vyplnit dotazník CRS.',
    CDCP_LONG: 'Centrální evidence CDCP',
    DLT_LONG: 'DLT evidence',
    CRS_GIIN: 'Vyplňte číslo GIIN pokud bylo přiděleno',
    CRS_GIIN_TOOLTIP: 'Číslo GIIN vyplňte ve formátu XXXXXX.XXXXX.XX.XXX',
    CRS_DIC_CZ_VALIDATION: 'DIČ musí začínat prefixem „CZ“, pokud je stát Česká republika.',
    CRS_OSOBY_ADRESA_ALT: 'Doručovací adresa je jiná od adresy trvalého pobytu',
    UEN_TITLE: 'PX Veřejná nabídka',
    PRODAVAJICI: 'Převodce',
    KUPUJICI: 'Nabyvatel',
    NAZEV_JMENO: 'Název/jméno',
    PRODVAJICI_JMENO: 'Převodce Název/jméno',
    KUPUJICI_JMENO: 'Nabyvatel Název/jméno',
    PRODVAJICI_UCET: 'Převodce Číslo majetkového účtu',
    KUPUJICI_UCET: 'Nabyvatel Číslo majetkového účtu',
    OM_STAV_ROZPRACOVANY: 'Rozpracovaný',
    OM_STAV_DOPL: 'Čeká na doplnění',
    OM_STAV_KDOPLNENI: 'K doplnění',
    OM_STAV_AUTKONTROLA: 'Probíhá automatická kontrola',
    OM_STAV_AUTKONTROLAPRED: 'Probíhá automatická kontrola',
    OM_STAV_CDCPKEKONTR: 'Čeká na kontrolu',
    OM_STAV_CDCPKEKONTRPRED: 'Čeká na předběžnou kontrolu',
    OM_STAV_CDCPKONTR: 'Kontrola probíhá',
    OM_STAV_CDCPKONTRPRED: 'Předběžná kontrola probíhá',
    OM_STAV_KPODPISU: 'K podpisu',
    OM_STAV_PODEPSANO: 'Podepsáno',
    OM_STAV_HOTOVOIIS: 'Odesláno do IIS',
    OM_STAV_ZAMITNUTO: 'Zamítnuto',
    OM_STAV_ZPRACOVANO: 'Zpracováno',
    OM_STAV_ZKONTROLOVANO: 'Zkontrolováno (Předběžný přístup)',
    OM_STAV_AKCEPTOVANO: 'Ověřeno',
    OM_STAV_ZRUSENO: 'Zrušeno',
    OM_POZADAVEK_KEKONTROLE: 'Ke kontrole',
    OM_POZADAVEK_ODSOUHLAS: 'Odsouhlasen',
    OM_POZADAVEK_ZAMITNUT: 'Zamítnut',
    OM_POZADAVEK_EXPIROVAL: 'Expiroval',
    OM_TITLE: 'Omezená převoditelnost',
    OM_ODSOUHLASIT: 'Odsouhlasit',
    OM_ODSOUHLASIT_TEXT: 'Opravdu si přejete dát souhlas s převodem emise s omezenou převoditelností?',
    OM_ZAMITNOUT: 'Zamítnout',
    OM_ZAMITNOUT_TEXT: 'Opravdu si přejete odmítnout převod emise s omezenou převoditelností?',
    OM_POCET_CP: 'Počet cenných papírů',
    OM_ROZHODNUTI_SOUHLAS: 'Souhlasí',
    OM_ROZHODNUTI_NESOUHLAS: 'Nesouhlasí',
    OM_ROZHODNUTI_VYJADRENI: 'Prohlášení emitenta',
    PRIKAZ: 'Příkaz',
    OM_PRIKAZ_SOUHLAS1:
        'Emitent tímto uděluje souhlas s převodem výše uvedeného počtu zaknihovaných akcií z uvedeného převodce na uvedeného nabyvatele. Emitent současně potvrzuje, že před udělením tohoto souhlasu posoudil splnění podmínek převodu stanovených právními předpisy a stanovami společnosti v rozsahu relevantním pro omezení převoditelnosti těchto akcií a že podle jeho posouzení byly tyto podmínky splněny. Byl-li souhlas s převodem udělen příslušným orgánem společnosti, emitent potvrzuje, že tento orgán souhlas udělil v souladu se stanovami společnosti.',
    OM_PRIKAZ_SOUHLAS2:
        'Emitent bere na vědomí, že odpovědnost za posouzení splnění uvedených podmínek nese emitent a že Centrální depozitář cenných papírů, a.s., není tímto prohlášením pověřen k jejich přezkoumávání.',

    // LOGINLESS LEI
    LEI_SEARCH_TITLE: 'Vyhledávání LEI kódů',
    LEI_SEARCH_SUBTITLE: 'Ověřte LEI, IČO nebo název společnosti během několika sekund.',
    LEI_SEARCH_INPUT_PLACEHOLDER: 'Zadejte LEI, IČO nebo název společnosti',
    LEI_SEARCH_BTN: 'Vyhledat',
    LEI_SEARCH_CLEAR_FILTERS: 'Vymazat filtry',
    LEI_SEARCH_FILTER_JURISDICTION: 'Jurisdikce',
    LEI_SEARCH_FILTER_CATEGORY: 'Kategorie',
    LEI_SEARCH_FILTER_STATUS: 'Stav LEI',
    LEI_SEARCH_RESULTS_TITLE: 'Výsledky vyhledávání',
    LEI_SEARCH_FOUND: 'Nalezeno',
    LEI_SEARCH_RESULT_ONE: 'výsledek',
    LEI_SEARCH_RESULT_FEW: 'výsledky',
    LEI_SEARCH_RESULT_MANY: 'výsledků',
    LEI_SEARCH_NO_RESULTS: 'Nebyly nalezeny žádné záznamy.',
    LEI_SEARCH_ERROR: 'Vyhledávání se nepodařilo dokončit. Zkuste to prosím znovu.',
    LEI_SEARCH_LIMIT_HINT: 'Zobrazeno je prvních 10 000 výsledků. Upřesněte hledání pomocí filtrů.',
    LEI_SEARCH_COL_LEI: 'LEI',
    LEI_SEARCH_COL_NAME: 'Název společnosti',
    LEI_SEARCH_COL_ICO: 'IČO',
    LEI_SEARCH_COL_COUNTRY: 'Země',
    LEI_SEARCH_COL_STATUS: 'Stav LEI',
    LEI_SEARCH_COL_RENEWAL: 'Datum příští obnovy',
    LEI_SEARCH_COL_ACTION: 'Akce',
    LEI_SEARCH_ACTION_DETAIL: 'Zobrazit detail',
    LEI_SEARCH_ACTION_OBNOVA: 'Obnova LEI',
    LEI_SEARCH_ACTION_PREVOD: 'Převod LEI',
    LEI_SEARCH_PAGE_SIZE: 'Zobrazit na stránce',
    LEI_SEARCH_RANGE_OF: 'z',
    LEI_STATUS_ISSUED: 'Aktivní',
    LEI_STATUS_LAPSED: 'Po platnosti',
    LEI_STATUS_MERGED: 'Sloučená',
    LEI_STATUS_RETIRED: 'Ukončená',
    LEI_STATUS_DUPLICATE: 'Duplicitní',
    LEI_STATUS_ANNULLED: 'Anulovaná',
    LEI_STATUS_CANCELLED: 'Zrušená',
    LEI_STATUS_TRANSFERRED: 'Převedená',
    LEI_STATUS_PENDING_TRANSFER: 'Probíhá převod',
    LEI_STATUS_PENDING_ARCHIVAL: 'Čeká na archivaci',
    LEI_CATEGORY_GENERAL: 'Ostatní',
    LEI_CATEGORY_BRANCH: 'Odštěpný závod',
    LEI_CATEGORY_FUND: 'Fond',
    LEI_CATEGORY_SOLE_PROPRIETOR: 'Podnikající fyzická osoba',
    LEI_CATEGORY_RESIDENT_GOVERNMENT_ENTITY: 'Subjekt státní správy',
    LEI_CATEGORY_INTERNATIONAL_ORGANIZATION: 'Mezinárodní organizace'
};
